//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.1.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

import * as moment from "moment";

export const API_BASE_URL = new InjectionToken<string>("API_BASE_URL");

@Injectable()
export class AccountServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  isTenantAvailable(
    body: IsTenantAvailableInput | undefined,
  ): Observable<IsTenantAvailableOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsTenantAvailable(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsTenantAvailable(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<IsTenantAvailableOutput>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<IsTenantAvailableOutput>;
        }),
      );
  }

  protected processIsTenantAvailable(
    response: HttpResponseBase,
  ): Observable<IsTenantAvailableOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IsTenantAvailableOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  register(body: RegisterInput | undefined): Observable<RegisterOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/Register";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRegister(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRegister(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RegisterOutput>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<RegisterOutput>;
        }),
      );
  }

  protected processRegister(
    response: HttpResponseBase,
  ): Observable<RegisterOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RegisterOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ConfigurationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeUiTheme(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeUiTheme(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class RoleServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateRoleDto | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<RoleDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param permission (optional)
   * @return Success
   */
  getRoles(
    permission: string | undefined,
  ): Observable<RoleListDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
    if (permission === null)
      throw new Error("The parameter 'permission' cannot be null.");
    else if (permission !== undefined)
      url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoles(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoles(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<RoleListDtoListResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<RoleListDtoListResultDto>;
        }),
      );
  }

  protected processGetRoles(
    response: HttpResponseBase,
  ): Observable<RoleListDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleListDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: RoleDto | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<RoleDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAllPermissions(): Observable<PermissionDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPermissions(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPermissions(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<PermissionDtoListResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<PermissionDtoListResultDto>;
        }),
      );
  }

  protected processGetAllPermissions(
    response: HttpResponseBase,
  ): Observable<PermissionDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PermissionDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoleForEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoleForEdit(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<GetRoleForEditOutput>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<GetRoleForEditOutput>;
        }),
      );
  }

  protected processGetRoleForEdit(
    response: HttpResponseBase,
  ): Observable<GetRoleForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetRoleForEditOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<RoleDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<RoleDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<RoleDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<RoleDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<RoleDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class SessionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
    let url_ =
      this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentLoginInformations(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentLoginInformations(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<GetCurrentLoginInformationsOutput>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<GetCurrentLoginInformationsOutput>;
        }),
      );
  }

  protected processGetCurrentLoginInformations(
    response: HttpResponseBase,
  ): Observable<GetCurrentLoginInformationsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class TenantServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateTenantDto | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TenantDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TenantDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    isActive: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<TenantDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<TenantDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<TenantDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<TenantDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: TenantDto | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TenantDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class TokenAuthServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  authenticate(
    body: AuthenticateModel | undefined,
  ): Observable<AuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthenticate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthenticate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AuthenticateResultModel>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AuthenticateResultModel>;
        }),
      );
  }

  otpAuthenticate(
    body: OtpAuthenticateModel | undefined,
  ): Observable<AuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/OtpAuthenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthenticate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthenticate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AuthenticateResultModel>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AuthenticateResultModel>;
        }),
      );
  }

  protected processAuthenticate(
    response: HttpResponseBase,
  ): Observable<AuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AuthenticateResultModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getExternalAuthenticationProviders(): Observable<
    ExternalLoginProviderInfoModel[]
  > {
    let url_ =
      this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetExternalAuthenticationProviders(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetExternalAuthenticationProviders(
                response_ as any,
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                ExternalLoginProviderInfoModel[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ExternalLoginProviderInfoModel[]
            >;
        }),
      );
  }

  getOtp(username: string): Observable<boolean> {
    if (username == null || username == "") {
      throw new Error("The parameter 'username' cannot be null or empty.");
    }
    let url_ =
      this.baseUrl + "/api/services/app/User/GetOtp?UserName=" + username;
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOtp(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOtp(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processGetExternalAuthenticationProviders(
    response: HttpResponseBase,
  ): Observable<ExternalLoginProviderInfoModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200.push(ExternalLoginProviderInfoModel.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  protected processGetOtp(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  externalAuthenticate(
    body: ExternalAuthenticateModel | undefined,
  ): Observable<ExternalAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processExternalAuthenticate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processExternalAuthenticate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ExternalAuthenticateResultModel>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ExternalAuthenticateResultModel>;
        }),
      );
  }

  protected processExternalAuthenticate(
    response: HttpResponseBase,
  ): Observable<ExternalAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class UserServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateUserDto | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + "/api/services/app/User/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<UserDto>;
        }),
      );
  }

  createCustomer(body: CreateUserDto | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + "/api/services/app/User/CreateCustomer";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<UserDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: UserDto | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + "/api/services/app/User/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<UserDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  activate(body: Int64EntityDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/Activate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processActivate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  deActivate(body: Int64EntityDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeActivate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeActivate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeActivate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getRoles(): Observable<RoleDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoles(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoles(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<RoleDtoListResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<RoleDtoListResultDto>;
        }),
      );
  }

  protected processGetRoles(
    response: HttpResponseBase,
  ): Observable<RoleDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeLanguage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeLanguage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processChangeLanguage(
    response: HttpResponseBase,
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processChangePassword(
    response: HttpResponseBase,
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processResetPassword(
    response: HttpResponseBase,
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + "/api/services/app/User/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<UserDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    isActive: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<UserDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<UserDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<UserDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<UserDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllCustomer(
    keyword: string | undefined,
    isActive: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<UserDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetAllCustomer?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllCustomer(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllCustomer(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<UserDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<UserDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllCustomer(
    response: HttpResponseBase,
  ): Observable<UserDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getAllCustomers(
    keyword: string | undefined,
    isActive: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<UserDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetAllCustomers?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<UserDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<UserDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllCustomers(
    response: HttpResponseBase,
  ): Observable<UserDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllExperts(
    keyword: string | undefined,
    isActive: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<UserDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetAllExperts?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<UserDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<UserDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllExperts(
    response: HttpResponseBase,
  ): Observable<UserDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getUserProfileImage(userId: number | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/services/app/User/GetUserProfileImage?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";

    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserProfileImage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserProfileImage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else
            return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processGetUserProfileImage(
    response: HttpResponseBase,
  ): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText == ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AdministrationServiceServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  checkReminders(): Observable<void> {
    let url_ =
      this.baseUrl + "/api/services/app/AdministrationService/CheckReminders";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckReminders(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckReminders(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCheckReminders(
    response: HttpResponseBase,
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  checkMails(): Observable<void> {
    let url_ =
      this.baseUrl + "/api/services/app/AdministrationService/CheckMails";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckMails(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckMails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCheckMails(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  checkSmss(): Observable<void> {
    let url_ =
      this.baseUrl + "/api/services/app/AdministrationService/CheckSmss";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckSmss(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckSmss(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCheckSmss(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userId (optional)
   * @param mailBoxType (optional)
   * @param keyword (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getEmails(
    userId: number | undefined,
    mailBoxType: MailBoxType | undefined,
    keyword: string | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<EmailInfoDtoMailPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/AdministrationService/GetEmails?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
    if (mailBoxType === null)
      throw new Error("The parameter 'mailBoxType' cannot be null.");
    else if (mailBoxType !== undefined)
      url_ += "MailBoxType=" + encodeURIComponent("" + mailBoxType) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEmails(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEmails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EmailInfoDtoMailPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EmailInfoDtoMailPagedResultDto>;
        }),
      );
  }

  protected processGetEmails(
    response: HttpResponseBase,
  ): Observable<EmailInfoDtoMailPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailInfoDtoMailPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param uniqueId (optional)
   * @param userId (optional)
   * @return Success
   */
  getEmailDetail(
    uniqueId: string | undefined,
    userId: number | undefined,
  ): Observable<EmailDetailDto> {
    let url_ =
      this.baseUrl + "/api/services/app/AdministrationService/GetEmailDetail?";
    if (uniqueId === null)
      throw new Error("The parameter 'uniqueId' cannot be null.");
    else if (uniqueId !== undefined)
      url_ += "UniqueId=" + encodeURIComponent("" + uniqueId) + "&";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEmailDetail(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEmailDetail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EmailDetailDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EmailDetailDto>;
        }),
      );
  }

  protected processGetEmailDetail(
    response: HttpResponseBase,
  ): Observable<EmailDetailDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailDetailDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param year (optional)
   * @param month (optional)
   * @return Success
   */
  getMonthCalendarInformation(
    year: number | undefined,
    month: number | undefined,
  ): Observable<MonthlyCalendarModel> {
    let url_ =
      this.baseUrl +
      "/api/services/app/AdministrationService/GetMonthCalendarInformation?";
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += "Year=" + encodeURIComponent("" + year) + "&";
    if (month === null)
      throw new Error("The parameter 'month' cannot be null.");
    else if (month !== undefined)
      url_ += "Month=" + encodeURIComponent("" + month) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMonthCalendarInformation(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMonthCalendarInformation(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<MonthlyCalendarModel>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MonthlyCalendarModel>;
        }),
      );
  }

  protected processGetMonthCalendarInformation(
    response: HttpResponseBase,
  ): Observable<MonthlyCalendarModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MonthlyCalendarModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param format (optional)
   * @param addDays (optional)
   * @param addMonths (optional)
   * @param addYears (optional)
   * @param addHours (optional)
   * @param onlyDate (optional)
   * @return Success
   */
  getDate(
    format: string | undefined,
    addDays: number | undefined,
    addMonths: number | undefined,
    addYears: number | undefined,
    addHours: number | undefined,
    onlyDate: boolean | undefined,
  ): Observable<GetDateModel> {
    let url_ =
      this.baseUrl + "/api/services/app/AdministrationService/GetDate?";
    if (format === null)
      throw new Error("The parameter 'format' cannot be null.");
    else if (format !== undefined)
      url_ += "Format=" + encodeURIComponent("" + format) + "&";
    if (addDays === null)
      throw new Error("The parameter 'addDays' cannot be null.");
    else if (addDays !== undefined)
      url_ += "AddDays=" + encodeURIComponent("" + addDays) + "&";
    if (addMonths === null)
      throw new Error("The parameter 'addMonths' cannot be null.");
    else if (addMonths !== undefined)
      url_ += "AddMonths=" + encodeURIComponent("" + addMonths) + "&";
    if (addYears === null)
      throw new Error("The parameter 'addYears' cannot be null.");
    else if (addYears !== undefined)
      url_ += "AddYears=" + encodeURIComponent("" + addYears) + "&";
    if (addHours === null)
      throw new Error("The parameter 'addHours' cannot be null.");
    else if (addHours !== undefined)
      url_ += "AddHours=" + encodeURIComponent("" + addHours) + "&";
    if (onlyDate === null)
      throw new Error("The parameter 'onlyDate' cannot be null.");
    else if (onlyDate !== undefined)
      url_ += "OnlyDate=" + encodeURIComponent("" + onlyDate) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetDateModel>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<GetDateModel>;
        }),
      );
  }

  protected processGetDate(
    response: HttpResponseBase,
  ): Observable<GetDateModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetDateModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<AdministrationDto> {
    let url_ = this.baseUrl + "/api/services/app/AdministrationService/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AdministrationDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AdministrationDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<AdministrationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AdministrationDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<AdministrationDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/AdministrationService/GetAll?";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AdministrationDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AdministrationDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<AdministrationDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AdministrationDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: AdministrationDto | undefined): Observable<AdministrationDto> {
    let url_ = this.baseUrl + "/api/services/app/AdministrationService/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AdministrationDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AdministrationDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<AdministrationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AdministrationDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: AdministrationDto | undefined): Observable<AdministrationDto> {
    let url_ = this.baseUrl + "/api/services/app/AdministrationService/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AdministrationDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AdministrationDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<AdministrationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AdministrationDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/AdministrationService/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ReferrerServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllReferrers(): Observable<string[]> {
    let url_ = this.baseUrl + "/api/services/app/Referrer/GetAllReferrers";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllReferrers(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllReferrers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<string[]>;
        }),
      );
  }

  protected processGetAllReferrers(
    response: HttpResponseBase,
  ): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<ReferrerDto> {
    let url_ = this.baseUrl + "/api/services/app/Referrer/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReferrerDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ReferrerDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ReferrerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReferrerDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ReferrerDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Referrer/GetAll?";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ReferrerDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ReferrerDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<ReferrerDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReferrerDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: ReferrerDto | undefined): Observable<ReferrerDto> {
    let url_ = this.baseUrl + "/api/services/app/Referrer/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReferrerDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ReferrerDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<ReferrerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReferrerDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: ReferrerDto | undefined): Observable<ReferrerDto> {
    let url_ = this.baseUrl + "/api/services/app/Referrer/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReferrerDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ReferrerDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<ReferrerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReferrerDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Referrer/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AwarenessSourceServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<AwarenessSourceDto> {
    let url_ = this.baseUrl + "/api/services/app/AwarenessSource/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AwarenessSourceDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AwarenessSourceDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<AwarenessSourceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AwarenessSourceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<AwarenessSourceDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/AwarenessSource/GetAll?";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AwarenessSourceDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AwarenessSourceDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<AwarenessSourceDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AwarenessSourceDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: AwarenessSourceDto | undefined): Observable<AwarenessSourceDto> {
    let url_ = this.baseUrl + "/api/services/app/AwarenessSource/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AwarenessSourceDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AwarenessSourceDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<AwarenessSourceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AwarenessSourceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: AwarenessSourceDto | undefined): Observable<AwarenessSourceDto> {
    let url_ = this.baseUrl + "/api/services/app/AwarenessSource/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AwarenessSourceDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AwarenessSourceDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<AwarenessSourceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AwarenessSourceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/AwarenessSource/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  activate(id: number | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/AwarenessSource/Activate?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processActivate(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deActivate(id: number | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/AwarenessSource/DeActivate?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeActivate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeActivate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processDeActivate(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class TagServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllTags(): Observable<string[]> {
    let url_ = this.baseUrl + "/api/services/app/Tag/GetAllTags";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllTags(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllTags(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<string[]>;
        }),
      );
  }

  protected processGetAllTags(
    response: HttpResponseBase,
  ): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<TagDto> {
    let url_ = this.baseUrl + "/api/services/app/Tag/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TagDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TagDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<TagDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TagDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<TagDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Tag/GetAll?";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<TagDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<TagDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<TagDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TagDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: TagDto | undefined): Observable<TagDto> {
    let url_ = this.baseUrl + "/api/services/app/Tag/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TagDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TagDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<TagDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TagDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: TagDto | undefined): Observable<TagDto> {
    let url_ = this.baseUrl + "/api/services/app/Tag/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TagDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TagDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<TagDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TagDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tag/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export interface EventViewModel {
  id: number;
  title: string;
  relatedUserName: string;
  date: string;
}

export class AwarenessSourceDto implements IAwarenessSourceDto {
  id: number;
  title: string | undefined;
  code: number;
  isActive: boolean;

  constructor(data?: IAwarenessSourceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      this.code = _data["code"];
      this.isActive = _data["isActive"];
    }
  }

  static fromJS(data: any): AwarenessSourceDto {
    data = typeof data === "object" ? data : {};
    let result = new AwarenessSourceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    data["code"] = this.code;
    data["isActive"] = this.isActive;
    return data;
  }

  clone(): AwarenessSourceDto {
    const json = this.toJSON();
    let result = new AwarenessSourceDto();
    result.init(json);
    return result;
  }
}

export interface IAwarenessSourceDto {
  id: number;
  title: string | undefined;
  code: number;
  isActive: boolean;
}

export class AwarenessSourceDtoPagedResultDto implements IAwarenessSourceDtoPagedResultDto {
  items: AwarenessSourceDto[] | undefined;
  totalCount: number;

  constructor(data?: IAwarenessSourceDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(AwarenessSourceDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): AwarenessSourceDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new AwarenessSourceDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): AwarenessSourceDtoPagedResultDto {
    const json = this.toJSON();
    let result = new AwarenessSourceDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IAwarenessSourceDtoPagedResultDto {
  items: AwarenessSourceDto[] | undefined;
  totalCount: number;
}

export enum MailBoxType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export class RestResponse implements IRestResponse {
  value: string | undefined;
  retStatus: number;
  strRetStatus: string | undefined;

  constructor(data?: IRestResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.retStatus = _data["retStatus"];
      this.strRetStatus = _data["strRetStatus"];
    }
  }

  static fromJS(data: any): RestResponse {
    data = typeof data === "object" ? data : {};
    let result = new RestResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["value"] = this.value;
    data["retStatus"] = this.retStatus;
    data["strRetStatus"] = this.strRetStatus;
    return data;
  }

  clone(): RestResponse {
    const json = this.toJSON();
    let result = new RestResponse();
    result.init(json);
    return result;
  }
}

export interface IRestResponse {
  value: string | undefined;
  retStatus: number;
  strRetStatus: string | undefined;
}

export class EmailDetailDto implements IEmailDetailDto {
  body: string | undefined;
  bodyHtml: string | undefined;
  uniqueId: string | undefined;
  from: string | undefined;
  subject: string | undefined;
  sendTime: string | undefined;
  senderEmailAddr: string | undefined;
  attachements: FileModelDto[] | undefined;

  constructor(data?: IEmailDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.body = _data["body"];
      this.bodyHtml = _data["bodyHtml"];
      this.uniqueId = _data["uniqueId"];
      this.from = _data["from"];
      this.subject = _data["subject"];
      this.sendTime = _data["sendTime"];
      this.senderEmailAddr = _data["senderEmailAddr"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"])
          this.attachements.push(FileModelDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): EmailDetailDto {
    data = typeof data === "object" ? data : {};
    let result = new EmailDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["body"] = this.body;
    data["bodyHtml"] = this.bodyHtml;
    data["uniqueId"] = this.uniqueId;
    data["from"] = this.from;
    data["subject"] = this.subject;
    data["sendTime"] = this.sendTime;
    data["senderEmailAddr"] = this.senderEmailAddr;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements)
        data["attachements"].push(item.toJSON());
    }
    return data;
  }

  clone(): EmailDetailDto {
    const json = this.toJSON();
    let result = new EmailDetailDto();
    result.init(json);
    return result;
  }
}

export interface IEmailDetailDto {
  body: string | undefined;
  bodyHtml: string | undefined;
  uniqueId: string | undefined;
  from: string | undefined;
  subject: string | undefined;
  sendTime: string | undefined;
  senderEmailAddr: string | undefined;
  attachements: FileModelDto[] | undefined;
}

export class FileModelDto implements IFileModelDto {
  name: string | undefined;
  type: string | undefined;
  base64: string | undefined;
  index: number;

  constructor(data?: IFileModelDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.type = _data["type"];
      this.base64 = _data["base64"];
      this.index = _data["index"];
    }
  }

  static fromJS(data: any): FileModelDto {
    data = typeof data === "object" ? data : {};
    let result = new FileModelDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["type"] = this.type;
    data["base64"] = this.base64;
    data["index"] = this.index;
    return data;
  }

  clone(): FileModelDto {
    const json = this.toJSON();
    let result = new FileModelDto();
    result.init(json);
    return result;
  }
}

export interface IFileModelDto {
  name: string | undefined;
  type: string | undefined;
  base64: string | undefined;
  index: number;
}

export class EmailInfoDto implements IEmailInfoDto {
  sender: string | undefined;
  subject: string | undefined;
  emailId: string | undefined;
  sendTime: string | undefined;
  status: boolean;
  hasAttachement: boolean;

  constructor(data?: IEmailInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sender = _data["sender"];
      this.subject = _data["subject"];
      this.emailId = _data["emailId"];
      this.sendTime = _data["sendTime"];
      this.status = _data["status"];
      this.hasAttachement = _data["hasAttachement"];
    }
  }

  static fromJS(data: any): EmailInfoDto {
    data = typeof data === "object" ? data : {};
    let result = new EmailInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["sender"] = this.sender;
    data["subject"] = this.subject;
    data["emailId"] = this.emailId;
    data["sendTime"] = this.sendTime;
    data["status"] = this.status;
    data["hasAttachement"] = this.hasAttachement;
    return data;
  }

  clone(): EmailInfoDto {
    const json = this.toJSON();
    let result = new EmailInfoDto();
    result.init(json);
    return result;
  }
}

export interface IEmailInfoDto {
  sender: string | undefined;
  subject: string | undefined;
  emailId: string | undefined;
  sendTime: string | undefined;
  status: boolean;
  hasAttachement: boolean;
}

export class ReferrerDto implements IReferrerDto {
  id: number;
  title: string | undefined;

  constructor(data?: IReferrerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
    }
  }

  static fromJS(data: any): ReferrerDto {
    data = typeof data === "object" ? data : {};
    let result = new ReferrerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    return data;
  }

  clone(): ReferrerDto {
    const json = this.toJSON();
    let result = new ReferrerDto();
    result.init(json);
    return result;
  }
}

export interface IReferrerDto {
  id: number;
  title: string | undefined;
}

export class ReferrerDtoPagedResultDto implements IReferrerDtoPagedResultDto {
  items: ReferrerDto[] | undefined;
  totalCount: number;

  constructor(data?: IReferrerDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ReferrerDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ReferrerDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ReferrerDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): ReferrerDtoPagedResultDto {
    const json = this.toJSON();
    let result = new ReferrerDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IReferrerDtoPagedResultDto {
  items: ReferrerDto[] | undefined;
  totalCount: number;
}

export class GetDateModel implements IGetDateModel {
  date: moment.Moment;
  displayDate: string | undefined;
  dayOfWeek: string | undefined;

  constructor(data?: IGetDateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"]
        ? moment(_data["date"].toString())
        : <any>undefined;
      this.displayDate = _data["displayDate"];
      this.dayOfWeek = _data["dayOfWeek"];
    }
  }

  static fromJS(data: any): GetDateModel {
    data = typeof data === "object" ? data : {};
    let result = new GetDateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["displayDate"] = this.displayDate;
    data["dayOfWeek"] = this.dayOfWeek;
    return data;
  }

  clone(): GetDateModel {
    const json = this.toJSON();
    let result = new GetDateModel();
    result.init(json);
    return result;
  }
}

export interface IGetDateModel {
  date: moment.Moment;
  displayDate: string | undefined;
  dayOfWeek: string | undefined;
}
export class EmailInfoDtoMailPagedResultDto implements IEmailInfoDtoMailPagedResultDto {
  items: EmailInfoDto[] | undefined;
  totalCount: number;
  unreadCount: number;
  mailAddr: string | undefined;

  constructor(data?: IEmailInfoDtoMailPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(EmailInfoDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
      this.unreadCount = _data["unreadCount"];
      this.mailAddr = _data["mailAddr"];
    }
  }

  static fromJS(data: any): EmailInfoDtoMailPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new EmailInfoDtoMailPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    data["unreadCount"] = this.unreadCount;
    data["mailAddr"] = this.mailAddr;
    return data;
  }

  clone(): EmailInfoDtoMailPagedResultDto {
    const json = this.toJSON();
    let result = new EmailInfoDtoMailPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IEmailInfoDtoMailPagedResultDto {
  items: EmailInfoDto[] | undefined;
  totalCount: number;
  unreadCount: number;
  mailAddr: string | undefined;
}

export class AdministrationDtoPagedResultDto implements IAdministrationDtoPagedResultDto {
  items: AdministrationDto[] | undefined;
  totalCount: number;

  constructor(data?: IAdministrationDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(AdministrationDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): AdministrationDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new AdministrationDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): AdministrationDtoPagedResultDto {
    const json = this.toJSON();
    let result = new AdministrationDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IAdministrationDtoPagedResultDto {
  items: AdministrationDto[] | undefined;
  totalCount: number;
}

export class AdministrationDto implements IAdministrationDto {
  id: number;

  constructor(data?: IAdministrationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AdministrationDto {
    data = typeof data === "object" ? data : {};
    let result = new AdministrationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    return data;
  }

  clone(): AdministrationDto {
    const json = this.toJSON();
    let result = new AdministrationDto();
    result.init(json);
    return result;
  }
}

export interface IAdministrationDto {
  id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
  version: string | undefined;
  releaseDate: moment.Moment;
  features: { [key: string]: boolean } | undefined;

  constructor(data?: IApplicationInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      this.releaseDate = _data["releaseDate"]
        ? moment(_data["releaseDate"].toString())
        : <any>undefined;
      if (_data["features"]) {
        this.features = {} as any;
        for (let key in _data["features"]) {
          if (_data["features"].hasOwnProperty(key))
            (<any>this.features)[key] = _data["features"][key];
        }
      }
    }
  }

  static fromJS(data: any): ApplicationInfoDto {
    data = typeof data === "object" ? data : {};
    let result = new ApplicationInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["version"] = this.version;
    data["releaseDate"] = this.releaseDate
      ? this.releaseDate.toISOString()
      : <any>undefined;
    if (this.features) {
      data["features"] = {};
      for (let key in this.features) {
        if (this.features.hasOwnProperty(key))
          (<any>data["features"])[key] = (<any>this.features)[key];
      }
    }
    return data;
  }

  clone(): ApplicationInfoDto {
    const json = this.toJSON();
    let result = new ApplicationInfoDto();
    result.init(json);
    return result;
  }
}

export class MonthlyCalendarModel implements IMonthlyCalendarModel {
  firstDay: string | undefined;
  lastDay: string | undefined;
  monthName: string | undefined;
  year: number;
  month: number;
  monthDays: CalendarDayModel[] | undefined;
  nextMonthDays: CalendarDayModel[] | undefined;
  previousMonthDays: CalendarDayModel[] | undefined;

  constructor(data?: IMonthlyCalendarModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstDay = _data["firstDay"];
      this.lastDay = _data["lastDay"];
      this.monthName = _data["monthName"];
      this.year = _data["year"];
      this.month = _data["month"];
      if (Array.isArray(_data["monthDays"])) {
        this.monthDays = [] as any;
        for (let item of _data["monthDays"])
          this.monthDays.push(CalendarDayModel.fromJS(item));
      }
      if (Array.isArray(_data["nextMonthDays"])) {
        this.nextMonthDays = [] as any;
        for (let item of _data["nextMonthDays"])
          this.nextMonthDays.push(CalendarDayModel.fromJS(item));
      }
      if (Array.isArray(_data["previousMonthDays"])) {
        this.previousMonthDays = [] as any;
        for (let item of _data["previousMonthDays"])
          this.previousMonthDays.push(CalendarDayModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MonthlyCalendarModel {
    data = typeof data === "object" ? data : {};
    let result = new MonthlyCalendarModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstDay"] = this.firstDay;
    data["lastDay"] = this.lastDay;
    data["monthName"] = this.monthName;
    data["year"] = this.year;
    data["month"] = this.month;
    if (Array.isArray(this.monthDays)) {
      data["monthDays"] = [];
      for (let item of this.monthDays) data["monthDays"].push(item.toJSON());
    }
    if (Array.isArray(this.nextMonthDays)) {
      data["nextMonthDays"] = [];
      for (let item of this.nextMonthDays)
        data["nextMonthDays"].push(item.toJSON());
    }
    if (Array.isArray(this.previousMonthDays)) {
      data["previousMonthDays"] = [];
      for (let item of this.previousMonthDays)
        data["previousMonthDays"].push(item.toJSON());
    }
    return data;
  }

  clone(): MonthlyCalendarModel {
    const json = this.toJSON();
    let result = new MonthlyCalendarModel();
    result.init(json);
    return result;
  }
}

export interface IMonthlyCalendarModel {
  firstDay: string | undefined;
  lastDay: string | undefined;
  monthName: string | undefined;
  year: number;
  month: number;
  monthDays: CalendarDayModel[] | undefined;
  nextMonthDays: CalendarDayModel[] | undefined;
  previousMonthDays: CalendarDayModel[] | undefined;
}

export class CalendarDayModel implements ICalendarDayModel {
  date: string | undefined;
  shamsiDate: string | undefined;
  weekDayNo: number;
  weekDayName: string | undefined;

  constructor(data?: ICalendarDayModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"];
      this.shamsiDate = _data["shamsiDate"];
      this.weekDayNo = _data["weekDayNo"];
      this.weekDayName = _data["weekDayName"];
    }
  }

  static fromJS(data: any): CalendarDayModel {
    data = typeof data === "object" ? data : {};
    let result = new CalendarDayModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date;
    data["shamsiDate"] = this.shamsiDate;
    data["weekDayNo"] = this.weekDayNo;
    data["weekDayName"] = this.weekDayName;
    return data;
  }

  clone(): CalendarDayModel {
    const json = this.toJSON();
    let result = new CalendarDayModel();
    result.init(json);
    return result;
  }
}

export interface ICalendarDayModel {
  date: string | undefined;
  shamsiDate: string | undefined;
  weekDayNo: number;
  weekDayName: string | undefined;
}

export interface IApplicationInfoDto {
  version: string | undefined;
  releaseDate: moment.Moment;
  features: { [key: string]: boolean } | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
  userNameOrEmailAddress: string;
  password: string;
  rememberClient: boolean;

  constructor(data?: IAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
      this.password = _data["password"];
      this.rememberClient = _data["rememberClient"];
    }
  }

  static fromJS(data: any): AuthenticateModel {
    data = typeof data === "object" ? data : {};
    let result = new AuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
    data["password"] = this.password;
    data["rememberClient"] = this.rememberClient;
    return data;
  }

  clone(): AuthenticateModel {
    const json = this.toJSON();
    let result = new AuthenticateModel();
    result.init(json);
    return result;
  }
}

export interface IAuthenticateModel {
  userNameOrEmailAddress: string;
  password: string;
  rememberClient: boolean;
}
export class OtpAuthenticateModel implements IOtpAuthenticateModel {
  UserName: string;
  Otp: string;

  constructor(data?: IAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.UserName = _data["userName"];
      this.Otp = _data["otp"];
    }
  }

  static fromJS(data: any): AuthenticateModel {
    data = typeof data === "object" ? data : {};
    let result = new AuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.UserName;
    data["otp"] = this.Otp;
    return data;
  }

  clone(): AuthenticateModel {
    const json = this.toJSON();
    let result = new AuthenticateModel();
    result.init(json);
    return result;
  }
}

export interface IOtpAuthenticateModel {
  UserName: string;
  Otp: string;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  userId: number;

  constructor(data?: IAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.userId = _data["userId"];
    }
  }

  static fromJS(data: any): AuthenticateResultModel {
    data = typeof data === "object" ? data : {};
    let result = new AuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["userId"] = this.userId;
    return data;
  }

  clone(): AuthenticateResultModel {
    const json = this.toJSON();
    let result = new AuthenticateResultModel();
    result.init(json);
    return result;
  }
}

export interface IAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  userId: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
  currentPassword: string;
  newPassword: string;

  constructor(data?: IChangePasswordDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPassword = _data["currentPassword"];
      this.newPassword = _data["newPassword"];
    }
  }

  static fromJS(data: any): ChangePasswordDto {
    data = typeof data === "object" ? data : {};
    let result = new ChangePasswordDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["currentPassword"] = this.currentPassword;
    data["newPassword"] = this.newPassword;
    return data;
  }

  clone(): ChangePasswordDto {
    const json = this.toJSON();
    let result = new ChangePasswordDto();
    result.init(json);
    return result;
  }
}

export interface IChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
  theme: string;

  constructor(data?: IChangeUiThemeInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.theme = _data["theme"];
    }
  }

  static fromJS(data: any): ChangeUiThemeInput {
    data = typeof data === "object" ? data : {};
    let result = new ChangeUiThemeInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["theme"] = this.theme;
    return data;
  }

  clone(): ChangeUiThemeInput {
    const json = this.toJSON();
    let result = new ChangeUiThemeInput();
    result.init(json);
    return result;
  }
}

export interface IChangeUiThemeInput {
  theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
  languageName: string;

  constructor(data?: IChangeUserLanguageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.languageName = _data["languageName"];
    }
  }

  static fromJS(data: any): ChangeUserLanguageDto {
    data = typeof data === "object" ? data : {};
    let result = new ChangeUserLanguageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["languageName"] = this.languageName;
    return data;
  }

  clone(): ChangeUserLanguageDto {
    const json = this.toJSON();
    let result = new ChangeUserLanguageDto();
    result.init(json);
    return result;
  }
}

export interface IChangeUserLanguageDto {
  languageName: string;
}

export class CreateRoleDto implements ICreateRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  grantedPermissions: string[] | undefined;

  constructor(data?: ICreateRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.normalizedName = _data["normalizedName"];
      this.description = _data["description"];
      if (Array.isArray(_data["grantedPermissions"])) {
        this.grantedPermissions = [] as any;
        for (let item of _data["grantedPermissions"])
          this.grantedPermissions.push(item);
      }
    }
  }

  static fromJS(data: any): CreateRoleDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["normalizedName"] = this.normalizedName;
    data["description"] = this.description;
    if (Array.isArray(this.grantedPermissions)) {
      data["grantedPermissions"] = [];
      for (let item of this.grantedPermissions)
        data["grantedPermissions"].push(item);
    }
    return data;
  }

  clone(): CreateRoleDto {
    const json = this.toJSON();
    let result = new CreateRoleDto();
    result.init(json);
    return result;
  }
}

export interface ICreateRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
  tenancyName: string;
  name: string;
  adminEmailAddress: string;
  connectionString: string | undefined;
  isActive: boolean;

  constructor(data?: ICreateTenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.adminEmailAddress = _data["adminEmailAddress"];
      this.connectionString = _data["connectionString"];
      this.isActive = _data["isActive"];
    }
  }

  static fromJS(data: any): CreateTenantDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateTenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["adminEmailAddress"] = this.adminEmailAddress;
    data["connectionString"] = this.connectionString;
    data["isActive"] = this.isActive;
    return data;
  }

  clone(): CreateTenantDto {
    const json = this.toJSON();
    let result = new CreateTenantDto();
    result.init(json);
    return result;
  }
}

export interface ICreateTenantDto {
  tenancyName: string;
  name: string;
  adminEmailAddress: string;
  connectionString: string | undefined;
  isActive: boolean;
}

export class CreateUserDto implements ICreateUserDto {
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  roleNames: string[] | undefined;
  password: string;
  IsCustomer: boolean;
  ProfilePhoto: string | undefined;
  BirthDate: string;
  BirthPlace: string;
  StudyField: string;
  UniversityInfo: string;
  PassportNumber: string;
  PassportExpirDate: string;
  BirthCertificateDescription: string;
  MobileNumber: string;
  FatherMobileNumber: string;
  MotherMobileNumber: string;
  PhoneNumber: string;
  HomeAddress: string;
  PostalCode: string;
  InterestsToApply: string;
  Gender: number;
  MaritalStatus: boolean;
  militaryServiceId: number;
  gradId: number;
  LastGPA: number;
  countryIds: number[] = [];
  organizationUnitIds: number[] = [];
  completionEducationDate: string;
  deploymentDate: string;

  constructor(data?: ICreateUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data["userName"];
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.emailAddress = _data["emailAddress"];
      this.isActive = _data["isActive"];
      this.IsCustomer = _data["isCustomer"];
      this.ProfilePhoto = _data["profilePhoto"];
      this.BirthDate = _data["birthDate"];
      this.BirthPlace = _data["birthPlace"];
      this.StudyField = _data["studyField"];
      this.UniversityInfo = _data["universityInfo"];
      this.PassportNumber = _data["passportNumber"];
      this.PassportExpirDate = _data["passportExpirDate"];
      this.BirthCertificateDescription = _data["birthCertificateDescription"];
      this.MobileNumber = _data["mobileNumber"];
      this.FatherMobileNumber = _data["fatherMobileNumber"];
      this.MotherMobileNumber = _data["motherMobileNumber"];
      this.PhoneNumber = _data["phoneNumber"];
      this.HomeAddress = _data["homeAddress"];
      this.PostalCode = _data["postalCode"];
      this.InterestsToApply = _data["interestsToApply"];
      this.Gender = _data["gender"];
      this.MaritalStatus = _data["maritalStatus"];
      this.militaryServiceId = _data["militaryServiceId"];
      this.gradId = _data["gradId"];
      this.LastGPA = _data["lastGPA"];
      this.completionEducationDate = _data["completionEducationDate"];
      this.deploymentDate = _data["deploymentDate"];
      if (Array.isArray(_data["roleNames"])) {
        this.roleNames = [] as any;
        for (let item of _data["roleNames"]) this.roleNames.push(item);
      }
      if (Array.isArray(_data["countryIds"])) {
        this.countryIds = [] as any;
        for (let item of _data["countryIds"]) this.countryIds.push(item);
      }
      if (Array.isArray(_data["organizationUnitIds"])) {
        this.organizationUnitIds = [] as any;
        for (let item of _data["organizationUnitIds"])
          this.organizationUnitIds.push(item);
      }
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): CreateUserDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.userName;
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["emailAddress"] = this.emailAddress;
    data["isActive"] = this.isActive;
    data["isCustomer"] = this.IsCustomer;
    data["profilePhoto"] = this.ProfilePhoto;
    data["birthDate"] = this.BirthDate;
    data["birthPlace"] = this.BirthPlace;
    data["studyField"] = this.StudyField;
    data["universityInfo"] = this.UniversityInfo;
    data["passportNumber"] = this.PassportNumber;
    data["passportExpirDate"] = this.PassportExpirDate;
    data["birthCertificateDescription"] = this.BirthCertificateDescription;
    data["mobileNumber"] = this.MobileNumber;
    data["fatherMobileNumber"] = this.FatherMobileNumber;
    data["motherMobileNumber"] = this.MotherMobileNumber;
    data["phoneNumber"] = this.PhoneNumber;
    data["homeAddress"] = this.HomeAddress;
    data["postalCode"] = this.PostalCode;
    data["interestsToApply"] = this.InterestsToApply;
    data["gender"] = this.Gender;
    data["maritalStatus"] = this.MaritalStatus;
    data["militaryServiceId"] = this.militaryServiceId;
    data["gradId"] = this.gradId;
    data["lastGPA"] = this.LastGPA;
    data["completionEducationDate"] = this.completionEducationDate;
    data["deploymentDate"] = this.deploymentDate;
    if (Array.isArray(this.roleNames)) {
      data["roleNames"] = [];
      for (let item of this.roleNames) data["roleNames"].push(item);
    }

    if (Array.isArray(this.countryIds)) {
      data["countryIds"] = [];
      for (let item of this.countryIds) data["countryIds"].push(item);
    }
    if (Array.isArray(this.organizationUnitIds)) {
      data["organizationUnitIds"] = [];
      for (let item of this.organizationUnitIds)
        data["organizationUnitIds"].push(item);
    }
    data["password"] = this.password;
    return data;
  }

  clone(): CreateUserDto {
    const json = this.toJSON();
    let result = new CreateUserDto();
    result.init(json);
    return result;
  }
}

export interface ICreateUserDto {
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  roleNames: string[] | undefined;
  password: string;
  IsCustomer: boolean;
  ProfilePhoto: string | undefined;
  BirthDate: string;
  BirthPlace: string;
  StudyField: string;
  UniversityInfo: string;
  PassportNumber: string;
  PassportExpirDate: string;
  BirthCertificateDescription: string;
  MobileNumber: string;
  FatherMobileNumber: string;
  MotherMobileNumber: string;
  PhoneNumber: string;
  HomeAddress: string;
  PostalCode: string;
  InterestsToApply: string;
  Gender: number;
  MaritalStatus: boolean;
  militaryServiceId: number;
  gradId: number;
  LastGPA: number;
  countryIds: number[];
  organizationUnitIds: number[];
  completionEducationDate: string;
  deploymentDate: string;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;

  constructor(data?: IExternalAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authProvider = _data["authProvider"];
      this.providerKey = _data["providerKey"];
      this.providerAccessCode = _data["providerAccessCode"];
    }
  }

  static fromJS(data: any): ExternalAuthenticateModel {
    data = typeof data === "object" ? data : {};
    let result = new ExternalAuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["authProvider"] = this.authProvider;
    data["providerKey"] = this.providerKey;
    data["providerAccessCode"] = this.providerAccessCode;
    return data;
  }

  clone(): ExternalAuthenticateModel {
    const json = this.toJSON();
    let result = new ExternalAuthenticateModel();
    result.init(json);
    return result;
  }
}

export interface IExternalAuthenticateModel {
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  waitingForActivation: boolean;

  constructor(data?: IExternalAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.waitingForActivation = _data["waitingForActivation"];
    }
  }

  static fromJS(data: any): ExternalAuthenticateResultModel {
    data = typeof data === "object" ? data : {};
    let result = new ExternalAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["waitingForActivation"] = this.waitingForActivation;
    return data;
  }

  clone(): ExternalAuthenticateResultModel {
    const json = this.toJSON();
    let result = new ExternalAuthenticateResultModel();
    result.init(json);
    return result;
  }
}

export interface IExternalAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
  name: string | undefined;
  clientId: string | undefined;

  constructor(data?: IExternalLoginProviderInfoModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.clientId = _data["clientId"];
    }
  }

  static fromJS(data: any): ExternalLoginProviderInfoModel {
    data = typeof data === "object" ? data : {};
    let result = new ExternalLoginProviderInfoModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["clientId"] = this.clientId;
    return data;
  }

  clone(): ExternalLoginProviderInfoModel {
    const json = this.toJSON();
    let result = new ExternalLoginProviderInfoModel();
    result.init(json);
    return result;
  }
}

export interface IExternalLoginProviderInfoModel {
  name: string | undefined;
  clientId: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;

  constructor(data?: IFlatPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): FlatPermissionDto {
    data = typeof data === "object" ? data : {};
    let result = new FlatPermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    return data;
  }

  clone(): FlatPermissionDto {
    const json = this.toJSON();
    let result = new FlatPermissionDto();
    result.init(json);
    return result;
  }
}

export interface IFlatPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
  application: ApplicationInfoDto;
  user: UserLoginInfoDto;
  tenant: TenantLoginInfoDto;

  constructor(data?: IGetCurrentLoginInformationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.application = _data["application"]
        ? ApplicationInfoDto.fromJS(_data["application"])
        : <any>undefined;
      this.user = _data["user"]
        ? UserLoginInfoDto.fromJS(_data["user"])
        : <any>undefined;
      this.tenant = _data["tenant"]
        ? TenantLoginInfoDto.fromJS(_data["tenant"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): GetCurrentLoginInformationsOutput {
    data = typeof data === "object" ? data : {};
    let result = new GetCurrentLoginInformationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["application"] = this.application
      ? this.application.toJSON()
      : <any>undefined;
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
    return data;
  }

  clone(): GetCurrentLoginInformationsOutput {
    const json = this.toJSON();
    let result = new GetCurrentLoginInformationsOutput();
    result.init(json);
    return result;
  }
}

export interface IGetCurrentLoginInformationsOutput {
  application: ApplicationInfoDto;
  user: UserLoginInfoDto;
  tenant: TenantLoginInfoDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
  role: RoleEditDto;
  permissions: FlatPermissionDto[] | undefined;
  grantedPermissionNames: string[] | undefined;

  constructor(data?: IGetRoleForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.role = _data["role"]
        ? RoleEditDto.fromJS(_data["role"])
        : <any>undefined;
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"])
          this.permissions.push(FlatPermissionDto.fromJS(item));
      }
      if (Array.isArray(_data["grantedPermissionNames"])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data["grantedPermissionNames"])
          this.grantedPermissionNames.push(item);
      }
    }
  }

  static fromJS(data: any): GetRoleForEditOutput {
    data = typeof data === "object" ? data : {};
    let result = new GetRoleForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["role"] = this.role ? this.role.toJSON() : <any>undefined;
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions)
        data["permissions"].push(item.toJSON());
    }
    if (Array.isArray(this.grantedPermissionNames)) {
      data["grantedPermissionNames"] = [];
      for (let item of this.grantedPermissionNames)
        data["grantedPermissionNames"].push(item);
    }
    return data;
  }

  clone(): GetRoleForEditOutput {
    const json = this.toJSON();
    let result = new GetRoleForEditOutput();
    result.init(json);
    return result;
  }
}

export interface IGetRoleForEditOutput {
  role: RoleEditDto;
  permissions: FlatPermissionDto[] | undefined;
  grantedPermissionNames: string[] | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
  id: number;

  constructor(data?: IInt64EntityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Int64EntityDto {
    data = typeof data === "object" ? data : {};
    let result = new Int64EntityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    return data;
  }

  clone(): Int64EntityDto {
    const json = this.toJSON();
    let result = new Int64EntityDto();
    result.init(json);
    return result;
  }
}

export interface IInt64EntityDto {
  id: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
  tenancyName: string;

  constructor(data?: IIsTenantAvailableInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
    }
  }

  static fromJS(data: any): IsTenantAvailableInput {
    data = typeof data === "object" ? data : {};
    let result = new IsTenantAvailableInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["tenancyName"] = this.tenancyName;
    return data;
  }

  clone(): IsTenantAvailableInput {
    const json = this.toJSON();
    let result = new IsTenantAvailableInput();
    result.init(json);
    return result;
  }
}

export interface IIsTenantAvailableInput {
  tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
  state: TenantAvailabilityState;
  tenantId: number | undefined;

  constructor(data?: IIsTenantAvailableOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.state = _data["state"];
      this.tenantId = _data["tenantId"];
    }
  }

  static fromJS(data: any): IsTenantAvailableOutput {
    data = typeof data === "object" ? data : {};
    let result = new IsTenantAvailableOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["state"] = this.state;
    data["tenantId"] = this.tenantId;
    return data;
  }

  clone(): IsTenantAvailableOutput {
    const json = this.toJSON();
    let result = new IsTenantAvailableOutput();
    result.init(json);
    return result;
  }
}

export interface IIsTenantAvailableOutput {
  state: TenantAvailabilityState;
  tenantId: number | undefined;
}

export class PermissionDto implements IPermissionDto {
  id: number;
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;

  constructor(data?: IPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): PermissionDto {
    data = typeof data === "object" ? data : {};
    let result = new PermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    return data;
  }

  clone(): PermissionDto {
    const json = this.toJSON();
    let result = new PermissionDto();
    result.init(json);
    return result;
  }
}

export interface IPermissionDto {
  id: number;
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
  items: PermissionDto[] | undefined;

  constructor(data?: IPermissionDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(PermissionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PermissionDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new PermissionDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PermissionDtoListResultDto {
    const json = this.toJSON();
    let result = new PermissionDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IPermissionDtoListResultDto {
  items: PermissionDto[] | undefined;
}

export class RegisterInput implements IRegisterInput {
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  password: string;
  captchaResponse: string | undefined;

  constructor(data?: IRegisterInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.password = _data["password"];
      this.captchaResponse = _data["captchaResponse"];
    }
  }

  static fromJS(data: any): RegisterInput {
    data = typeof data === "object" ? data : {};
    let result = new RegisterInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["password"] = this.password;
    data["captchaResponse"] = this.captchaResponse;
    return data;
  }

  clone(): RegisterInput {
    const json = this.toJSON();
    let result = new RegisterInput();
    result.init(json);
    return result;
  }
}

export interface IRegisterInput {
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  password: string;
  captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
  canLogin: boolean;

  constructor(data?: IRegisterOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canLogin = _data["canLogin"];
    }
  }

  static fromJS(data: any): RegisterOutput {
    data = typeof data === "object" ? data : {};
    let result = new RegisterOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["canLogin"] = this.canLogin;
    return data;
  }

  clone(): RegisterOutput {
    const json = this.toJSON();
    let result = new RegisterOutput();
    result.init(json);
    return result;
  }
}

export interface IRegisterOutput {
  canLogin: boolean;
}

export class ResetPasswordDto implements IResetPasswordDto {
  adminPassword: string;
  userId: number;
  newPassword: string;

  constructor(data?: IResetPasswordDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.adminPassword = _data["adminPassword"];
      this.userId = _data["userId"];
      this.newPassword = _data["newPassword"];
    }
  }

  static fromJS(data: any): ResetPasswordDto {
    data = typeof data === "object" ? data : {};
    let result = new ResetPasswordDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["adminPassword"] = this.adminPassword;
    data["userId"] = this.userId;
    data["newPassword"] = this.newPassword;
    return data;
  }

  clone(): ResetPasswordDto {
    const json = this.toJSON();
    let result = new ResetPasswordDto();
    result.init(json);
    return result;
  }
}

export interface IResetPasswordDto {
  adminPassword: string;
  userId: number;
  newPassword: string;
}

export class RoleDto implements IRoleDto {
  id: number;
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  grantedPermissions: string[] | undefined;

  constructor(data?: IRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.normalizedName = _data["normalizedName"];
      this.description = _data["description"];
      if (Array.isArray(_data["grantedPermissions"])) {
        this.grantedPermissions = [] as any;
        for (let item of _data["grantedPermissions"])
          this.grantedPermissions.push(item);
      }
    }
  }

  static fromJS(data: any): RoleDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["normalizedName"] = this.normalizedName;
    data["description"] = this.description;
    if (Array.isArray(this.grantedPermissions)) {
      data["grantedPermissions"] = [];
      for (let item of this.grantedPermissions)
        data["grantedPermissions"].push(item);
    }
    return data;
  }

  clone(): RoleDto {
    const json = this.toJSON();
    let result = new RoleDto();
    result.init(json);
    return result;
  }
}

export interface IRoleDto {
  id: number;
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
  items: RoleDto[] | undefined;

  constructor(data?: IRoleDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(RoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RoleDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): RoleDtoListResultDto {
    const json = this.toJSON();
    let result = new RoleDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IRoleDtoListResultDto {
  items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
  items: RoleDto[] | undefined;
  totalCount: number;

  constructor(data?: IRoleDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(RoleDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): RoleDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): RoleDtoPagedResultDto {
    const json = this.toJSON();
    let result = new RoleDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IRoleDtoPagedResultDto {
  items: RoleDto[] | undefined;
  totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
  id: number;
  name: string;
  displayName: string;
  description: string | undefined;
  isStatic: boolean;

  constructor(data?: IRoleEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
      this.isStatic = _data["isStatic"];
    }
  }

  static fromJS(data: any): RoleEditDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    data["isStatic"] = this.isStatic;
    return data;
  }

  clone(): RoleEditDto {
    const json = this.toJSON();
    let result = new RoleEditDto();
    result.init(json);
    return result;
  }
}

export interface IRoleEditDto {
  id: number;
  name: string;
  displayName: string;
  description: string | undefined;
  isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
  id: number;
  name: string | undefined;
  displayName: string | undefined;
  isStatic: boolean;
  isDefault: boolean;
  creationTime: moment.Moment;

  constructor(data?: IRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.isStatic = _data["isStatic"];
      this.isDefault = _data["isDefault"];
      this.creationTime = _data["creationTime"]
        ? moment(_data["creationTime"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): RoleListDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["isStatic"] = this.isStatic;
    data["isDefault"] = this.isDefault;
    data["creationTime"] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    return data;
  }

  clone(): RoleListDto {
    const json = this.toJSON();
    let result = new RoleListDto();
    result.init(json);
    return result;
  }
}

export interface IRoleListDto {
  id: number;
  name: string | undefined;
  displayName: string | undefined;
  isStatic: boolean;
  isDefault: boolean;
  creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
  items: RoleListDto[] | undefined;

  constructor(data?: IRoleListDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(RoleListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RoleListDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleListDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): RoleListDtoListResultDto {
    const json = this.toJSON();
    let result = new RoleListDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IRoleListDtoListResultDto {
  items: RoleListDto[] | undefined;
}

export enum TenantAvailabilityState {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class TenantDto implements ITenantDto {
  id: number;
  tenancyName: string;
  name: string;
  isActive: boolean;

  constructor(data?: ITenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.isActive = _data["isActive"];
    }
  }

  static fromJS(data: any): TenantDto {
    data = typeof data === "object" ? data : {};
    let result = new TenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["isActive"] = this.isActive;
    return data;
  }

  clone(): TenantDto {
    const json = this.toJSON();
    let result = new TenantDto();
    result.init(json);
    return result;
  }
}

export interface ITenantDto {
  id: number;
  tenancyName: string;
  name: string;
  isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
  items: TenantDto[] | undefined;
  totalCount: number;

  constructor(data?: ITenantDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(TenantDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): TenantDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new TenantDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): TenantDtoPagedResultDto {
    const json = this.toJSON();
    let result = new TenantDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ITenantDtoPagedResultDto {
  items: TenantDto[] | undefined;
  totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
  id: number;
  tenancyName: string | undefined;
  name: string | undefined;

  constructor(data?: ITenantLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): TenantLoginInfoDto {
    data = typeof data === "object" ? data : {};
    let result = new TenantLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    return data;
  }

  clone(): TenantLoginInfoDto {
    const json = this.toJSON();
    let result = new TenantLoginInfoDto();
    result.init(json);
    return result;
  }
}

export interface ITenantLoginInfoDto {
  id: number;
  tenancyName: string | undefined;
  name: string | undefined;
}

export class UserDto implements IUserDto {
  id: number;
  IsCustomer: boolean;
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  fullName: string | undefined;
  lastLoginTime: moment.Moment | undefined;
  creationTime: moment.Moment;
  roleNames: string[] | undefined;
  password: string;
  ProfilePhoto: string;
  BirthDate: string;
  BirthPlace: string;
  StudyField: string;
  UniversityInfo: string;
  PassportNumber: string;
  PassportExpirDate: string;
  BirthCertificateDescription: string;
  MobileNumber: string;
  FatherMobileNumber: string;
  MotherMobileNumber: string;
  PhoneNumber: string;
  HomeAddress: string;
  PostalCode: string;
  InterestsToApply: string;
  Gender: number = 0;
  MaritalStatus: boolean;
  militaryServiceId: number;
  gradId: number;
  LastGPA: number;
  CaseId: number;
  countryIds: number[] = [];
  organizationUnitIds: number[] = [];
  viraemailAddress: string;
  viraPassword: string;
  emailPassword: string;
  completionEducationDate: string;
  deploymentDate: string;
  thumbnail: string;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.userName = _data["userName"];
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.emailAddress = _data["emailAddress"];
      this.isActive = _data["isActive"];
      this.fullName = _data["fullName"];
      this.password = _data["password"];
      this.IsCustomer = _data["isCustomer"];
      this.ProfilePhoto = _data["profilePhoto"];
      this.BirthDate = _data["birthDate"];
      this.BirthPlace = _data["birthPlace"];
      this.StudyField = _data["studyField"];
      this.UniversityInfo = _data["universityInfo"];
      this.PassportNumber = _data["passportNumber"];
      this.PassportExpirDate = _data["passportExpirDate"];
      this.BirthCertificateDescription = _data["birthCertificateDescription"];
      this.MobileNumber = _data["mobileNumber"];
      this.FatherMobileNumber = _data["fatherMobileNumber"];
      this.MotherMobileNumber = _data["motherMobileNumber"];
      this.PhoneNumber = _data["phoneNumber"];
      this.HomeAddress = _data["homeAddress"];
      this.PostalCode = _data["postalCode"];
      this.InterestsToApply = _data["interestsToApply"];
      this.Gender = _data["gender"];
      this.MaritalStatus = _data["maritalStatus"];
      this.militaryServiceId = _data["militaryServiceId"];
      this.gradId = _data["gradId"];
      this.LastGPA = _data["lastGPA"];
      this.CaseId = _data["caseId"];
      this.viraemailAddress = _data["viraemailAddress"];
      this.viraPassword = _data["viraPassword"];
      this.emailPassword = _data["emailPassword"];
      this.completionEducationDate = _data["completionEducationDate"];
      this.deploymentDate = _data["deploymentDate"];
      this.lastLoginTime = _data["lastLoginTime"]
      this.thumbnail = _data["thumbnail"]
        ? moment(_data["lastLoginTime"].toString())
        : <any>undefined;
      this.creationTime = _data["creationTime"]
        ? moment(_data["creationTime"].toString())
        : <any>undefined;
      if (Array.isArray(_data["roleNames"])) {
        this.roleNames = [] as any;
        for (let item of _data["roleNames"]) this.roleNames.push(item);
      }

      if (Array.isArray(_data["countryIds"])) {
        this.countryIds = [] as any;
        for (let item of _data["countryIds"]) this.countryIds.push(item);
      }
      if (Array.isArray(_data["organizationUnitIds"])) {
        this.organizationUnitIds = [] as any;
        for (let item of _data["organizationUnitIds"])
          this.organizationUnitIds.push(item);
      }
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === "object" ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["userName"] = this.userName;
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["emailAddress"] = this.emailAddress;
    data["isActive"] = this.isActive;
    data["fullName"] = this.fullName;
    data["password"] = this.password;
    data["isCustomer"] = this.IsCustomer;
    data["profilePhoto"] = this.ProfilePhoto;
    data["birthDate"] = this.BirthDate;
    data["birthPlace"] = this.BirthPlace;
    data["studyField"] = this.StudyField;
    data["universityInfo"] = this.UniversityInfo;
    data["passportNumber"] = this.PassportNumber;
    data["passportExpirDate"] = this.PassportExpirDate;
    data["birthCertificateDescription"] = this.BirthCertificateDescription;
    data["mobileNumber"] = this.MobileNumber;
    data["fatherMobileNumber"] = this.FatherMobileNumber;
    data["motherMobileNumber"] = this.MotherMobileNumber;
    data["phoneNumber"] = this.PhoneNumber;
    data["homeAddress"] = this.HomeAddress;
    data["postalCode"] = this.PostalCode;
    data["interestsToApply"] = this.InterestsToApply;
    data["gender"] = this.Gender;
    data["maritalStatus"] = this.MaritalStatus;
    data["militaryServiceId"] = this.militaryServiceId;
    data["gradId"] = this.gradId;
    data["lastGPA"] = this.LastGPA;
    data["caseId"] = this.CaseId;
    data["viraemailAddress"] = this.viraemailAddress;
    data["viraPassword"] = this.viraPassword;
    data["emailPassword"] = this.emailPassword;
    data["completionEducationDate"] = this.completionEducationDate;
    data["deploymentDate"] = this.deploymentDate;
    data["lastLoginTime"] = this.lastLoginTime;
    data["thumbnail"] = this.thumbnail
      ? this.lastLoginTime.toISOString()
      : <any>undefined;
    data["creationTime"] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    if (Array.isArray(this.roleNames)) {
      data["roleNames"] = [];
      for (let item of this.roleNames) data["roleNames"].push(item);
    }

    if (Array.isArray(this.countryIds)) {
      data["countryIds"] = [];
      for (let item of this.countryIds) data["countryIds"].push(item);
    }
    if (Array.isArray(this.organizationUnitIds)) {
      data["organizationUnitIds"] = [];
      for (let item of this.organizationUnitIds)
        data["organizationUnitIds"].push(item);
    }
    return data;
  }

  clone(): UserDto {
    const json = this.toJSON();
    let result = new UserDto();
    result.init(json);
    return result;
  }
}

export interface IUserDto {
  id: number;
  IsCustomer: boolean;
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  fullName: string | undefined;
  password: string | undefined;
  lastLoginTime: moment.Moment | undefined;
  creationTime: moment.Moment;
  roleNames: string[] | undefined;
  ProfilePhoto: string | undefined;
  BirthDate: string;
  BirthPlace: string;
  StudyField: string;
  UniversityInfo: string;
  PassportNumber: string;
  PassportExpirDate: string;
  BirthCertificateDescription: string;
  MobileNumber: string;
  FatherMobileNumber: string;
  MotherMobileNumber: string;
  PhoneNumber: string;
  HomeAddress: string;
  PostalCode: string;
  InterestsToApply: string;
  Gender: number;
  MaritalStatus: boolean;
  militaryServiceId: number;
  gradId: number;
  LastGPA: number;
  CaseId: number;
  countryIds: number[];
  organizationUnitIds: number[];
  viraPassword: string;
  emailPassword: string;
  viraemailAddress: string;
  completionEducationDate: string;
  deploymentDate: string;
  thumbnail: string;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
  items: UserDto[] | undefined;
  totalCount: number;

  constructor(data?: IUserDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(UserDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): UserDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new UserDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): UserDtoPagedResultDto {
    const json = this.toJSON();
    let result = new UserDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IUserDtoPagedResultDto {
  items: UserDto[] | undefined;
  totalCount: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
  id: number;
  name: string | undefined;
  surname: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  profilePhoto: string;

  constructor(data?: IUserLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.profilePhoto = _data["profilePhoto"];
    }
  }

  static fromJS(data: any): UserLoginInfoDto {
    data = typeof data === "object" ? data : {};
    let result = new UserLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["profilePhoto"] = this.profilePhoto;
    return data;
  }

  clone(): UserLoginInfoDto {
    const json = this.toJSON();
    let result = new UserLoginInfoDto();
    result.init(json);
    return result;
  }
}

export interface IUserLoginInfoDto {
  id: number;
  name: string | undefined;
  surname: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  profilePhoto: string | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

export class TagDto implements ITagDto {
  id: number;
  title: string | undefined;

  constructor(data?: ITagDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
    }
  }

  static fromJS(data: any): TagDto {
    data = typeof data === "object" ? data : {};
    let result = new TagDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    return data;
  }

  clone(): TagDto {
    const json = this.toJSON();
    let result = new TagDto();
    result.init(json);
    return result;
  }
}

export interface ITagDto {
  id: number;
  title: string | undefined;
}

export class TagDtoPagedResultDto implements ITagDtoPagedResultDto {
  items: TagDto[] | undefined;
  totalCount: number;

  constructor(data?: ITagDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(TagDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): TagDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new TagDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): TagDtoPagedResultDto {
    const json = this.toJSON();
    let result = new TagDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ITagDtoPagedResultDto {
  items: TagDto[] | undefined;
  totalCount: number;
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new ApiException(message, status, response, headers, null),
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}

//#region OrganizationUnit
@Injectable()
export class OrganizationUnitServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateOrganizationUnitDto | undefined,
  ): Observable<OrganizationUnitDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnits/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<OrganizationUnitDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<OrganizationUnitDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<OrganizationUnitDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationUnitDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(
    body: OrganizationUnitDto | undefined,
  ): Observable<OrganizationUnitDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnits/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<OrganizationUnitDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<OrganizationUnitDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<OrganizationUnitDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationUnitDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnits/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<OrganizationUnitDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnits/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<OrganizationUnitDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<OrganizationUnitDto>;
        }),
      );
  }
  protected processGet(
    response: HttpResponseBase,
  ): Observable<OrganizationUnitDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationUnitDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    parentId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<OrganizationUnitDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnits/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (parentId === null)
      throw new Error("The parameter 'parentId' cannot be null.");
    if (parentId !== undefined)
      url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<OrganizationUnitDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<OrganizationUnitDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<OrganizationUnitDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationUnitDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  GetAllList(): Observable<OrganizationUnitDto[]> {
    let url_ = this.baseUrl + "/api/services/app/OrganizationUnits/GetAllList?";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                OrganizationUnitDto[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              OrganizationUnitDto[]
            >;
        }),
      );
  }

  protected processGetAllList(
    response: HttpResponseBase,
  ): Observable<OrganizationUnitDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationUnitListDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  GetAllOrganizationsForSubject(
    ShowAll: boolean = false,
  ): Observable<OrganizationUnitSubjectDto[]> {
    let url_ =
      this.baseUrl +
      "/api/services/app/OrganizationUnits/GetOrganizationsForSubject?ShowAll=" +
      ShowAll;
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.ProccessGetAllOrganizationsForSubject(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.ProccessGetAllOrganizationsForSubject(
                response_ as any,
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                OrganizationUnitSubjectDto[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              OrganizationUnitSubjectDto[]
            >;
        }),
      );
  }

  protected ProccessGetAllOrganizationsForSubject(
    response: HttpResponseBase,
  ): Observable<OrganizationUnitSubjectDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  GetOrganizationUnitTreeData(): Observable<OrganizationUnitDto[]> {
    let url_ =
      this.baseUrl + "/api/services/app/OrganizationUnits/GetTreeData?";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processOrganizationUnitTreeData(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processOrganizationUnitTreeData(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                OrganizationUnitDto[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              OrganizationUnitDto[]
            >;
        }),
      );
  }

  protected processOrganizationUnitTreeData(
    response: HttpResponseBase,
  ): Observable<OrganizationUnitDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateOrganizationUnitDto implements ICreateOrganizationUnitDto {
  Id: number;
  ParentId: number;
  Code: string;
  DisplayName: string;

  constructor(data?: ICreateOrganizationUnitDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["Id"];
      this.ParentId = _data["ParentId"];
      this.Code = _data["Code"];
      this.DisplayName = _data["DisplayName"];
    }
  }

  static fromJS(data: any): CreateOrganizationUnitDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateOrganizationUnitDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["parentid"] = this.ParentId;
    data["code"] = this.Code;
    data["displayName"] = this.DisplayName;

    return data;
  }

  clone(): CreateOrganizationUnitDto {
    const json = this.toJSON();
    let result = new CreateOrganizationUnitDto();
    result.init(json);
    return result;
  }
}

export class OrganizationUnitSubjectDto implements IOrganizationUnitSubjectDto {
  id: number;
  displayName: string;
  fullName: string;

  constructor(data?: ICreateOrganizationUnitDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["Id"];
      this.displayName = _data["displayName"];
      this.fullName = _data["fullName"];
    }
  }

  static fromJS(data: any): OrganizationUnitSubjectDto {
    data = typeof data === "object" ? data : {};
    let result = new OrganizationUnitSubjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    data["fullName"] = this.fullName;

    return data;
  }

  clone(): OrganizationUnitSubjectDto {
    const json = this.toJSON();
    let result = new OrganizationUnitSubjectDto();
    result.init(json);
    return result;
  }
}

export interface IOrganizationUnitSubjectDto {
  id: number;
  displayName: string;
  fullName: string;
}

export interface ICreateOrganizationUnitDto {
  Id: number;
  ParentId: number;
  Code: string;
  DisplayName: string;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
  id: number;
  parentId: number;
  displayName: string = "";
  parentName: string = "";
  code: string = "";
  children: OrganizationUnitDto[] | undefined;

  constructor(data?: IOrganizationUnitDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.parentId = _data["parentid"];
      this.displayName = _data["displayName"];
      this.parentName = _data["parentName"];
      if (Array.isArray(_data["children"])) {
        this.children = [] as any;
        for (let item of _data["children"]) this.children.push(item);
      }
    }
  }

  static fromJS(data: any): OrganizationUnitDto {
    data = typeof data === "object" ? data : {};
    let result = new OrganizationUnitDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["parentId"] = this.parentId;
    data["displayName"] = this.displayName;
    data["parentName"] = this.parentName;
    if (Array.isArray(this.children)) {
      data["children"] = [];
      for (let item of this.children) data["children"].push(item);
    }
    return data;
  }

  clone(): OrganizationUnitDto {
    const json = this.toJSON();
    let result = new OrganizationUnitDto();
    result.init(json);
    return result;
  }
}

export interface IOrganizationUnitDto {
  id: number;
  parentId: number;
  displayName: string;
  parentName: string;
  code: string;
  children: OrganizationUnitDto[] | undefined;
}
export class OrganizationUnitListDto implements IOrganizationUnitListDto {
  OrganizationUnitDtos: OrganizationUnitDto[] | undefined;

  constructor(data?: IOrganizationUnitDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["OrganizationUnitDtos"])) {
        this.OrganizationUnitDtos = [] as any;
        for (let item of _data["OrganizationUnitDtos"])
          this.OrganizationUnitDtos.push(OrganizationUnitDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): OrganizationUnitListDto {
    data = typeof data === "object" ? data : {};
    let result = new OrganizationUnitListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.OrganizationUnitDtos)) {
      data["OrganizationUnitDtos"] = [];
      for (let item of this.OrganizationUnitDtos)
        data["OrganizationUnitDtos"].push(item.toJSON());
    }
    return data;
  }

  clone(): OrganizationUnitListDto {
    const json = this.toJSON();
    let result = new OrganizationUnitListDto();
    result.init(json);
    return result;
  }
}

export interface IOrganizationUnitListDto {
  OrganizationUnitDtos: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitSubjectListDto implements IOrganizationUnitSubjectListDto {
  OrganizationUnitSubjectDtos: OrganizationUnitSubjectDto[] | undefined;

  constructor(data?: IOrganizationUnitDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["OrganizationUnitSubjectDtos"])) {
        this.OrganizationUnitSubjectDtos = [] as any;
        for (let item of _data["OrganizationUnitSubjectDtos"])
          this.OrganizationUnitSubjectDtos.push(
            OrganizationUnitSubjectDto.fromJS(item),
          );
      }
    }
  }

  static fromJS(data: any): OrganizationUnitSubjectListDto {
    data = typeof data === "object" ? data : {};
    let result = new OrganizationUnitSubjectListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.OrganizationUnitSubjectDtos)) {
      data["OrganizationUnitSubjectDto"] = [];
      for (let item of this.OrganizationUnitSubjectDtos)
        data["OrganizationUnitSubjectDto"].push(item.toJSON());
    }
    return data;
  }

  clone(): OrganizationUnitSubjectListDto {
    const json = this.toJSON();
    let result = new OrganizationUnitSubjectListDto();
    result.init(json);
    return result;
  }
}

export interface IOrganizationUnitSubjectListDto {
  OrganizationUnitSubjectDtos: OrganizationUnitSubjectDto[] | undefined;
}

export class OrganizationUnitDtoPagedResultDto implements IOrganizationUnitDtoPagedResultDto {
  items: OrganizationUnitDto[] | undefined;
  totalCount: number;

  constructor(data?: IOrganizationUnitDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(OrganizationUnitDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): OrganizationUnitDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new OrganizationUnitDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): OrganizationUnitDtoPagedResultDto {
    const json = this.toJSON();
    let result = new OrganizationUnitDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IOrganizationUnitDtoPagedResultDto {
  items: OrganizationUnitDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region Country

@Injectable()
export class CountryServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateCountryDto | undefined): Observable<CountryDto> {
    let url_ = this.baseUrl + "/api/services/app/Country/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CountryDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<CountryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountryDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: CountryDto | undefined): Observable<CountryDto> {
    let url_ = this.baseUrl + "/api/services/app/Country/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CountryDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<CountryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountryDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Country/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<CountryDto> {
    let url_ = this.baseUrl + "/api/services/app/Country/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CountryDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<CountryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountryDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<CountryDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Country/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<CountryDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CountryDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<CountryDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountryDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getAllForCombo(): Observable<CountryDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Country/GetForCombo";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllForCombo(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllForCombo(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              CountryDto[]
            >;
        }),
      );
  }

  protected processGetAllForCombo(
    response: HttpResponseBase,
  ): Observable<CountryDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateCountryDto implements ICreateCountryDto {
  Name: string;

  constructor(data?: ICreateCountryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Name = _data["name"];
    }
  }

  static fromJS(data: any): CreateCountryDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCountryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.Name;

    return data;
  }

  clone(): CreateCountryDto {
    const json = this.toJSON();
    let result = new CreateCountryDto();
    result.init(json);
    return result;
  }
}

export interface ICreateCountryDto {
  Name: string;
}

export class CountryDto implements ICountryDto {
  Id: number;
  Name: string;

  constructor(data?: ICountryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["id"];
      this.Name = _data["name"];
    }
  }

  static fromJS(data: any): CountryDto {
    data = typeof data === "object" ? data : {};
    let result = new CountryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["name"] = this.Name;

    return data;
  }

  clone(): CountryDto {
    const json = this.toJSON();
    let result = new CountryDto();
    result.init(json);
    return result;
  }
}

export interface ICountryDto {
  Id: number;
  Name: string;
}
export class CountryDtoPagedResultDto implements ICountryDtoPagedResultDto {
  items: CountryDto[] | undefined;
  totalCount: number;

  constructor(data?: ICountryDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(CountryDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): CountryDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CountryDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): CountryDtoPagedResultDto {
    const json = this.toJSON();
    let result = new CountryDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ICountryDtoPagedResultDto {
  items: CountryDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region  Meeting

@Injectable()
export class ApplicationActionTypeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param keyword (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ApplicationActionTypeDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationActionType/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ApplicationActionTypeDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ApplicationActionTypeDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<ApplicationActionTypeDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            ApplicationActionTypeDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateApplicationActionTypeDto | undefined,
  ): Observable<ApplicationActionTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationActionType/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ApplicationActionTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ApplicationActionTypeDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<ApplicationActionTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationActionTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(
    body: ApplicationActionTypeDto | undefined,
  ): Observable<ApplicationActionTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationActionType/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ApplicationActionTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ApplicationActionTypeDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<ApplicationActionTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationActionTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<ApplicationActionTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationActionType/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ApplicationActionTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ApplicationActionTypeDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<ApplicationActionTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationActionTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationActionType/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class MeetingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param expertId (optional)
   * @param applicationId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    expertId: number | undefined,
    applicationId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<MeetingDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/GetAll?";
    if (expertId === null)
      throw new Error("The parameter 'expertId' cannot be null.");
    else if (expertId !== undefined)
      url_ += "ExpertId=" + encodeURIComponent("" + expertId) + "&";
    if (applicationId === null)
      throw new Error("The parameter 'applicationId' cannot be null.");
    else if (applicationId !== undefined)
      url_ += "ApplicationId=" + encodeURIComponent("" + applicationId) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<MeetingDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MeetingDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<MeetingDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @param body (optional)
   * @return Success
   */
  reserveMeetingTime(
    body: ReserveMeetingDto | undefined,
  ): Observable<MeetingDto> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/ReserveMeetingTime";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReserveMeetingTime(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReserveMeetingTime(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MeetingDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<MeetingDto>;
        }),
      );
  }

  protected processReserveMeetingTime(
    response: HttpResponseBase,
  ): Observable<MeetingDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<MeetingDto> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MeetingDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<MeetingDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<MeetingDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateMeetingDto | undefined): Observable<MeetingDto> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MeetingDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<MeetingDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<MeetingDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: MeetingDto | undefined): Observable<MeetingDto> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MeetingDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<MeetingDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<MeetingDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param meetingId (optional)
   * @return Success
   */
  confirmMeeting(meetingId: number | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/ConfirmMeeting?";
    if (meetingId === null)
      throw new Error("The parameter 'meetingId' cannot be null.");
    else if (meetingId !== undefined)
      url_ += "MeetingId=" + encodeURIComponent("" + meetingId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processConfirmMeeting(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processConfirmMeeting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processConfirmMeeting(
    response: HttpResponseBase,
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param meetingId (optional)
   * @param rejectionResaon (optional)
   * @return Success
   */
  rejectMeeting(
    meetingId: number | undefined,
    rejectionResaon: string | undefined,
  ): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/RejectMeeting?";
    if (meetingId === null)
      throw new Error("The parameter 'meetingId' cannot be null.");
    else if (meetingId !== undefined)
      url_ += "MeetingId=" + encodeURIComponent("" + meetingId) + "&";
    if (rejectionResaon === null)
      throw new Error("The parameter 'rejectionResaon' cannot be null.");
    else if (rejectionResaon !== undefined)
      url_ +=
        "RejectionResaon=" + encodeURIComponent("" + rejectionResaon) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRejectMeeting(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRejectMeeting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processRejectMeeting(
    response: HttpResponseBase,
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param meetingId (optional)
   * @param cancelResaon (optional)
   * @return Success
   */
  cancelMeeting(
    meetingId: number | undefined,
    cancelResaon: string | undefined,
  ): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/CancelMeeting?";
    if (meetingId === null)
      throw new Error("The parameter 'meetingId' cannot be null.");
    else if (meetingId !== undefined)
      url_ += "MeetingId=" + encodeURIComponent("" + meetingId) + "&";
    if (cancelResaon === null)
      throw new Error("The parameter 'cancelResaon' cannot be null.");
    else if (cancelResaon !== undefined)
      url_ += "CancelResaon=" + encodeURIComponent("" + cancelResaon) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCancelMeeting(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCancelMeeting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processCancelMeeting(
    response: HttpResponseBase,
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param meetingId (optional)
   * @param cancelResaon (optional)
   * @return Success
   */
  postponeMeeting(
    meetingId: number | undefined,
    cancelResaon: string | undefined,
  ): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/PostponeMeeting?";
    if (meetingId === null)
      throw new Error("The parameter 'meetingId' cannot be null.");
    else if (meetingId !== undefined)
      url_ += "MeetingId=" + encodeURIComponent("" + meetingId) + "&";
    if (cancelResaon === null)
      throw new Error("The parameter 'cancelResaon' cannot be null.");
    else if (cancelResaon !== undefined)
      url_ += "CancelResaon=" + encodeURIComponent("" + cancelResaon) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPostponeMeeting(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPostponeMeeting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processPostponeMeeting(
    response: HttpResponseBase,
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  heldMeeting(body: HeldMeetingModel | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/Meeting/HeldMeeting";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processHeldMeeting(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processHeldMeeting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processHeldMeeting(
    response: HttpResponseBase,
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class MeetingTypeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param keyword (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<MeetingTypeDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/MeetingType/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<MeetingTypeDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MeetingTypeDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<MeetingTypeDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingTypeDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateMeetingTypeDto | undefined): Observable<MeetingTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/MeetingType/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MeetingTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MeetingTypeDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<MeetingTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: MeetingTypeDto | undefined): Observable<MeetingTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/MeetingType/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MeetingTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MeetingTypeDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<MeetingTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<MeetingTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/MeetingType/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MeetingTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MeetingTypeDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<MeetingTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MeetingTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/MeetingType/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ApplicationActionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateApplicationActionDto | undefined,
  ): Observable<ApplicationActionDto> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationAction/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ApplicationActionDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ApplicationActionDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<ApplicationActionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationActionDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<ApplicationActionDto> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationAction/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ApplicationActionDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ApplicationActionDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<ApplicationActionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationActionDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param applicationId (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    applicationId: number | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ApplicationActionDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationAction/GetAll?";
    if (applicationId === null)
      throw new Error("The parameter 'applicationId' cannot be null.");
    else if (applicationId !== undefined)
      url_ += "ApplicationId=" + encodeURIComponent("" + applicationId) + "&";
    if (sorting === null)
      throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined)
      url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ApplicationActionDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ApplicationActionDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<ApplicationActionDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationActionDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(
    body: ApplicationActionDto | undefined,
  ): Observable<ApplicationActionDto> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationAction/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ApplicationActionDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ApplicationActionDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<ApplicationActionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationActionDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/ApplicationAction/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export class ApplicationActionTypeDto implements IApplicationActionTypeDto {
  id: number;
  code: number;
  title: string | undefined;
  description: string | undefined;

  constructor(data?: IApplicationActionTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.title = _data["title"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): ApplicationActionTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new ApplicationActionTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["title"] = this.title;
    data["description"] = this.description;
    return data;
  }

  clone(): ApplicationActionTypeDto {
    const json = this.toJSON();
    let result = new ApplicationActionTypeDto();
    result.init(json);
    return result;
  }
}

export class ApplicationActionDto implements IApplicationActionDto {
  id: number;
  applicationId: number;
  actionTypeId: number;
  actionTypeName: string | undefined;
  actionDate: Date;
  actionDateText: string | undefined;
  actionDescription: string | undefined;
  followUpDescriptions: string | undefined;
  followUpDate: Date | undefined;
  followUpDateText: string | undefined;
  hasExpertAlarm: boolean;
  hasApplicantAlarm: boolean;

  constructor(data?: IApplicationActionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.applicationId = _data["applicationId"];
      this.actionTypeId = _data["actionTypeId"];
      this.actionTypeName = _data["actionTypeName"];
      this.actionDate = _data["actionDate"];
      this.actionDateText = _data["actionDateText"];
      this.actionDescription = _data["actionDescription"];
      this.followUpDescriptions = _data["followUpDescriptions"];
      this.followUpDate = _data["followUpDate"];
      this.followUpDateText = _data["followUpDateText"];
      this.hasExpertAlarm = _data["hasExpertAlarm"];
      this.hasApplicantAlarm = _data["hasApplicantAlarm"];
    }
  }

  static fromJS(data: any): ApplicationActionDto {
    data = typeof data === "object" ? data : {};
    let result = new ApplicationActionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["applicationId"] = this.applicationId;
    data["actionTypeName"] = this.actionTypeName;
    data["actionTypeId"] = this.actionTypeId;
    data["actionDate"] = this.actionDate;
    data["actionDateText"] = this.actionDateText;
    data["actionDescription"] = this.actionDescription;
    data["followUpDescriptions"] = this.followUpDescriptions;
    data["followUpDate"] = this.followUpDate;
    data["followUpDateText"] = this.followUpDateText;
    data["hasExpertAlarm"] = this.hasExpertAlarm;
    data["hasApplicantAlarm"] = this.hasApplicantAlarm;
    return data;
  }

  clone(): ApplicationActionDto {
    const json = this.toJSON();
    let result = new ApplicationActionDto();
    result.init(json);
    return result;
  }
}

export interface IApplicationActionDto {
  id: number;
  applicationId: number;
  actionTypeId: number;
  actionTypeName: string | undefined;
  actionDate: Date;
  actionDateText: string | undefined;
  actionDescription: string | undefined;
  followUpDescriptions: string | undefined;
  followUpDate: Date | undefined;
  followUpDateText: string | undefined;
  hasExpertAlarm: boolean;
  hasApplicantAlarm: boolean;
}

export class ApplicationActionDtoPagedResultDto implements IApplicationActionDtoPagedResultDto {
  items: ApplicationActionDto[] | undefined;
  totalCount: number;

  constructor(data?: IApplicationActionDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ApplicationActionDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ApplicationActionDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ApplicationActionDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): ApplicationActionDtoPagedResultDto {
    const json = this.toJSON();
    let result = new ApplicationActionDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export class CreateApplicationActionDto implements ICreateApplicationActionDto {
  applicationId: number;
  actionTypeId: number;
  actionDate: Date;
  actionDescription: string | undefined;
  followUpDescriptions: string | undefined;
  followUpDate: Date | null;
  hasExpertAlarm: boolean;
  hasApplicantAlarm: boolean;
  isSuccess: boolean;

  constructor(data?: ICreateApplicationActionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.applicationId = _data["applicationId"];
      this.actionTypeId = _data["actionTypeId"];
      this.actionDate = _data["actionDate"];
      this.actionDescription = _data["actionDescription"];
      this.followUpDescriptions = _data["followUpDescriptions"];
      this.followUpDate = _data["followUpDate"];
      this.hasExpertAlarm = _data["hasExpertAlarm"];
      this.hasApplicantAlarm = _data["hasApplicantAlarm"];
      this.isSuccess = _data["isSuccess"];
    }
  }

  static fromJS(data: any): CreateApplicationActionDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateApplicationActionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["applicationId"] = this.applicationId;
    data["actionTypeId"] = this.actionTypeId;
    data["actionDate"] = this.actionDate;
    data["actionDescription"] = this.actionDescription;
    data["followUpDescriptions"] = this.followUpDescriptions;
    data["followUpDate"] = this.followUpDate;
    data["hasExpertAlarm"] = this.hasExpertAlarm;
    data["hasApplicantAlarm"] = this.hasApplicantAlarm;
    data["isSuccess"] = this.isSuccess;
    return data;
  }

  clone(): CreateApplicationActionDto {
    const json = this.toJSON();
    let result = new CreateApplicationActionDto();
    result.init(json);
    return result;
  }
}

export interface ICreateApplicationActionDto {
  applicationId: number;
  actionTypeId: number;
  actionDate: Date;
  actionDescription: string | undefined;
  followUpDescriptions: string | undefined;
  followUpDate: Date | null;
  hasExpertAlarm: boolean;
  hasApplicantAlarm: boolean;
  isSuccess: boolean;
}

export interface IApplicationActionDtoPagedResultDto {
  items: ApplicationActionDto[] | undefined;
  totalCount: number;
}

export interface IApplicationActionTypeDto {
  id: number;
  code: number;
  title: string | undefined;
  description: string | undefined;
}

export class CreateApplicationActionTypeDto implements ICreateApplicationActionTypeDto {
  title: string | undefined;
  description: string | undefined;

  constructor(data?: ICreateApplicationActionTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): CreateApplicationActionTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateApplicationActionTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    data["description"] = this.description;
    return data;
  }

  clone(): CreateApplicationActionTypeDto {
    const json = this.toJSON();
    let result = new CreateApplicationActionTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICreateApplicationActionTypeDto {
  title: string | undefined;
  description: string | undefined;
}

export class ApplicationActionTypeDtoPagedResultDto implements IApplicationActionTypeDtoPagedResultDto {
  items: ApplicationActionTypeDto[] | undefined;
  totalCount: number;

  constructor(data?: IApplicationActionTypeDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ApplicationActionTypeDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ApplicationActionTypeDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ApplicationActionTypeDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): ApplicationActionTypeDtoPagedResultDto {
    const json = this.toJSON();
    let result = new ApplicationActionTypeDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IApplicationActionTypeDtoPagedResultDto {
  items: ApplicationActionTypeDto[] | undefined;
  totalCount: number;
}

export class MeetingDto implements IMeetingDto {
  id: number;
  meetingSlotId: number;
  applicationId: number | undefined;
  applicantId: number;
  applicantName: string;
  subject: string | undefined;
  expertId: number;
  expertName: string;
  sessionDate: string;
  startTime: string;
  endTime: string;
  duration: number;
  requestDescription: string | undefined;
  sessionDescription: string | undefined;
  meetingInfo: string | undefined;
  meetingTypeId: number;
  meetingTypeName: string;
  status: MeetingStatus;
  isExpert: boolean;

  constructor(data?: IMeetingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.meetingSlotId = _data["meetingSlotId"];
      this.applicationId = _data["applicationId"];
      this.applicantId = _data["applicantId"];
      this.applicantName = _data["applicantName"];
      this.subject = _data["subject"];
      this.expertId = _data["expertId"];
      this.expertName = _data["expertName"];
      this.sessionDate = _data["sessionDate"];
      this.startTime = _data["startTime"];
      this.endTime = _data["endTime"];
      this.duration = _data["duration"];
      this.requestDescription = _data["requestDescription"];
      this.sessionDescription = _data["sessionDescription"];
      this.meetingInfo = _data["meetingInfo"];
      this.meetingTypeId = _data["meetingTypeId"];
      this.meetingTypeName = _data["meetingTypeName"];
      this.status = _data["status"];
      this.isExpert = _data["isExpert"];
    }
  }

  static fromJS(data: any): MeetingDto {
    data = typeof data === "object" ? data : {};
    let result = new MeetingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["meetingSlotId"] = this.meetingSlotId;
    data["applicationId"] = this.applicationId;
    data["applicantId"] = this.applicantId;
    data["applicantName"] = this.applicantName;
    data["subject"] = this.subject;
    data["expertId"] = this.expertId;
    data["expertName"] = this.expertName;
    data["sessionDate"] = this.sessionDate;
    data["startTime"] = this.startTime;
    data["endTime"] = this.endTime;
    data["duration"] = this.duration;
    data["requestDescription"] = this.requestDescription;
    data["sessionDescription"] = this.sessionDescription;
    data["meetingInfo"] = this.meetingInfo;
    data["meetingTypeId"] = this.meetingTypeId;
    data["meetingTypeName"] = this.meetingTypeName;
    data["status"] = this.status;
    data["isExpert"] = this.isExpert;
    return data;
  }

  clone(): MeetingDto {
    const json = this.toJSON();
    let result = new MeetingDto();
    result.init(json);
    return result;
  }
}

export interface IMeetingDto {
  id: number;
  meetingSlotId: number;
  applicationId: number | undefined;
  applicantId: number;
  applicantName: string;
  subject: string | undefined;
  expertId: number;
  expertName: string;
  sessionDate: string;
  startTime: string;
  endTime: string;
  duration: number;
  requestDescription: string | undefined;
  sessionDescription: string | undefined;
  meetingInfo: string | undefined;
  meetingTypeId: number;
  meetingTypeName: string;
  status: MeetingStatus;
  isExpert: boolean;
}

export class MeetingDtoPagedResultDto implements IMeetingDtoPagedResultDto {
  items: MeetingDto[] | undefined;
  totalCount: number;

  constructor(data?: IMeetingDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(MeetingDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): MeetingDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new MeetingDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): MeetingDtoPagedResultDto {
    const json = this.toJSON();
    let result = new MeetingDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IMeetingDtoPagedResultDto {
  items: MeetingDto[] | undefined;
  totalCount: number;
}

export enum MeetingStatus {
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
  CANCELED = 4,
  POSTPONED = 5,
  HELD = 6,
}

export class ReserveMeetingDto implements IReserveMeetingDto {
  meetingSlotId: number;
  applicationId: number | undefined;
  subject: string | undefined;
  duration: number | undefined;
  requestDescription: string | undefined;
  meetingTypeId: number;

  constructor(data?: IReserveMeetingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.meetingSlotId = _data["meetingSlotId"];
      this.applicationId = _data["applicationId"];
      this.subject = _data["subject"];
      this.duration = _data["duration"];
      this.requestDescription = _data["requestDescription"];
      this.meetingTypeId = _data["meetingTypeId"];
    }
  }

  static fromJS(data: any): ReserveMeetingDto {
    data = typeof data === "object" ? data : {};
    let result = new ReserveMeetingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["meetingSlotId"] = this.meetingSlotId;
    data["applicationId"] = this.applicationId;
    data["subject"] = this.subject;
    data["duration"] = this.duration;
    data["requestDescription"] = this.requestDescription;
    data["meetingTypeId"] = this.meetingTypeId;
    return data;
  }

  clone(): ReserveMeetingDto {
    const json = this.toJSON();
    let result = new ReserveMeetingDto();
    result.init(json);
    return result;
  }
}

export interface IReserveMeetingDto {
  meetingSlotId: number;
  applicationId: number | undefined;
  subject: string | undefined;
  duration: number | undefined;
  requestDescription: string | undefined;
  meetingTypeId: number;
}

export class CreateMeetingDto implements ICreateMeetingDto {
  constructor(data?: ICreateMeetingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): CreateMeetingDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateMeetingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }

  clone(): CreateMeetingDto {
    const json = this.toJSON();
    let result = new CreateMeetingDto();
    result.init(json);
    return result;
  }
}

export interface ICreateMeetingDto {}

export class HeldMeetingModel implements IHeldMeetingModel {
  meetingId: number;
  sessionDescription: string;
  meetingInfo: string;
  startTime: string;
  endTime: string;

  constructor(data?: IHeldMeetingModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.meetingId = _data["meetingId"];
      this.sessionDescription = _data["sessionDescription"];
      this.meetingInfo = _data["meetingInfo"];
      this.startTime = _data["startTime"];
      this.endTime = _data["endTime"];
    }
  }

  static fromJS(data: any): HeldMeetingModel {
    data = typeof data === "object" ? data : {};
    let result = new HeldMeetingModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["meetingId"] = this.meetingId;
    data["sessionDescription"] = this.sessionDescription;
    data["meetingInfo"] = this.meetingInfo;
    data["startTime"] = this.startTime;
    data["endTime"] = this.endTime;
    return data;
  }

  clone(): HeldMeetingModel {
    const json = this.toJSON();
    let result = new HeldMeetingModel();
    result.init(json);
    return result;
  }
}

export interface IHeldMeetingModel {
  meetingId: number;
  sessionDescription: string;
  meetingInfo: string;
  startTime: string;
  endTime: string;
}

export class CreateMeetingTypeDto implements ICreateMeetingTypeDto {
  title: string | undefined;
  description: string | undefined;

  constructor(data?: ICreateMeetingTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): CreateMeetingTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateMeetingTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    data["description"] = this.description;
    return data;
  }

  clone(): CreateMeetingTypeDto {
    const json = this.toJSON();
    let result = new CreateMeetingTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICreateMeetingTypeDto {
  title: string | undefined;
  description: string | undefined;
}

export class MeetingTypeDtoPagedResultDto implements IMeetingTypeDtoPagedResultDto {
  items: MeetingTypeDto[] | undefined;
  totalCount: number;

  constructor(data?: IMeetingTypeDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(MeetingTypeDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): MeetingTypeDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new MeetingTypeDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): MeetingTypeDtoPagedResultDto {
    const json = this.toJSON();
    let result = new MeetingTypeDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IMeetingTypeDtoPagedResultDto {
  items: MeetingTypeDto[] | undefined;
  totalCount: number;
}

export class MeetingTypeDto implements IMeetingTypeDto {
  id: number;
  code: number;
  title: string | undefined;
  description: string | undefined;

  constructor(data?: IMeetingTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.title = _data["title"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): MeetingTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new MeetingTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["title"] = this.title;
    data["description"] = this.description;
    return data;
  }

  clone(): MeetingTypeDto {
    const json = this.toJSON();
    let result = new MeetingTypeDto();
    result.init(json);
    return result;
  }
}

export interface IMeetingTypeDto {
  id: number;
  code: number;
  title: string | undefined;
  description: string | undefined;
}

@Injectable()
export class CaseReportServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getCaseFile(fileId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CaseReport/GetCaseFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCaseFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateCaseReportDto | undefined): Observable<CaseReportDto> {
    let url_ = this.baseUrl + "/api/services/app/CaseReport/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseReportDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseReportDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<CaseReportDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseReportDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<CaseReportDto> {
    let url_ = this.baseUrl + "/api/services/app/CaseReport/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseReportDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseReportDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<CaseReportDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseReportDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

     /**
     * @param caseId (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(caseId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CaseReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CaseReport/GetAll?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseReportDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CaseReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: CreateCaseReportDto | undefined): Observable<CaseReportDto> {
    let url_ = this.baseUrl + "/api/services/app/CaseReport/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseReportDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseReportDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<CaseReportDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseReportDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/CaseReport/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export class CreateCaseReportDto implements ICreateCaseReportDto {
  id: number;
  caseId: number;
  reportDate: Date;
  title: string | undefined;
  desc: string | undefined;
  files: CaseReporttFileCreateDto[] | undefined;

  constructor(data?: ICreateCaseReportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.caseId = _data["caseId"];
      this.reportDate = _data["reportDate"];
      this.title = _data["title"];
      this.desc = _data["desc"];
      if (Array.isArray(_data["files"])) {
        this.files = [] as any;
        for (let item of _data["files"])
          this.files.push(CaseReporttFileCreateDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreateCaseReportDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCaseReportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["caseId"] = this.caseId;
    data["reportDate"] = this.reportDate;
    data["title"] = this.title;
    data["desc"] = this.desc;
    if (Array.isArray(this.files)) {
      data["files"] = [];
      for (let item of this.files) data["files"].push(item.toJSON());
    }
    return data;
  }

  clone(): CreateCaseReportDto {
    const json = this.toJSON();
    let result = new CreateCaseReportDto();
    result.init(json);
    return result;
  }
}

export interface ICreateCaseReportDto {
  id: number;
  caseId: number;
  reportDate: Date;
  title: string | undefined;
  desc: string | undefined;
  files: CaseReporttFileCreateDto[] | undefined;
}

export class CaseReportDto implements ICaseReportDto {
  id: number;
  caseId: number;
  reportDate: string;
  title: string | undefined;
  desc: string | undefined;
  files: CaseReportFileDto[] | undefined;
  issuerUserId: number;
  issuerUserName: string | undefined;

  constructor(data?: ICaseReportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.caseId = _data["caseId"];
      this.reportDate = _data["reportDate"];
      this.title = _data["title"];
      this.desc = _data["desc"];
      if (Array.isArray(_data["files"])) {
        this.files = [] as any;
        for (let item of _data["files"])
          this.files.push(CaseReportFileDto.fromJS(item));
      }
      this.issuerUserId = _data["issuerUserId"];
      this.issuerUserName = _data["issuerUserName"];
    }
  }

  static fromJS(data: any): CaseReportDto {
    data = typeof data === "object" ? data : {};
    let result = new CaseReportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["caseId"] = this.caseId;
    data["reportDate"] = this.reportDate;
    data["title"] = this.title;
    data["desc"] = this.desc;
    if (Array.isArray(this.files)) {
      data["files"] = [];
      for (let item of this.files) data["files"].push(item.toJSON());
    }
    data["issuerUserId"] = this.issuerUserId;
    data["issuerUserName"] = this.issuerUserName;
    return data;
  }

  clone(): CaseReportDto {
    const json = this.toJSON();
    let result = new CaseReportDto();
    result.init(json);
    return result;
  }
}

export interface ICaseReportDto {
  id: number;
  caseId: number;
  reportDate: string;
  title: string | undefined;
  desc: string | undefined;
  files: CaseReportFileDto[] | undefined;
  issuerUserId: number;
  issuerUserName: string | undefined;
}

export class CaseReportDtoPagedResultDto implements ICaseReportDtoPagedResultDto {
  items: CaseReportDto[] | undefined;
  totalCount: number;

  constructor(data?: ICaseReportDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(CaseReportDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): CaseReportDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CaseReportDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): CaseReportDtoPagedResultDto {
    const json = this.toJSON();
    let result = new CaseReportDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ICaseReportDtoPagedResultDto {
  items: CaseReportDto[] | undefined;
  totalCount: number;
}

export class CaseReportFileDto implements ICaseReportFileDto {
  id: number;
  fileType: string | undefined;
  fileName: string | undefined;
  filesize: number | undefined;
  thumbnail: string;

  constructor(data?: ICaseReportFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.fileType = _data["fileType"];
      this.fileName = _data["fileName"];
      this.filesize = _data["filesize"];
      this.thumbnail = _data["thumbnail"];
    }
  }

  static fromJS(data: any): CaseReportFileDto {
    data = typeof data === "object" ? data : {};
    let result = new CaseReportFileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["fileType"] = this.fileType;
    data["fileName"] = this.fileName;
    data["filesize"] = this.filesize;
    data["thumbnail"] = this.thumbnail;
    return data;
  }

  clone(): CaseReportFileDto {
    const json = this.toJSON();
    let result = new CaseReportFileDto();
    result.init(json);
    return result;
  }
}

export interface ICaseReportFileDto {
  id: number;
  fileType: string | undefined;
  fileName: string | undefined;
  filesize: number | undefined;
  thumbnail: string;
}

export class CaseReporttFileCreateDto implements ICaseReporttFileCreateDto {
  fileType: string | undefined;
  fileName: string | undefined;
  filePath: string | undefined;
  filesize: number | undefined;
  id: number | undefined;

  constructor(data?: ICaseReporttFileCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileType = _data["fileType"];
      this.fileName = _data["fileName"];
      this.filePath = _data["filePath"];
      this.filesize = _data["filesize"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CaseReporttFileCreateDto {
    data = typeof data === "object" ? data : {};
    let result = new CaseReporttFileCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fileType"] = this.fileType;
    data["fileName"] = this.fileName;
    data["filePath"] = this.filePath;
    data["filesize"] = this.filesize;
    data["id"] = this.id;
    return data;
  }

  clone(): CaseReporttFileCreateDto {
    const json = this.toJSON();
    let result = new CaseReporttFileCreateDto();
    result.init(json);
    return result;
  }
}

export interface ICaseReporttFileCreateDto {
  fileType: string | undefined;
  fileName: string | undefined;
  filePath: string | undefined;
  filesize: number | undefined;
  id: number | undefined;
}

//#endregion

//#region  EducationalInstitution

@Injectable()
export class EducationalInstitutionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateEducationalInstitutionDto | undefined,
  ): Observable<EducationalInstitutionDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationalInstitution/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(
    body: EducationalInstitutionDto | undefined,
  ): Observable<EducationalInstitutionDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationalInstitution/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitution/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<EducationalInstitutionDto> {
    let url_ = this.baseUrl + "/api/services/app/EducationalInstitution/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    CountryId: number | undefined,
    ParentId: number | undefined,
    CityId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<EducationalInstitutionDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitution/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (CountryId === null)
      throw new Error("The parameter 'CountryId' cannot be null.");
    else if (CountryId !== undefined)
      url_ += "CountryId=" + encodeURIComponent("" + CountryId) + "&";
    if (ParentId === null)
      throw new Error("The parameter 'ParentId' cannot be null.");
    else if (ParentId !== undefined)
      url_ += "ParentId=" + encodeURIComponent("" + ParentId) + "&";
    if (CityId === null)
      throw new Error("The parameter 'CityId' cannot be null.");
    else if (CityId !== undefined)
      url_ += "CityId=" + encodeURIComponent("" + CityId) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            EducationalInstitutionDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateEducationalInstitutionDto implements ICreateEducationalInstitutionDto {
  Name: string;
  CountryId: number;
  parentId: number;
  cityId: number;
  EducationalInstitutionTypeId: number;

  constructor(data?: ICreateEducationalInstitutionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Name = _data["Name"];
      this.CountryId = _data["CountryId"];
      this.parentId = _data["parentId"];
      this.cityId = _data["cityId"];
      this.EducationalInstitutionTypeId = _data["EducationalInstitutionTypeId"];
    }
  }

  static fromJS(data: any): CreateEducationalInstitutionDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateEducationalInstitutionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.Name;
    data["countryId"] = this.CountryId;
    data["parentId"] = this.parentId;
    data["cityId"] = this.cityId;
    data["educationalInstitutionTypeId"] = this.EducationalInstitutionTypeId;
    return data;
  }

  clone(): CreateEducationalInstitutionDto {
    const json = this.toJSON();
    let result = new CreateEducationalInstitutionDto();
    result.init(json);
    return result;
  }
}

export interface ICreateEducationalInstitutionDto {
  Name: string;
  CountryId: number;
  parentId: number;
  cityId: number;
  EducationalInstitutionTypeId: number;
}

export class EducationalInstitutionDto implements IEducationalInstitutionDto {
  Id: number;
  parentId: number;
  ParentName: string;
  Name: string;
  CountryId: number;
  CountryName: string;
  cityId: number;
  cityName: string;
  EducationalInstitutionTypeId: number;
  EducationalInstitutionTypeName: string;

  constructor(data?: IEducationalInstitutionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["id"];
      this.parentId = _data["parentId"];
      this.ParentName = _data["parentName"];
      this.Name = _data["name"];
      this.CountryId = _data["countryId"];
      this.CountryName = _data["countryName"];
      this.cityId = _data["cityId"];
      this.cityName = _data["cityName"];
      this.EducationalInstitutionTypeId = _data["educationalInstitutionTypeId"];
      this.EducationalInstitutionTypeName =
        _data["educationalInstitutionTypeName"];
    }
  }

  static fromJS(data: any): EducationalInstitutionDto {
    data = typeof data === "object" ? data : {};
    let result = new EducationalInstitutionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["parentId"] = this.parentId;
    data["parentName"] = this.ParentName;
    data["name"] = this.Name;
    data["countryId"] = this.CountryId;
    data["countryName"] = this.CountryName;
    data["cityId"] = this.cityId;
    data["cityName"] = this.cityName;
    data["educationalInstitutionTypeId"] = this.EducationalInstitutionTypeId;
    data["educationalInstitutionTypeName"] =
      this.EducationalInstitutionTypeName;

    return data;
  }

  clone(): EducationalInstitutionDto {
    const json = this.toJSON();
    let result = new EducationalInstitutionDto();
    result.init(json);
    return result;
  }
}

export interface IEducationalInstitutionDto {
  Id: number;
  parentId: number;
  ParentName: string;
  Name: string;
  CountryId: number;
  CountryName: string;
  cityId: number;
  cityName: string;
  EducationalInstitutionTypeId: number;
  EducationalInstitutionTypeName: string;
}
export class EducationalInstitutionDtoPagedResultDto implements IEducationalInstitutionDtoPagedResultDto {
  items: EducationalInstitutionDto[] | undefined;
  totalCount: number;

  constructor(data?: IEducationalInstitutionDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(EducationalInstitutionDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): EducationalInstitutionDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new EducationalInstitutionDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): EducationalInstitutionDtoPagedResultDto {
    const json = this.toJSON();
    let result = new EducationalInstitutionDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IEducationalInstitutionDtoPagedResultDto {
  items: EducationalInstitutionDto[] | undefined;
  totalCount: number;
}

//#endregion

//#region FileType
@Injectable()
export class FileTypeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateFileTypeDto | undefined): Observable<FileTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/FileType/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileTypeDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<FileTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: FileTypeDto | undefined): Observable<FileTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/FileType/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileTypeDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<FileTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/FileType/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<FileTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/FileType/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileTypeDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<FileTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<FileTypeDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/FileType/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileTypeDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileTypeDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<FileTypeDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileTypeDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllScholarShipType(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<FileTypeDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/FileType/GetAllScholarShipType?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileTypeDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileTypeDtoPagedResultDto>;
        }),
      );
  }
}
export class CreateFileTypeDto implements ICreateFileTypeDto {
  name: string;
  code: number;
  option1: string;
  option2: string;
  option3: string;
  option4: string;

  constructor(data?: ICreateFileTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.code = _data["code"];
      this.option1 = _data["option1"];
      this.option2 = _data["option2"];
      this.option3 = _data["option3"];
      this.option4 = _data["option4"];
    }
  }

  static fromJS(data: any): CreateFileTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateFileTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["code"] = this.code;
    data["option1"] = this.option1;
    data["option2"] = this.option2;
    data["option3"] = this.option3;
    data["option4"] = this.option4;
    return data;
  }

  clone(): CreateFileTypeDto {
    const json = this.toJSON();
    let result = new CreateFileTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICreateFileTypeDto {
  name: string;
  code: number;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
}

export class FileTypeDto implements IFileTypeDto {
  id: number;
  name: string;
  code: number;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
  isScholarShip: boolean = false;

  constructor(data?: IFileTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.code = _data["code"];
      this.option1 = _data["option1"];
      this.option2 = _data["option2"];
      this.option3 = _data["option3"];
      this.option4 = _data["option4"];
      this.isScholarShip = _data["isScholarShip"];
    }
  }

  static fromJS(data: any): FileTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new FileTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["code"] = this.code;
    data["option1"] = this.option1;
    data["option2"] = this.option2;
    data["option3"] = this.option3;
    data["option4"] = this.option4;
    data["isScholarShip"] = this.isScholarShip;

    return data;
  }

  clone(): FileTypeDto {
    const json = this.toJSON();
    let result = new FileTypeDto();
    result.init(json);
    return result;
  }
}

export interface IFileTypeDto {
  id: number;
  name: string;
  code: number;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
  isScholarShip: boolean;
}
export class FileTypeDtoPagedResultDto implements IFileTypeDtoPagedResultDto {
  items: FileTypeDto[] | undefined;
  totalCount: number;

  constructor(data?: IFileTypeDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(FileTypeDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): FileTypeDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new FileTypeDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): FileTypeDtoPagedResultDto {
    const json = this.toJSON();
    let result = new FileTypeDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IFileTypeDtoPagedResultDto {
  items: FileTypeDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region Case

@Injectable()
export class CaseServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateCaseDto | undefined): Observable<CaseDto> {
    let url_ = this.baseUrl + "/api/services/app/Case/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CaseDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<CaseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  CreateMulti(body: CreateMultiCaseDto | undefined): Observable<CaseDto> {
    let url_ = this.baseUrl + "/api/services/app/Case/CreateMultiCase";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateMulti(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateMulti(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CaseDto>;
        }),
      );
  }

  protected processCreateMulti(
    response: HttpResponseBase,
  ): Observable<CaseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: CaseDto | undefined): Observable<CaseDto> {
    let url_ = this.baseUrl + "/api/services/app/Case/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CaseDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<CaseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Case/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<CaseDto> {
    let url_ = this.baseUrl + "/api/services/app/Case/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CaseDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<CaseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getAllForClientManagement(
    keyword: string | undefined,
    countryIds: number[],
    organizationUnitIds: number[],
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<CaseDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Case/GetAllForClientManagement?";
    if (countryIds !== undefined && countryIds.length > 0)
      url_ += "countryIds=" + JSON.stringify(countryIds) + "&";
    if (organizationUnitIds !== undefined && organizationUnitIds.length > 0)
      url_ +=
        "organizationUnitIds=" + JSON.stringify(organizationUnitIds) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllForClientManagement(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllForClientManagement(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<CaseDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllForClientManagement(
    response: HttpResponseBase,
  ): Observable<CaseDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  GetCaseCount(): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Case/GetCaseCount";

    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCaseCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCaseCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        }),
      );
  }

  protected processGetCaseCount(
    response: HttpResponseBase,
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<CaseDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Case/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<CaseDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<CaseDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateCaseDto implements ICreateCaseDto {
  userId: number;
  CreateCaseRequests: CreateCaseRequestsDto[] = [];

  constructor(data?: ICreateCaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      if (Array.isArray(_data["createCaseRequests"])) {
        this.CreateCaseRequests = [] as any;
        for (let item of _data["createCaseRequests"])
          this.CreateCaseRequests.push(item);
      }
    }
  }

  static fromJS(data: any): CreateCaseDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCaseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userId"] = this.userId;
    if (Array.isArray(this.CreateCaseRequests)) {
      data["createCaseRequests"] = [];
      for (let item of this.CreateCaseRequests)
        data["createCaseRequests"].push(item);
    }
    return data;
  }

  clone(): CreateCaseDto {
    const json = this.toJSON();
    let result = new CreateCaseDto();
    result.init(json);
    return result;
  }
}

export interface ICreateCaseDto {
  userId: number;
  CreateCaseRequests: CreateCaseRequestsDto[] | undefined;
}
export class CreateMultiCaseDto implements ICreateMultiCaseDto {
  UserId: number;
  UserName: string;
  Description: string;
  SelectionorganizationItem: SelectionorganizationItems[] | undefined;

  constructor(data?: ICreateMultiCaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.UserId = _data["UserId"];
      this.Description = _data["Description"];
      if (Array.isArray(_data["SelectionorganizationItem"])) {
        this.SelectionorganizationItem = [] as any;
        for (let item of _data["SelectionorganizationItem"])
          this.SelectionorganizationItem.push(item);
      }
    }
  }

  static fromJS(data: any): CreateMultiCaseDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateMultiCaseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userId"] = this.UserId;
    data["description"] = this.Description;
    if (Array.isArray(this.SelectionorganizationItem)) {
      data["selectionorganizationItem"] = [];
      for (let item of this.SelectionorganizationItem)
        data["selectionorganizationItem"].push(item);
    }
    return data;
  }

  clone(): CreateMultiCaseDto {
    const json = this.toJSON();
    let result = new CreateMultiCaseDto();
    result.init(json);
    return result;
  }
}

export interface ICreateMultiCaseDto {
  UserId: number;
  UserName: string;
  Description: string;
  SelectionorganizationItem: SelectionorganizationItems[] | undefined;
}

export class CaseDto implements ICaseDto {
  Id: number;
  UserId: number;
  user: UserDto = new UserDto();

  constructor(data?: ICaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["id"];
      this.user = _data["user"];
      this.UserId = _data["userId"];
    }
  }

  static fromJS(data: any): CaseDto {
    data = typeof data === "object" ? data : {};
    let result = new CaseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["user"] = this.user;
    data["userId"] = this.UserId;
    return data;
  }

  clone(): CaseDto {
    const json = this.toJSON();
    let result = new CaseDto();
    result.init(json);
    return result;
  }
}

export interface ICaseDto {
  Id: number;
  UserId: number;
  user: UserDto | undefined;
}
export class CaseDtoPagedResultDto implements ICaseDtoPagedResultDto {
  items: CaseDto[] | undefined;
  totalCount: number;

  constructor(data?: ICaseDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(CaseDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): CaseDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CaseDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): CaseDtoPagedResultDto {
    const json = this.toJSON();
    let result = new CaseDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ICaseDtoPagedResultDto {
  items: CaseDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region  EducationalInstitutionType

@Injectable()
export class EducationalInstitutionTypeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateEducationalInstitutionTypeDto | undefined,
  ): Observable<EducationalInstitutionTypeDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionType/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionTypeDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(
    body: EducationalInstitutionTypeDto | undefined,
  ): Observable<EducationalInstitutionTypeDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionType/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionTypeDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionType/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<EducationalInstitutionTypeDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionType/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionTypeDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<EducationalInstitutionTypeDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionType/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionTypeDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionTypeDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionTypeDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            EducationalInstitutionTypeDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateEducationalInstitutionTypeDto implements ICreateEducationalInstitutionTypeDto {
  Name: string;

  constructor(data?: ICreateEducationalInstitutionTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Name = _data["name"];
    }
  }

  static fromJS(data: any): CreateEducationalInstitutionTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateEducationalInstitutionTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.Name;
    return data;
  }

  clone(): CreateEducationalInstitutionTypeDto {
    const json = this.toJSON();
    let result = new CreateEducationalInstitutionTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICreateEducationalInstitutionTypeDto {
  Name: string;
}

export class EducationalInstitutionTypeDto implements IEducationalInstitutionTypeDto {
  Id: number;
  Name: string;

  constructor(data?: IEducationalInstitutionTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["id"];
      this.Name = _data["name"];
    }
  }

  static fromJS(data: any): EducationalInstitutionTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new EducationalInstitutionTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["name"] = this.Name;

    return data;
  }

  clone(): EducationalInstitutionTypeDto {
    const json = this.toJSON();
    let result = new EducationalInstitutionTypeDto();
    result.init(json);
    return result;
  }
}

export interface IEducationalInstitutionTypeDto {
  Id: number;
  Name: string;
}
export class EducationalInstitutionTypeDtoPagedResultDto implements IEducationalInstitutionTypeDtoPagedResultDto {
  items: EducationalInstitutionTypeDto[] | undefined;
  totalCount: number;

  constructor(data?: IEducationalInstitutionTypeDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(EducationalInstitutionTypeDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): EducationalInstitutionTypeDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new EducationalInstitutionTypeDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): EducationalInstitutionTypeDtoPagedResultDto {
    const json = this.toJSON();
    let result = new EducationalInstitutionTypeDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IEducationalInstitutionTypeDtoPagedResultDto {
  items: EducationalInstitutionTypeDto[] | undefined;
  totalCount: number;
}

//#endregion

//#region CaseRequests
@Injectable()
export class CaseRequestsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateCaseRequestsDto | undefined): Observable<CaseRequestsDto> {
    let url_ = this.baseUrl + "/api/services/app/CaseRequests/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseRequestsDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseRequestsDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<CaseRequestsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseRequestsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: CaseRequestsDto | undefined): Observable<CaseRequestsDto> {
    let url_ = this.baseUrl + "/api/services/app/CaseRequests/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseRequestsDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseRequestsDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<CaseRequestsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseRequestsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/CaseRequests/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<CaseRequestsDto> {
    let url_ = this.baseUrl + "/api/services/app/CaseRequests/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CaseRequestsDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseRequestsDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<CaseRequestsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseRequestsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<CaseRequestsDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/CaseRequests/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<CaseRequestsDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseRequestsDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<CaseRequestsDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseRequestsDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllByCaseId(
    keyword: string | undefined,
    CaseId: number | undefined,
    countryIds: number[],
    organizationUnitIds: number[],
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<CaseRequestsDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/CaseRequests/getAllByCaseId?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (CaseId === null)
      throw new Error("The parameter 'CaseId' cannot be null.");
    else if (CaseId !== undefined)
      url_ += "CaseId=" + encodeURIComponent("" + CaseId) + "&";
    if (countryIds !== undefined && countryIds.length > 0)
      url_ += "countryIds=" + encodeURIComponent("" + countryIds) + "&";
    if (organizationUnitIds !== undefined && organizationUnitIds.length > 0)
      url_ +=
        "organizationUnitIds=" +
        encodeURIComponent("" + organizationUnitIds) +
        "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllByCaseId(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllByCaseId(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<CaseRequestsDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseRequestsDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllByCaseId(
    response: HttpResponseBase,
  ): Observable<CaseRequestsDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseRequestsDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getAllByLoginedExpert(
    keyword: string | undefined,
    countryIds: number[],
    organizationUnitIds: number[],
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<CaseRequestsDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/CaseRequests/GetAllByLoginedExpert?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (countryIds !== undefined && countryIds.length > 0)
      url_ += "countryIds=" + encodeURIComponent("" + countryIds) + "&";
    if (organizationUnitIds !== undefined && organizationUnitIds.length > 0)
      url_ +=
        "organizationUnitIds=" +
        encodeURIComponent("" + organizationUnitIds) +
        "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllByLoginedExpert(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllByLoginedExpert(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<CaseRequestsDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CaseRequestsDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllByLoginedExpert(
    response: HttpResponseBase,
  ): Observable<CaseRequestsDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CaseRequestsDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  GetCaseRequestCount(): Observable<number> {
    let url_ =
      this.baseUrl + "/api/services/app/CaseRequests/GetCaseRequestCount";

    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCaseRequestCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCaseRequestCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        }),
      );
  }

  protected processGetCaseRequestCount(
    response: HttpResponseBase,
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateCaseRequestsDto implements ICreateCaseRequestsDto {
  CaseId: number;
  organizationUnitIds: number[] = [];
  countryIds: number[] = [];
  Description: string;

  constructor(data?: ICreateCaseRequestsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.CaseId = _data["caseId"];
      if (Array.isArray(_data["countryIds"])) {
        this.countryIds = [] as any;
        for (let item of _data["countryIds"]) this.countryIds.push(item);
      }
      if (Array.isArray(_data["organizationUnitIds"])) {
        this.organizationUnitIds = [] as any;
        for (let item of _data["organizationUnitIds"])
          this.organizationUnitIds.push(item);
      }
      this.Description = _data["description"];
    }
  }

  static fromJS(data: any): CreateCaseRequestsDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCaseRequestsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["caseId"] = this.CaseId;
    if (Array.isArray(this.countryIds)) {
      data["countryIds"] = [];
      for (let item of this.countryIds) data["countryIds"].push(item);
    }
    if (Array.isArray(this.organizationUnitIds)) {
      data["organizationUnitIds"] = [];
      for (let item of this.organizationUnitIds)
        data["organizationUnitIds"].push(item);
    }
    data["description"] = this.Description;
    return data;
  }

  clone(): CreateCaseRequestsDto {
    const json = this.toJSON();
    let result = new CreateCaseRequestsDto();
    result.init(json);
    return result;
  }
}

export interface ICreateCaseRequestsDto {
  CaseId: number;
  organizationUnitIds: number[];
  countryIds: number[];
  Description: string;
}

export class CaseRequestsDto implements ICaseRequestsDto {
  Id: number;
  CaseId: number;
  OrganizationUnitId: number;
  organizationUnitCode: string;
  OrganizationUnitName: string;
  CountryId: number;
  CountryName: string;
  userName: string;
  userId: number;
  Description: string;
  HaveLayer: boolean = false;
  organizationUnitIds: number[];
  countryIds: number[];

  constructor(data?: ICaseRequestsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["id"];
      this.CaseId = _data["caseId"];
      this.OrganizationUnitId = _data["organizationUnitId"];
      this.organizationUnitCode = _data["organizationUnitCode"];
      this.OrganizationUnitName = _data["organizationUnitName"];
      this.CountryId = _data["countryId"];
      this.userName = _data["userName"];
      this.userId = _data["userId"];
      this.CountryName = _data["countryName"];
      this.Description = _data["description"];
      this.HaveLayer = _data["haveLayer"];
      if (Array.isArray(_data["countryIds"])) {
        this.countryIds = [] as any;
        for (let item of _data["countryIds"]) this.countryIds.push(item);
      }
      if (Array.isArray(_data["organizationUnitIds"])) {
        this.organizationUnitIds = [] as any;
        for (let item of _data["organizationUnitIds"])
          this.organizationUnitIds.push(item);
      }
    }
  }

  static fromJS(data: any): CaseRequestsDto {
    data = typeof data === "object" ? data : {};
    let result = new CaseRequestsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["caseId"] = this.CaseId;
    data["userId"] = this.userId;
    data["organizationUnitId"] = this.OrganizationUnitId;
    data["organizationUnitCode"] = this.organizationUnitCode;
    data["organizationUnitName"] = this.OrganizationUnitName;
    data["countryId"] = this.CountryId;
    data["countryName"] = this.CountryName;
    data["userName"] = this.userName;
    data["description"] = this.Description;
    data["haveLayer"] = this.HaveLayer;
    if (Array.isArray(this.countryIds)) {
      data["countryIds"] = [];
      for (let item of this.countryIds) data["countryIds"].push(item);
    }
    if (Array.isArray(this.organizationUnitIds)) {
      data["organizationUnitIds"] = [];
      for (let item of this.organizationUnitIds)
        data["organizationUnitIds"].push(item);
    }

    return data;
  }

  clone(): CaseRequestsDto {
    const json = this.toJSON();
    let result = new CaseRequestsDto();
    result.init(json);
    return result;
  }
}

export interface ICaseRequestsDto {
  Id: number;
  CaseId: number;
  userId: number;
  OrganizationUnitId: number;
  organizationUnitCode: string;
  CountryId: number;
  Description: string;
  userName: string;
  HaveLayer: boolean;
  organizationUnitIds: number[];
  countryIds: number[];
}
export class CaseRequestsDtoPagedResultDto implements ICaseRequestsDtoPagedResultDto {
  items: CaseRequestsDto[] | undefined;
  totalCount: number;

  constructor(data?: ICaseRequestsDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(CaseRequestsDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): CaseRequestsDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CaseRequestsDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): CaseRequestsDtoPagedResultDto {
    const json = this.toJSON();
    let result = new CaseRequestsDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ICaseRequestsDtoPagedResultDto {
  items: CaseRequestsDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region FileUploadRequest
@Injectable()
export class FileUploadRequestServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateFileUploadRequestDto | undefined,
  ): Observable<FileUploadRequestDto> {
    let url_ = this.baseUrl + "/api/services/app/FileUploadRequest/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileUploadRequestDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileUploadRequestDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<FileUploadRequestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileUploadRequestDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(
    body: FileUploadRequestDto | undefined,
  ): Observable<FileUploadRequestDto> {
    let url_ = this.baseUrl + "/api/services/app/FileUploadRequest/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileUploadRequestDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileUploadRequestDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<FileUploadRequestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileUploadRequestDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  UploadRequest(
    body: CreateFileUploadRequestFileDto | undefined,
  ): Observable<boolean> {
    let url_ =
      this.baseUrl + "/api/services/app/FileUploadRequest/UpdateRequestFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadRequest(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else
            return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processUploadRequest(
    response: HttpResponseBase,
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/FileUploadRequest/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<FileUploadRequestDto> {
    let url_ = this.baseUrl + "/api/services/app/FileUploadRequest/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileUploadRequestDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileUploadRequestDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<FileUploadRequestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileUploadRequestDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    CaseId: number | undefined,
    CaseRequestId: number | undefined,
    EducationalInstitutionLayerId: number | undefined,
    FileTypeId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<FileUploadRequestDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/FileUploadRequest/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (CaseId === null)
      throw new Error("The parameter 'CaseId' cannot be null.");
    else if (CaseId !== undefined)
      url_ += "CaseId=" + encodeURIComponent("" + CaseId) + "&";
    if (CaseRequestId === null)
      throw new Error("The parameter 'CaseRequestId' cannot be null.");
    else if (CaseRequestId !== undefined)
      url_ += "CaseRequestId=" + encodeURIComponent("" + CaseRequestId) + "&";
    if (EducationalInstitutionLayerId === null)
      throw new Error(
        "The parameter 'EducationalInstitutionLayerId' cannot be null.",
      );
    else if (EducationalInstitutionLayerId !== undefined)
      url_ +=
        "EducationalInstitutionLayerId=" +
        encodeURIComponent("" + EducationalInstitutionLayerId) +
        "&";
    if (FileTypeId === null)
      throw new Error("The parameter 'FileTypeId' cannot be null.");
    else if (FileTypeId !== undefined)
      url_ += "FileTypeId=" + encodeURIComponent("" + FileTypeId) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileUploadRequestDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileUploadRequestDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<FileUploadRequestDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileUploadRequestDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  GetCurrentCustomerFileUploadRequestCount(): Observable<number> {
    let url_ =
      this.baseUrl +
      "/api/services/app/FileUploadRequest/GetCurrentCustomerFileUploadRequestCount";

    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentCustomerFileUploadRequestCount(
            response_,
          );
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentCustomerFileUploadRequestCount(
                response_ as any,
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        }),
      );
  }

  protected processGetCurrentCustomerFileUploadRequestCount(
    response: HttpResponseBase,
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllByCurrentCustomer(
    keyword: string | undefined,
    FileTypeId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<FileUploadRequestDtoPagedResultDto> {
    let url_ =
      this.baseUrl +
      "/api/services/app/FileUploadRequest/getAllByCurrentCustomer?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (FileTypeId === null)
      throw new Error("The parameter 'FileTypeId' cannot be null.");
    else if (FileTypeId !== undefined)
      url_ += "FileTypeId=" + encodeURIComponent("" + FileTypeId) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllByCurrentCustomer(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllByCurrentCustomer(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileUploadRequestDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileUploadRequestDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllByCurrentCustomer(
    response: HttpResponseBase,
  ): Observable<FileUploadRequestDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileUploadRequestDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateFileUploadRequestDto implements ICreateFileUploadRequestDto {
  CreateMethod: number;
  RequesterUserId: number;
  UploaderUserId: number;
  IsUploaded: boolean;
  UploadConfirmed: boolean;
  ConfirmUserId: number;
  UploadRejected: boolean;
  RejectUserId: number;
  RejectReason: string;
  FileTypeId: number;
  CaseId: number;
  EducationalInstitutionLayerId: number;
  Description: string;
  UploaderUserDescription: string;

  constructor(data?: ICreateFileUploadRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.CreateMethod = _data["createMethod"];
      this.RequesterUserId = _data["requesterUserId"];
      this.UploaderUserId = _data["uploaderUserId"];
      this.IsUploaded = _data["isUploaded"];
      this.UploadConfirmed = _data["uploadConfirmed"];
      this.ConfirmUserId = _data["confirmUserId"];
      this.UploadRejected = _data["uploadRejected"];
      this.RejectUserId = _data["rejectUserId"];
      this.RejectReason = _data["rejectReason"];
      this.FileTypeId = _data["fileTypeId"];
      this.CaseId = _data["caseId"];
      this.EducationalInstitutionLayerId =
        _data["educationalInstitutionLayerId"];
      this.Description = _data["description"];
      this.UploaderUserDescription = _data["uploaderUserDescription"];
    }
  }

  static fromJS(data: any): CreateFileUploadRequestDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateFileUploadRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["createMethod"] = this.CreateMethod;
    data["requesterUserId"] = this.RequesterUserId;
    data["uploaderUserId"] = this.UploaderUserId;
    data["isUploaded"] = this.IsUploaded;
    data["uploadConfirmed"] = this.UploadConfirmed;
    data["confirmUserId"] = this.ConfirmUserId;
    data["uploadRejected"] = this.UploadRejected;
    data["rejectUserId"] = this.RejectUserId;
    data["rejectReason"] = this.RejectReason;
    data["fileTypeId"] = this.FileTypeId;
    data["caseId"] = this.CaseId;
    data["educationalInstitutionLayerId"] = this.EducationalInstitutionLayerId;
    data["description"] = this.Description;
    data["uploaderUserDescription"] = this.UploaderUserDescription;
    return data;
  }

  clone(): CreateFileUploadRequestDto {
    const json = this.toJSON();
    let result = new CreateFileUploadRequestDto();
    result.init(json);
    return result;
  }
}

export interface ICreateFileUploadRequestDto {
  CreateMethod: number;
  RequesterUserId: number;
  UploaderUserId: number;
  IsUploaded: boolean;
  UploadConfirmed: boolean;
  ConfirmUserId: number;
  UploadRejected: boolean;
  RejectUserId: number;
  RejectReason: string;
  FileTypeId: number;
  CaseId: number;
  EducationalInstitutionLayerId: number;
  Description: string;
  UploaderUserDescription: string;
}

export class FileUploadRequestDto implements IFileUploadRequestDto {
  Id: number;
  CreateMethod: number;
  RequesterUserId: number;
  UploaderUserId: number;
  IsUploaded: boolean;
  UploadConfirmed: boolean;
  ConfirmUserId: number;
  UploadRejected: boolean;
  RejectUserId: number;
  RejectReason: string;
  FileTypeId: number;
  FileTypeName: string;
  CaseId: number;
  Description: string;
  UploaderUserDescription: string;
  FirstFilePath: string;
  FirstFileVersion: number;
  CaseRequestId: number;
  EducationalInstitutionLayerId: number;

  constructor(data?: IFileUploadRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["id"];
      this.CreateMethod = _data["createMethod"];
      this.RequesterUserId = _data["requesterUserId"];
      this.UploaderUserId = _data["uploaderUserId"];
      this.IsUploaded = _data["isUploaded"];
      this.UploadConfirmed = _data["uploadConfirmed"];
      this.ConfirmUserId = _data["confirmUserId"];
      this.UploadRejected = _data["uploadRejected"];
      this.RejectUserId = _data["rejectUserId"];
      this.RejectReason = _data["rejectReason"];
      this.FileTypeId = _data["fileTypeId"];
      this.FileTypeName = _data["fileTypeName"];
      this.CaseId = _data["caseId"];
      this.Description = _data["description"];
      this.UploaderUserDescription = _data["uploaderUserDescription"];
      this.FirstFilePath = _data["firstFilePath"];
      this.FirstFileVersion = _data["firstFileVersion"];
      this.CaseRequestId = _data["caseRequestId"];
      this.EducationalInstitutionLayerId =
        _data["educationalInstitutionLayerId"];
    }
  }

  static fromJS(data: any): FileUploadRequestDto {
    data = typeof data === "object" ? data : {};
    let result = new FileUploadRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["createMethod"] = this.CreateMethod;
    data["requesterUserId"] = this.RequesterUserId;
    data["uploaderUserId"] = this.UploaderUserId;
    data["isUploaded"] = this.IsUploaded;
    data["uploadConfirmed"] = this.UploadConfirmed;
    data["confirmUserId"] = this.ConfirmUserId;
    data["uploadRejected"] = this.UploadRejected;
    data["rejectUserId"] = this.RejectUserId;
    data["rejectReason"] = this.RejectReason;
    data["fileTypeId"] = this.FileTypeId;
    data["fileTypeName"] = this.FileTypeName;
    data["caseId"] = this.CaseId;
    data["description"] = this.Description;
    data["uploaderUserDescription"] = this.UploaderUserDescription;
    data["firstFilePath"] = this.FirstFilePath;
    data["firstFileVersion"] = this.FirstFileVersion;
    data["caseRequestId"] = this.CaseRequestId;
    data["educationalInstitutionLayerId"] = this.EducationalInstitutionLayerId;

    return data;
  }

  clone(): FileUploadRequestDto {
    const json = this.toJSON();
    let result = new FileUploadRequestDto();
    result.init(json);
    return result;
  }
}

export interface IFileUploadRequestDto {
  Id: number;
  CreateMethod: number;
  RequesterUserId: number;
  EducationalInstitutionLayerId: number;
  UploaderUserId: number;
  IsUploaded: boolean;
  UploadConfirmed: boolean;
  ConfirmUserId: number;
  UploadRejected: boolean;
  RejectUserId: number;
  RejectReason: string;
  FileTypeId: number;
  FileTypeName: string;
  CaseId: number;
  Description: string;
  UploaderUserDescription: string;
  FirstFileVersion: number;
  CaseRequestId: number;
}
export class FileUploadRequestDtoPagedResultDto implements IFileUploadRequestDtoPagedResultDto {
  items: FileUploadRequestDto[] | undefined;
  totalCount: number;

  constructor(data?: IFileUploadRequestDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(FileUploadRequestDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): FileUploadRequestDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new FileUploadRequestDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): FileUploadRequestDtoPagedResultDto {
    const json = this.toJSON();
    let result = new FileUploadRequestDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IFileUploadRequestDtoPagedResultDto {
  items: FileUploadRequestDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region File
@Injectable()
export class FileServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateFileDto | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/File/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  createFile(body: CreateFileDto | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/File/CreateFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processCreateFile(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @param body (optional)
   * @return Success
   */
  update(body: FileDto | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/File/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/File/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  DeleteByVersionAnfFileType(id: number | undefined): Observable<void> {
    let url_ =
      this.baseUrl + "/api/services/app/File/DeleteByVersionAnfFileType?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteByVersionAnfFileType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteByVersionAnfFileType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteByVersionAnfFileType(
    response: HttpResponseBase,
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + "/api/services/app/File/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<FileDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/File/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<FileDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getAllBy_(
    keyword: string | undefined,
    CaseId: number | undefined,
    CaseRequestId: number | undefined,
    EducationalInstitutionLayerId: number | undefined,
    FileTypeId: number | undefined,
    ScholarShipId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    forScholarship: boolean = false,
  ): Observable<FileDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/File/GetAllBy?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (CaseId === null)
      throw new Error("The parameter 'CaseId' cannot be null.");
    else if (CaseId !== undefined)
      url_ += "CaseId=" + encodeURIComponent("" + CaseId) + "&";
    if (CaseRequestId === null)
      throw new Error("The parameter 'CaseRequestId' cannot be null.");
    else if (CaseRequestId !== undefined)
      url_ += "CaseRequestId=" + encodeURIComponent("" + CaseRequestId) + "&";
    if (EducationalInstitutionLayerId === null)
      throw new Error(
        "The parameter 'EducationalInstitutionLayerId' cannot be null.",
      );
    else if (EducationalInstitutionLayerId !== undefined)
      url_ +=
        "EducationalInstitutionLayerId=" +
        encodeURIComponent("" + EducationalInstitutionLayerId) +
        "&";
    if (FileTypeId === null)
      throw new Error("The parameter 'FileTypeId' cannot be null.");
    else if (FileTypeId !== undefined)
      url_ += "FileTypeId=" + encodeURIComponent("" + FileTypeId) + "&";
    if (ScholarShipId != undefined)
      url_ += "ScholarShipId=" + encodeURIComponent("" + ScholarShipId) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";

    url_ += "forScholarship=" + encodeURIComponent("" + forScholarship) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllByCase(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllByCase(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllByCase(
    response: HttpResponseBase,
  ): Observable<FileDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  GetAllByVersionAndType(
    keyword: string | undefined,
    CaseId: number | undefined,
    CaseRequestId: number | undefined,
    FileUploadRequestId: number | undefined,
    EducationalInstitutionLayerId: number | undefined,
    version: number | undefined,
    FileTypeId: number | undefined,
    ScholarshipId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    forScholarship: boolean = false,
  ): Observable<FileDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/File/GetAllByVersionAndType?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (version === null)
      throw new Error("The parameter 'version' cannot be null.");
    else if (version !== undefined)
      url_ += "version=" + encodeURIComponent("" + version) + "&";
    if (FileTypeId === null)
      throw new Error("The parameter 'FileTypeId' cannot be null.");
    else if (FileTypeId !== undefined)
      url_ += "FileTypeId=" + encodeURIComponent("" + FileTypeId) + "&";
    if (ScholarshipId === null)
      throw new Error("The parameter 'ScholarshipId' cannot be null.");
    else if (ScholarshipId !== undefined)
      url_ += "ScholarshipId=" + encodeURIComponent("" + ScholarshipId) + "&";
    if (CaseId === null)
      throw new Error("The parameter 'CaseId' cannot be null.");
    else if (CaseId !== undefined)
      url_ += "CaseId=" + encodeURIComponent("" + CaseId) + "&";
    if (CaseRequestId === null)
      throw new Error("The parameter 'CaseRequestId' cannot be null.");
    else if (CaseRequestId !== undefined)
      url_ += "CaseRequestId=" + encodeURIComponent("" + CaseRequestId) + "&";
    if (FileUploadRequestId === null)
      throw new Error("The parameter 'FileUploadRequestId' cannot be null.");
    else if (FileUploadRequestId !== undefined)
      url_ +=
        "FileUploadRequestId=" +
        encodeURIComponent("" + FileUploadRequestId) +
        "&";
    if (EducationalInstitutionLayerId === null)
      throw new Error(
        "The parameter 'EducationalInstitutionLayerId' cannot be null.",
      );
    else if (EducationalInstitutionLayerId !== undefined)
      url_ +=
        "EducationalInstitutionLayerId=" +
        encodeURIComponent("" + EducationalInstitutionLayerId) +
        "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";

    url_ += "forScholarship=" + encodeURIComponent("" + forScholarship) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllByVersionAndType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllByVersionAndType(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<FileDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<FileDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllByVersionAndType(
    response: HttpResponseBase,
  ): Observable<FileDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  GetFirstByVersionAndType(
    keyword: string | undefined,
    version: number | undefined,
    FileTypeId: number | undefined,
    CaseId: number | undefined,
    CaseRequestId: number | undefined,
    EducationalInstitutionLayerId: number | undefined,
    ScholarshipId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    forScholarship: boolean = false,
  ): Observable<FileDto> {
    let url_ =
      this.baseUrl + "/api/services/app/File/GetFirstByVersionAndType?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (version === null)
      throw new Error("The parameter 'version' cannot be null.");
    else if (version !== undefined)
      url_ += "version=" + encodeURIComponent("" + version) + "&";
    if (ScholarshipId != undefined)
      url_ += "ScholarshipId=" + encodeURIComponent("" + ScholarshipId) + "&";
    if (FileTypeId === null)
      throw new Error("The parameter 'FileTypeId' cannot be null.");
    else if (FileTypeId !== undefined)
      url_ += "FileTypeId=" + encodeURIComponent("" + FileTypeId) + "&";
    if (CaseId !== undefined)
      url_ += "CaseId=" + encodeURIComponent("" + CaseId) + "&";
    if (CaseRequestId === null)
      throw new Error("The parameter 'CaseRequestId' cannot be null.");
    else if (CaseRequestId !== undefined)
      url_ += "CaseRequestId=" + encodeURIComponent("" + CaseRequestId) + "&";
    if (EducationalInstitutionLayerId != undefined)
      url_ +=
        "EducationalInstitutionLayerId=" +
        encodeURIComponent("" + EducationalInstitutionLayerId) +
        "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";

    url_ += "forScholarship=" + encodeURIComponent("" + forScholarship) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFirstByVersionAndType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFirstByVersionAndType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processGetFirstByVersionAndType(
    response: HttpResponseBase,
  ): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export class CreateFileDto implements ICreateFileDto {
  name: string;
  version: number;
  index: number;
  fileTypeId: number;
  caseId: number;
  ownerUserId: number;
  caseRequestId: number;
  fileUploadRequestId: number;
  educationalInstitutionLayerId: number;
  isItVisibleToTheUser: boolean = false;
  attachements: FileModel[] = [];
  description: string;
  scholarshipId: number;
  statusId: number;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
  date: string;
  isForScholarShip: boolean;

  constructor(data?: ICreateFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.version = _data["version"];
      this.index = _data["index"];
      this.fileTypeId = _data["fileTypeId"];
      this.caseId = _data["caseId"];
      this.ownerUserId = _data["ownerUserId"];
      this.caseRequestId = _data["caseRequestId"];
      this.isItVisibleToTheUser = _data["isItVisibleToTheUser"];
      this.description = _data["description"];
      this.fileUploadRequestId = _data["fileUploadRequestId"];
      this.educationalInstitutionLayerId =
        _data["educationalInstitutionLayerId"];
      this.scholarshipId = _data["scholarshipId"];
      this.statusId = _data["statusId"];
      this.option1 = _data["option1"];
      this.option2 = _data["option2"];
      this.option3 = _data["option3"];
      this.option4 = _data["option4"];
      this.date = _data["date"];
      this.isForScholarShip = _data["isForScholarShip"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): CreateFileDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateFileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["version"] = this.version;
    data["index"] = this.index;
    data["fileTypeId"] = this.fileTypeId;
    data["caseId"] = this.caseId;
    data["ownerUserId"] = this.ownerUserId;
    data["caseRequestId"] = this.caseRequestId;
    data["isItVisibleToTheUser"] = this.isItVisibleToTheUser;
    data["description"] = this.description;
    data["fileUploadRequestId"] = this.fileUploadRequestId;
    data["educationalInstitutionLayerId"] = this.educationalInstitutionLayerId;
    data["scholarshipId"] = this.scholarshipId;
    data["statusId"] = this.statusId;
    data["option1"] = this.option1;
    data["option2"] = this.option2;
    data["option3"] = this.option3;
    data["option4"] = this.option4;
    data["date"] = this.date;
    data["isForScholarShip"] = this.isForScholarShip;

    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    return data;
  }

  clone(): CreateFileDto {
    const json = this.toJSON();
    let result = new CreateFileDto();
    result.init(json);
    return result;
  }
}

export interface ICreateFileDto {
  name: string;
  fileTypeId: number;
  caseId: number;
  ownerUserId: number;
  caseRequestId: number;
  fileUploadRequestId: number;
  educationalInstitutionLayerId: number;
  isItVisibleToTheUser: boolean;
  attachements: FileModel[] | undefined;
  description: string;
  scholarshipId: number;
  statusId: number;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
  date: string;
  isForScholarShip: boolean;
}

export class CreateFileUploadRequestFileDto implements ICreateFileUploadRequestFileDto {
  FileTypeId: number;
  FileUploadRequestId: number;
  attachements: FileModel[] = [];
  Description: string;

  constructor(data?: ICreateFileUploadRequestFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.FileTypeId = _data["fileTypeId"];
      this.FileUploadRequestId = _data["fileUploadRequestId"];
      this.Description = _data["description"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): CreateFileUploadRequestFileDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateFileUploadRequestFileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fileTypeId"] = this.FileTypeId;
    data["fileUploadRequestId"] = this.FileUploadRequestId;
    data["description"] = this.Description;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    return data;
  }

  clone(): CreateFileUploadRequestFileDto {
    const json = this.toJSON();
    let result = new CreateFileUploadRequestFileDto();
    result.init(json);
    return result;
  }
}

export interface ICreateFileUploadRequestFileDto {
  FileTypeId: number;
  FileUploadRequestId: number;
  attachements: FileModel[] | undefined;
}
export class FileDto implements IFileDto {
  id: number;
  name: string;
  type: string;
  path: string;
  version: number;
  index: number;
  fileTypeId: number;
  fileTypeName: string;
  caseId: number;
  caseRequestId: number;
  fileUploadRequestId: number;
  educationalInstitutionLayerId: number;
  description: string;
  uploaderUserDescription: string;
  ownerUserId: number;
  scholarshipId: number;
  statusId: number;
  statusName: string;
  statusColor: string;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
  option: string;
  date: string;
  option3Name: string;
  option4Name: string;
  attachements: FileModel[] = [];

  constructor(data?: IFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.type = _data["type"];
      this.path = _data["path"];
      this.version = _data["version"];
      this.index = _data["index"];
      this.fileTypeId = _data["fileTypeId"];
      this.fileTypeName = _data["fileTypeName"];
      this.caseId = _data["caseId"];
      this.caseRequestId = _data["caseRequestId"];
      this.fileUploadRequestId = _data["fileUploadRequestId"];
      this.educationalInstitutionLayerId =
        _data["educationalInstitutionLayerId"];
      this.description = _data["description"];
      this.uploaderUserDescription = _data["uploaderUserDescription"];
      this.ownerUserId = _data["ownerUserId"];
      this.scholarshipId = _data["scholarshipId"];
      this.statusId = _data["statusId"];
      this.statusName = _data["statusName"];
      this.statusColor = _data["statusColor"];
      this.option1 = _data["option1"];
      this.option2 = _data["option2"];
      this.option3 = _data["option3"];
      this.option4 = _data["option4"];
      this.option4Name = _data["option4Name"];
      this.option3Name = _data["option3Name"];
      this.date = _data["date"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): FileDto {
    data = typeof data === "object" ? data : {};
    let result = new FileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["type"] = this.type;
    data["path"] = this.path;
    data["version"] = this.version;
    data["index"] = this.index;
    data["fileTypeId"] = this.fileTypeId;
    data["fileTypeName"] = this.fileTypeName;
    data["caseId"] = this.caseId;
    data["caseRequestId"] = this.caseRequestId;
    data["fileUploadRequestId"] = this.fileUploadRequestId;
    data["educationalInstitutionLayerId"] = this.educationalInstitutionLayerId;
    data["description"] = this.description;
    data["uploaderUserDescription"] = this.uploaderUserDescription;
    data["ownerUserId"] = this.ownerUserId;
    data["scholarshipId"] = this.scholarshipId;
    data["statusId"] = this.statusId;
    data["statusName"] = this.statusName;
    data["statusColor"] = this.statusColor;
    data["option1"] = this.option1;
    data["option2"] = this.option2;
    data["option3"] = this.option3;
    data["option4"] = this.option4;
    data["option4Name"] = this.option4Name;
    data["option3Name"] = this.option3Name;
    data["date"] = this.date;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    return data;
  }

  clone(): FileDto {
    const json = this.toJSON();
    let result = new FileDto();
    result.init(json);
    return result;
  }
}

export class FileDtoPagedResultDto implements IFileDtoPagedResultDto {
  items: FileDto[] | undefined;
  totalCount: number;

  constructor(data?: IFileDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(FileDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): FileDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new FileDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): FileDtoPagedResultDto {
    const json = this.toJSON();
    let result = new FileDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IFileDtoPagedResultDto {
  items: FileDto[] | undefined;
  totalCount: number;
}
export interface IFileDto {
  id: number;
  name: string;
  type: string;
  path: string;
  version: number;
  index: number;
  fileTypeId: number;
  fileTypeName: string;
  caseId: number;
  caseRequestId: number;
  fileUploadRequestId: number;
  educationalInstitutionLayerId: number;
  description: string;
  uploaderUserDescription: string;
  ownerUserId: number;
  scholarshipId: number;
  statusId: number;
  statusName: string;
  statusColor: string;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
  date: string;
  option3Name: string;
  option4Name: string;
  attachements: FileModel[] | undefined;
}
export class FileModel implements IFileModel {
  Base64: string | ArrayBuffer;
  Name: string;
  Type: string;
  index: number;
  file: File;
  constructor(data?: IFileModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Base64 = _data["base64"];
      this.Name = _data["name"];
      this.Type = _data["type"];
      this.index = _data["index"];
    }
  }

  static fromJS(data: any): FileModel {
    data = typeof data === "object" ? data : {};
    let result = new FileModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["base64"] = this.Base64;
    data["name"] = this.Name;
    data["type"] = this.Type;
    data["index"] = this.index;
    return data;
  }

  clone(): FileModel {
    const json = this.toJSON();
    let result = new FileModel();
    result.init(json);
    return result;
  }
}

export interface IFileModel {
  Base64: string | ArrayBuffer;
  Name: string;
  Type: string;
  index: number;
  file: File;
}

//#endregion

//#region EducationalInstitutionLayer
@Injectable()
export class EducationalInstitutionLayerServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateEducationalInstitutionLayerDto | undefined,
  ): Observable<EducationalInstitutionLayerDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionLayer/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionLayerDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionLayerDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionLayerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionLayerDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(
    body: EducationalInstitutionLayerDto | undefined,
  ): Observable<EducationalInstitutionLayerDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionLayer/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionLayerDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionLayerDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionLayerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionLayerDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionLayer/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<EducationalInstitutionLayerDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionLayer/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionLayerDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionLayerDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionLayerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EducationalInstitutionLayerDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<EducationalInstitutionLayerDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionLayer/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionLayerDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionLayerDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionLayerDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            EducationalInstitutionLayerDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getAllByCaseRequestId(
    keyword: string | undefined,
    CaseRequestId: number | undefined,
    ParentId: number | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<EducationalInstitutionLayerDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/EducationalInstitutionLayer/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (CaseRequestId === null)
      throw new Error("The parameter 'CaseRequestId' cannot be null.");
    else if (CaseRequestId !== undefined)
      url_ += "CaseRequestId=" + encodeURIComponent("" + CaseRequestId) + "&";
    if (ParentId === null)
      throw new Error("The parameter 'ParentId' cannot be null.");
    else if (ParentId !== undefined)
      url_ += "ParentId=" + encodeURIComponent("" + ParentId) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllByCaseRequestId(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllByCaseRequestId(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<EducationalInstitutionLayerDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<EducationalInstitutionLayerDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllByCaseRequestId(
    response: HttpResponseBase,
  ): Observable<EducationalInstitutionLayerDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            EducationalInstitutionLayerDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateEducationalInstitutionLayerDto implements ICreateEducationalInstitutionLayerDto {
  ParentId: number;
  UserId: number;
  CaseRequestId: number;
  EducationalInstitutionId: number;
  EILink: string;
  EIUserName: string;
  EIPassword: string;
  Title: string;
  StatusId: number;

  constructor(data?: ICreateEducationalInstitutionLayerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ParentId = _data["parentId"];
      this.UserId = _data["userId"];
      this.CaseRequestId = _data["caseRequestId"];
      this.EducationalInstitutionId = _data["educationalInstitutionId"];
      this.EILink = _data["eiLink"];
      this.EIUserName = _data["eiUserName"];
      this.EIPassword = _data["eiPassword"];
      this.Title = _data["title"];
      this.StatusId = _data["statusId"];
    }
  }

  static fromJS(data: any): CreateEducationalInstitutionLayerDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateEducationalInstitutionLayerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["parentId"] = this.ParentId;
    data["userId"] = this.UserId;
    data["caseRequestId"] = this.CaseRequestId;
    data["educationalInstitutionId"] = this.EducationalInstitutionId;
    data["eiLink"] = this.EILink;
    data["eiUserName"] = this.EIUserName;
    data["eiPassword"] = this.EIPassword;
    data["title"] = this.Title;
    data["statusId"] = this.StatusId;
    return data;
  }

  clone(): CreateEducationalInstitutionLayerDto {
    const json = this.toJSON();
    let result = new CreateEducationalInstitutionLayerDto();
    result.init(json);
    return result;
  }

  Reinit(_data?: any) {
    if (_data) {
      this.ParentId = _data["ParentId"];
      this.CaseRequestId = _data["CaseRequestId"];
      this.EducationalInstitutionId = _data["EducationalInstitutionId"];
      this.EILink = _data["EILink"];
      this.EIUserName = _data["EIUserName"];
      this.EIPassword = _data["EIPassword"];
      this.UserId = _data["UserId"];
      this.Title = _data["Title"];
      this.StatusId = _data["StatusId"];
    }
  }
}

export interface ICreateEducationalInstitutionLayerDto {
  ParentId: number;
  UserId: number;
  CaseRequestId: number;
  EducationalInstitutionId: number;
  EILink: string;
  EIUserName: string;
  EIPassword: string;
  Title: string;
  StatusId: number;
}

export class EducationalInstitutionLayerDto implements IEducationalInstitutionLayerDto {
  Id: number;
  ParentId: number;
  UserId: number;
  CaseRequestId: number;
  EducationalInstitutionId: number;
  EducationalInstitutionName: string;
  EducationalInstitutionTypeId: number;
  EducationalInstitutionTypeName: string;
  EILink: string;
  EIUserName: string;
  EIPassword: string;
  CountryId: number;
  Title: string;
  HaveLayer: boolean = false;
  StatusId: number;
  statuscolor: string;

  constructor(data?: IEducationalInstitutionLayerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["id"];
      this.ParentId = _data["parentId"];
      this.UserId = _data["userId"];
      this.CaseRequestId = _data["caseRequestId"];
      this.EducationalInstitutionId = _data["educationalInstitutionId"];
      this.EducationalInstitutionName = _data["educationalInstitutionName"];
      this.EducationalInstitutionTypeId = _data["educationalInstitutionTypeId"];
      this.EducationalInstitutionTypeName =
        _data["educationalInstitutionTypeName"];
      this.EILink = _data["eiLink"];
      this.EIUserName = _data["eiUserName"];
      this.EIPassword = _data["eiPassword"];
      this.Title = _data["title"];
      this.HaveLayer = _data["haveLayer"];
      this.StatusId = _data["statusId"];
      this.statuscolor = _data["statuscolor"];
    }
  }

  static fromJS(data: any): EducationalInstitutionLayerDto {
    data = typeof data === "object" ? data : {};
    let result = new EducationalInstitutionLayerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["parentId"] = this.ParentId;
    data["userId"] = this.UserId;
    data["caseRequestId"] = this.CaseRequestId;
    data["educationalInstitutionId"] = this.EducationalInstitutionId;
    data["educationalInstitutionName"] = this.EducationalInstitutionName;
    data["educationalInstitutionTypeId"] = this.EducationalInstitutionTypeId;
    data["educationalInstitutionTypeName"] =
      this.EducationalInstitutionTypeName;
    data["eiLink"] = this.EILink;
    data["eiUserName"] = this.EIUserName;
    data["eiPassword"] = this.EIPassword;
    data["title"] = this.Title;
    data["haveLayer"] = this.HaveLayer;
    data["statusId"] = this.StatusId;
    data["statuscolor"] = this.statuscolor;

    return data;
  }

  clone(): EducationalInstitutionLayerDto {
    const json = this.toJSON();
    let result = new EducationalInstitutionLayerDto();
    result.init(json);
    return result;
  }
}

export interface IEducationalInstitutionLayerDto {
  Id: number;
  ParentId: number;
  UserId: number;
  CaseRequestId: number;
  EducationalInstitutionId: number;
  EducationalInstitutionName: string;
  EducationalInstitutionTypeId: number;
  EducationalInstitutionTypeName: string;
  EILink: string;
  EIUserName: string;
  EIPassword: string;
  Title: string;
  HaveLayer: boolean;
  StatusId: number;
  statuscolor: string;
}
export class EducationalInstitutionLayerDtoPagedResultDto implements IEducationalInstitutionLayerDtoPagedResultDto {
  items: EducationalInstitutionLayerDto[] | undefined;
  totalCount: number;

  constructor(data?: IEducationalInstitutionLayerDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(EducationalInstitutionLayerDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): EducationalInstitutionLayerDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new EducationalInstitutionLayerDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): EducationalInstitutionLayerDtoPagedResultDto {
    const json = this.toJSON();
    let result = new EducationalInstitutionLayerDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IEducationalInstitutionLayerDtoPagedResultDto {
  items: EducationalInstitutionLayerDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region ExamType
@Injectable()
export class ExamTypeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateExamTypeDto | undefined): Observable<ExamTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/ExamType/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExamTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ExamTypeDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<ExamTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: ExamTypeDto | undefined): Observable<ExamTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/ExamType/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExamTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ExamTypeDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<ExamTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/ExamType/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<ExamTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/ExamType/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExamTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ExamTypeDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ExamTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ExamTypeDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/ExamType/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ExamTypeDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ExamTypeDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<ExamTypeDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamTypeDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateExamTypeDto implements ICreateExamTypeDto {
  Name: string;
  Code: string;

  constructor(data?: ICreateExamTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Name = _data["name"];
      this.Code = _data["code"];
    }
  }
  Reinit(_data?: any) {
    if (_data) {
      this.Name = _data["Name"];
      this.Code = _data["Code"];
    }
  }

  static fromJS(data: any): CreateExamTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateExamTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.Name;
    data["code"] = this.Code;
    return data;
  }

  clone(): CreateExamTypeDto {
    const json = this.toJSON();
    let result = new CreateExamTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICreateExamTypeDto {
  Name: string;
  Code: string;
}

export class ExamTypeDto implements IExamTypeDto {
  Id: number;
  Name: string;
  Code: string;

  constructor(data?: IExamTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Id = _data["id"];
      this.Name = _data["name"];
      this.Code = _data["code"];
    }
  }

  static fromJS(data: any): ExamTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new ExamTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.Id;
    data["name"] = this.Name;
    data["code"] = this.Code;

    return data;
  }

  clone(): ExamTypeDto {
    const json = this.toJSON();
    let result = new ExamTypeDto();
    result.init(json);
    return result;
  }
}

export interface IExamTypeDto {
  Id: number;
  Name: string;
  Code: string;
}
export class ExamTypeDtoPagedResultDto implements IExamTypeDtoPagedResultDto {
  items: ExamTypeDto[] | undefined;
  totalCount: number;

  constructor(data?: IExamTypeDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ExamTypeDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ExamTypeDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ExamTypeDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): ExamTypeDtoPagedResultDto {
    const json = this.toJSON();
    let result = new ExamTypeDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IExamTypeDtoPagedResultDto {
  items: ExamTypeDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region Exam
@Injectable()
export class ExamServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateExamDto | undefined): Observable<ExamDto> {
    let url_ = this.baseUrl + "/api/services/app/Exam/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExamDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ExamDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<ExamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: ExamDto | undefined): Observable<ExamDto> {
    let url_ = this.baseUrl + "/api/services/app/Exam/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExamDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ExamDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<ExamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Exam/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<ExamDto> {
    let url_ = this.baseUrl + "/api/services/app/Exam/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExamDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ExamDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ExamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ExamDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Exam/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ExamDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ExamDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<ExamDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllBy_(
    UserId: number | undefined,
    CaseId: number | undefined,
    CaseRequestsId: number | undefined,
    EducationalInstitutionLayerId: number | undefined,
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ExamDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Exam/GetAllBy?";
    if (UserId === null)
      throw new Error("The parameter 'UserId' cannot be null.");
    else if (UserId !== undefined)
      url_ += "UserId=" + encodeURIComponent("" + UserId) + "&";
    if (CaseId === null)
      throw new Error("The parameter 'CaseId' cannot be null.");
    else if (CaseId !== undefined)
      url_ += "CaseId=" + encodeURIComponent("" + CaseId) + "&";
    if (CaseRequestsId === null)
      throw new Error("The parameter 'CaseRequestsId' cannot be null.");
    else if (CaseRequestsId !== undefined)
      url_ += "CaseRequestsId=" + encodeURIComponent("" + CaseRequestsId) + "&";
    if (EducationalInstitutionLayerId === null)
      throw new Error(
        "The parameter 'EducationalInstitutionLayerId' cannot be null.",
      );
    else if (EducationalInstitutionLayerId !== undefined)
      url_ +=
        "EducationalInstitutionLayerId=" +
        encodeURIComponent("" + EducationalInstitutionLayerId) +
        "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllBy_(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllBy_(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ExamDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ExamDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllBy_(
    response: HttpResponseBase,
  ): Observable<ExamDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExamDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  getExamEvents(
    FromDate: string,
    ToDate: string,
    UserId: number,
    CaseId: number,
  ): Observable<EventViewModel[]> {
    let url_ = this.baseUrl + "/api/services/app/Exam/GetExamEvents?";
    if (UserId != undefined)
      url_ += "UserId=" + encodeURIComponent("" + UserId) + "&";
    if (CaseId != undefined)
      url_ += "CaseId=" + encodeURIComponent("" + CaseId) + "&";
    if (FromDate === null)
      throw new Error("The parameter 'FromDate' cannot be null.");
    else if (FromDate !== undefined)
      url_ += "FromDate=" + encodeURIComponent("" + FromDate) + "&";
    if (ToDate === null)
      throw new Error("The parameter 'ToDate' cannot be null.");
    else if (ToDate !== undefined)
      url_ += "ToDate=" + encodeURIComponent("" + ToDate) + "&";

    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetExamEvents(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetExamEvents(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EventViewModel[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              EventViewModel[]
            >;
        }),
      );
  }

  protected processGetExamEvents(
    response: HttpResponseBase,
  ): Observable<EventViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateExamDto implements ICreateExamDto {
  examTypeId: number;
  statusId: number;
  title: string;
  userId: number;
  caseId: number;
  caseRequestsId: number;
  educationalInstitutionLayerId: number;
  countryId: number;
  date: string;
  time: string;
  inPerson: boolean = false;
  remote: boolean = false;
  examVenue: string;
  userName: string;
  password: string;
  link: string;
  dateInCountry: string;
  timeInCountry: string;

  constructor(data?: ICreateExamDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.examTypeId = _data["examTypeId"];
      this.statusId = _data["statusId"];
      this.title = _data["title"];
      this.userId = _data["userId"];
      this.caseId = _data["caseId"];
      this.caseRequestsId = _data["caseRequestsId"];
      this.educationalInstitutionLayerId =
        _data["educationalInstitutionLayerId"];
      this.time = _data["time"];
      this.date = _data["date"];
      this.inPerson = _data["inPerson"];
      this.remote = _data["remote"];
      this.examVenue = _data["examVenue"];
      this.userName = _data["userName"];
      this.password = _data["password"];
      this.link = _data["link"];
      this.countryId = _data["countryId"];
      this.dateInCountry = _data["dateInCountry"];
      this.timeInCountry = _data["timeInCountry"];
    }
  }

  static fromJS(data: any): CreateExamDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateExamDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["examTypeId"] = this.examTypeId;
    data["statusId"] = this.statusId;
    data["title"] = this.title;
    data["userId"] = this.userId;
    data["caseId"] = this.caseId;
    data["caseRequestsId"] = this.caseRequestsId;
    data["educationalInstitutionLayerId"] = this.educationalInstitutionLayerId;
    data["date"] = this.date;
    data["time"] = this.time;
    data["inPerson"] = this.inPerson;
    data["remote"] = this.remote;
    data["examVenue"] = this.examVenue;
    data["userName"] = this.userName;
    data["password"] = this.password;
    data["link"] = this.link;
    data["countryId"] = this.countryId;
    data["dateInCountry"] = this.dateInCountry;
    data["timeInCountry"] = this.timeInCountry;
    return data;
  }

  clone(): CreateExamDto {
    const json = this.toJSON();
    let result = new CreateExamDto();
    result.init(json);
    return result;
  }
}

export interface ICreateExamDto {
  examTypeId: number;
  statusId: number;
  title: string;
  userId: number;
  caseId: number;
  caseRequestsId: number;
  educationalInstitutionLayerId: number;
  countryId: number;
  date: string;
  time: string;
  inPerson: boolean;
  remote: boolean;
  examVenue: string;
  userName: string;
  password: string;
  link: string;
  dateInCountry: string;
  timeInCountry: string;
}

export class ExamDto implements IExamDto {
  id: number;
  examTypeId: number;
  examTypeName: string;
  statusId: number;
  statusName: string;
  title: string;
  userId: number = 0;
  caseId: number = 0;
  caseRequestsId: number = 0;
  educationalInstitutionLayerId: number = 0;
  date: string;
  time: string;
  inPerson: boolean = false;
  remote: boolean = false;
  examVenue: string;
  userName: string;
  password: string;
  link: string;
  countryId: number;
  countryName: string;
  dateInCountry: string;
  timeInCountry: string;

  constructor(data?: IExamDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.examTypeId = _data["examTypeId"];
      this.examTypeName = _data["examTypeName"];
      this.statusId = _data["statusId"];
      this.statusName = _data["statusName"];
      this.title = _data["title"];
      this.userId = _data["userId"];
      this.caseId = _data["caseId"];
      this.caseRequestsId = _data["caseRequestsId"];
      this.educationalInstitutionLayerId =
        _data["educationalInstitutionLayerId"];
      this.time = _data["time"];
      this.date = _data["date"];
      this.inPerson = _data["inPerson"];
      this.remote = _data["remote"];
      this.examVenue = _data["examVenue"];
      this.userName = _data["userName"];
      this.password = _data["password"];
      this.link = _data["link"];
      this.countryId = _data["countryId"];
      this.countryName = _data["countryName"];
      this.dateInCountry = _data["dateInCountry"];
      this.timeInCountry = _data["timeInCountry"];
    }
  }

  static fromJS(data: any): ExamDto {
    data = typeof data === "object" ? data : {};
    let result = new ExamDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["examTypeId"] = this.examTypeId;
    data["examTypeName"] = this.examTypeName;
    data["statusId"] = this.statusId;
    data["statusName"] = this.statusName;
    data["title"] = this.title;
    data["userId"] = this.userId;
    data["caseId"] = this.caseId;
    data["caseRequestsId"] = this.caseRequestsId;
    data["educationalInstitutionLayerId"] = this.educationalInstitutionLayerId;
    data["time"] = this.time;
    data["date"] = this.date;
    data["inPerson"] = this.inPerson;
    data["remote"] = this.remote;
    data["examVenue"] = this.examVenue;
    data["userName"] = this.userName;
    data["password"] = this.password;
    data["link"] = this.link;
    data["countryId"] = this.countryId;
    data["countryName"] = this.countryName;
    data["dateInCountry"] = this.dateInCountry;
    data["timeInCountry"] = this.timeInCountry;
    return data;
  }

  clone(): ExamDto {
    const json = this.toJSON();
    let result = new ExamDto();
    result.init(json);
    return result;
  }
}

export interface IExamDto {
  id: number;
  examTypeId: number;
  examTypeName: string;
  statusId: number;
  statusName: string;
  title: string;
  userId: number;
  caseId: number;
  caseRequestsId: number;
  educationalInstitutionLayerId: number;
  date: string;
  time: string;
  inPerson: boolean;
  remote: boolean;
  examVenue: string;
  userName: string;
  password: string;
  link: string;
  countryId: number;
  countryName: string;
  dateInCountry: string;
  timeInCountry: string;
}
export class ExamDtoPagedResultDto implements IExamDtoPagedResultDto {
  items: ExamDto[] | undefined;
  totalCount: number;

  constructor(data?: IExamDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(ExamDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ExamDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ExamDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): ExamDtoPagedResultDto {
    const json = this.toJSON();
    let result = new ExamDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IExamDtoPagedResultDto {
  items: ExamDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region Grade
@Injectable()
export class GradeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateGradeDto | undefined): Observable<GradeDto> {
    let url_ = this.baseUrl + "/api/services/app/Grade/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GradeDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<GradeDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<GradeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GradeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: GradeDto | undefined): Observable<GradeDto> {
    let url_ = this.baseUrl + "/api/services/app/Grade/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GradeDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<GradeDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<GradeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GradeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Grade/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<GradeDto> {
    let url_ = this.baseUrl + "/api/services/app/Grade/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GradeDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<GradeDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GradeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GradeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<GradeDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Grade/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<GradeDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<GradeDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<GradeDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GradeDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateGradeDto implements ICreateGradeDto {
  name: string;
  code: number;

  constructor(data?: ICreateGradeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): CreateGradeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateGradeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["code"] = this.code;
    return data;
  }

  clone(): CreateGradeDto {
    const json = this.toJSON();
    let result = new CreateGradeDto();
    result.init(json);
    return result;
  }
}

export interface ICreateGradeDto {
  name: string;
  code: number;
}
export class GradeDto implements IGradeDto {
  id: number;
  name: string;
  code: number;

  constructor(data?: IGradeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): GradeDto {
    data = typeof data === "object" ? data : {};
    let result = new GradeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["code"] = this.code;

    return data;
  }

  clone(): GradeDto {
    const json = this.toJSON();
    let result = new GradeDto();
    result.init(json);
    return result;
  }
}

export interface IGradeDto {
  id: number;
  name: string;
  code: number;
}
export class GradeDtoPagedResultDto implements IGradeDtoPagedResultDto {
  items: GradeDto[] | undefined;
  totalCount: number;

  constructor(data?: IGradeDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(GradeDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): GradeDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new GradeDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): GradeDtoPagedResultDto {
    const json = this.toJSON();
    let result = new GradeDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IGradeDtoPagedResultDto {
  items: GradeDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region MilitaryService
@Injectable()
export class MilitaryServiceServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateMilitaryServiceDto | undefined,
  ): Observable<MilitaryServiceDto> {
    let url_ = this.baseUrl + "/api/services/app/MilitaryService/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<MilitaryServiceDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MilitaryServiceDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<MilitaryServiceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MilitaryServiceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: MilitaryServiceDto | undefined): Observable<MilitaryServiceDto> {
    let url_ = this.baseUrl + "/api/services/app/MilitaryService/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<MilitaryServiceDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MilitaryServiceDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<MilitaryServiceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MilitaryServiceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/MilitaryService/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<MilitaryServiceDto> {
    let url_ = this.baseUrl + "/api/services/app/MilitaryService/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<MilitaryServiceDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MilitaryServiceDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<MilitaryServiceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MilitaryServiceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<MilitaryServiceDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/MilitaryService/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<MilitaryServiceDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MilitaryServiceDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<MilitaryServiceDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MilitaryServiceDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateMilitaryServiceDto implements ICreateMilitaryServiceDto {
  name: string;
  code: number;

  constructor(data?: ICreateMilitaryServiceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): CreateMilitaryServiceDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateMilitaryServiceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["code"] = this.code;
    return data;
  }

  clone(): CreateMilitaryServiceDto {
    const json = this.toJSON();
    let result = new CreateMilitaryServiceDto();
    result.init(json);
    return result;
  }
}

export interface ICreateMilitaryServiceDto {
  name: string;
  code: number;
}
export class MilitaryServiceDto implements IMilitaryServiceDto {
  id: number;
  name: string;
  code: number;

  constructor(data?: IMilitaryServiceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): MilitaryServiceDto {
    data = typeof data === "object" ? data : {};
    let result = new MilitaryServiceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["extentionName"] = this.code;

    return data;
  }

  clone(): MilitaryServiceDto {
    const json = this.toJSON();
    let result = new MilitaryServiceDto();
    result.init(json);
    return result;
  }
}

export interface IMilitaryServiceDto {
  id: number;
  name: string;
  code: number;
}
export class MilitaryServiceDtoPagedResultDto implements IMilitaryServiceDtoPagedResultDto {
  items: MilitaryServiceDto[] | undefined;
  totalCount: number;

  constructor(data?: IMilitaryServiceDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(MilitaryServiceDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): MilitaryServiceDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new MilitaryServiceDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): MilitaryServiceDtoPagedResultDto {
    const json = this.toJSON();
    let result = new MilitaryServiceDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IMilitaryServiceDtoPagedResultDto {
  items: MilitaryServiceDto[] | undefined;
  totalCount: number;
}
//#endregion
//#region Grade

//#region Status
@Injectable()
export class StatusServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateStatusDto | undefined): Observable<StatusDto> {
    let url_ = this.baseUrl + "/api/services/app/Status/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<StatusDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<StatusDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<StatusDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = StatusDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: StatusDto | undefined): Observable<StatusDto> {
    let url_ = this.baseUrl + "/api/services/app/Status/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<StatusDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<StatusDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<StatusDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = StatusDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Status/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<StatusDto> {
    let url_ = this.baseUrl + "/api/services/app/Status/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<StatusDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<StatusDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<StatusDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = StatusDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<StatusDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Status/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<StatusDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<StatusDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<StatusDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = StatusDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllByCatStatus(
    CatStatusCode: number | undefined,
  ): Observable<StatusDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Status/GetAllByCatStatus?";
    if (CatStatusCode === null)
      throw new Error("The parameter 'CatStatusCode' cannot be null.");
    else if (CatStatusCode !== undefined)
      url_ += "CatStatusCode=" + encodeURIComponent("" + CatStatusCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllByCatStatus(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllByCatStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<StatusDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              StatusDto[]
            >;
        }),
      );
  }

  protected processGetAllByCatStatus(
    response: HttpResponseBase,
  ): Observable<StatusDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllLayerStatus(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<StatusDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Status/GetAllLayerStatus?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processgetAllLayerStatus(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processgetAllLayerStatus(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<StatusDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<StatusDtoPagedResultDto>;
        }),
      );
  }

  protected processgetAllLayerStatus(
    response: HttpResponseBase,
  ): Observable<StatusDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = StatusDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateStatusDto implements ICreateStatusDto {
  name: string;
  code: number;
  color: string;

  constructor(data?: ICreateStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.code = _data["code"];
      this.color = _data["color"];
    }
  }

  static fromJS(data: any): CreateStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["code"] = this.code;
    data["color"] = this.color;
    return data;
  }

  clone(): CreateStatusDto {
    const json = this.toJSON();
    let result = new CreateStatusDto();
    result.init(json);
    return result;
  }
}

export interface ICreateStatusDto {
  name: string;
  code: number;
  color: string;
}
export class StatusDto implements IStatusDto {
  id: number;
  name: string;
  code: number;
  color: string;

  constructor(data?: IStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.code = _data["code"];
      this.color = _data["color"];
    }
  }

  static fromJS(data: any): StatusDto {
    data = typeof data === "object" ? data : {};
    let result = new StatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["code"] = this.code;
    data["color"] = this.color;

    return data;
  }

  clone(): StatusDto {
    const json = this.toJSON();
    let result = new StatusDto();
    result.init(json);
    return result;
  }
}

export interface IStatusDto {
  id: number;
  name: string;
  code: number;
  color: string;
}
export class StatusDtoPagedResultDto implements IStatusDtoPagedResultDto {
  items: StatusDto[] | undefined;
  totalCount: number;

  constructor(data?: IStatusDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(StatusDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): StatusDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new StatusDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): StatusDtoPagedResultDto {
    const json = this.toJSON();
    let result = new StatusDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IStatusDtoPagedResultDto {
  items: StatusDto[] | undefined;
  totalCount: number;
}
//#endregion

//#region PayFor
@Injectable()
export class PayForServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreatePayForDto | undefined): Observable<PayForDto> {
    let url_ = this.baseUrl + "/api/services/app/PayFor/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PayForDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<PayForDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<PayForDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PayForDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: PayForDto | undefined): Observable<PayForDto> {
    let url_ = this.baseUrl + "/api/services/app/PayFor/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PayForDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<PayForDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<PayForDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PayForDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/PayFor/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<PayForDto> {
    let url_ = this.baseUrl + "/api/services/app/PayFor/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PayForDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<PayForDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<PayForDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PayForDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PayForDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/PayFor/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<PayForDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<PayForDtoPagedResultDto>;
        }),
      );
  }
  getAllbyisCurrencyOrRiyal(
    isCurrencyOrRiyal: boolean | undefined,
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PayForDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/PayFor/GetAll?";
    if (isCurrencyOrRiyal !== undefined)
      url_ +=
        "isCurrencyOrRiyal=" + encodeURIComponent("" + isCurrencyOrRiyal) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<PayForDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<PayForDtoPagedResultDto>;
        }),
      );
  }
  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<PayForDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PayForDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllByType(
    isRiyal: boolean | undefined,
    isCurrency: boolean | undefined,
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PayForDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/PayFor/GetAllByType?";
    if (isRiyal !== undefined)
      url_ += "isRiyal=" + encodeURIComponent("" + isRiyal) + "&";
    if (isCurrency !== undefined)
      url_ += "isCurrency=" + encodeURIComponent("" + isCurrency) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllByType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllByType(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<PayForDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<PayForDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllByType(
    response: HttpResponseBase,
  ): Observable<PayForDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PayForDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreatePayForDto implements ICreatePayForDto {
  name: string;
  code: number;
  isCurrency: boolean = false;
  isRiyal: boolean = false;

  constructor(data?: ICreatePayForDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.code = _data["code"];
      this.isCurrency = _data["isCurrency"];
      this.isRiyal = _data["isRiyal"];
    }
  }

  static fromJS(data: any): CreatePayForDto {
    data = typeof data === "object" ? data : {};
    let result = new CreatePayForDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["code"] = this.code;
    data["isCurrency"] = this.isCurrency;
    data["isRiyal"] = this.isRiyal;
    return data;
  }

  clone(): CreatePayForDto {
    const json = this.toJSON();
    let result = new CreatePayForDto();
    result.init(json);
    return result;
  }
}

export interface ICreatePayForDto {
  name: string;
  code: number;
  isCurrency: boolean;
  isRiyal: boolean;
}

export class PayForDto implements IPayForDto {
  id: number;
  name: string;
  code: number;
  isCurrency: boolean = false;
  isRiyal: boolean = false;

  constructor(data?: IPayForDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.code = _data["code"];
      this.isCurrency = _data["isCurrency"];
      this.isRiyal = _data["isRiyal"];
    }
  }

  static fromJS(data: any): PayForDto {
    data = typeof data === "object" ? data : {};
    let result = new PayForDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["code"] = this.code;
    data["isCurrency"] = this.isCurrency;
    data["isRiyal"] = this.isRiyal;

    return data;
  }

  clone(): PayForDto {
    const json = this.toJSON();
    let result = new PayForDto();
    result.init(json);
    return result;
  }
}

export interface IPayForDto {
  id: number;
  name: string;
  code: number;
  isCurrency: boolean;
  isRiyal: boolean;
}
export class PayForDtoPagedResultDto implements IPayForDtoPagedResultDto {
  items: PayForDto[] | undefined;
  totalCount: number;

  constructor(data?: IPayForDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(PayForDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): PayForDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new PayForDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): PayForDtoPagedResultDto {
    const json = this.toJSON();
    let result = new PayForDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IPayForDtoPagedResultDto {
  items: PayForDto[] | undefined;
  totalCount: number;
}
//#endregion
//#region CurrencyType
@Injectable()
export class CurrencyTypeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateCurrencyTypeDto | undefined): Observable<CurrencyTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/CurrencyType/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CurrencyTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CurrencyTypeDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<CurrencyTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CurrencyTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: CurrencyTypeDto | undefined): Observable<CurrencyTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/CurrencyType/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CurrencyTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CurrencyTypeDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<CurrencyTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CurrencyTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/CurrencyType/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<CurrencyTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/CurrencyType/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CurrencyTypeDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CurrencyTypeDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<CurrencyTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CurrencyTypeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<CurrencyTypeDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/CurrencyType/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<CurrencyTypeDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CurrencyTypeDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<CurrencyTypeDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CurrencyTypeDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateCurrencyTypeDto implements ICreateCurrencyTypeDto {
  name: string;
  code: number;

  constructor(data?: ICreateCurrencyTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): CreateCurrencyTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCurrencyTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["code"] = this.code;
    return data;
  }

  clone(): CreateCurrencyTypeDto {
    const json = this.toJSON();
    let result = new CreateCurrencyTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICreateCurrencyTypeDto {
  name: string;
  code: number;
}

export class CurrencyTypeDto implements ICurrencyTypeDto {
  id: number;
  name: string;
  code: number;
  constructor(data?: ICurrencyTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): CurrencyTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CurrencyTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["code"] = this.code;

    return data;
  }

  clone(): CurrencyTypeDto {
    const json = this.toJSON();
    let result = new CurrencyTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICurrencyTypeDto {
  id: number;
  name: string;
  code: number;
}
export class CurrencyTypeDtoPagedResultDto implements ICurrencyTypeDtoPagedResultDto {
  items: CurrencyTypeDto[] | undefined;
  totalCount: number;

  constructor(data?: ICurrencyTypeDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(CurrencyTypeDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): CurrencyTypeDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CurrencyTypeDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): CurrencyTypeDtoPagedResultDto {
    const json = this.toJSON();
    let result = new CurrencyTypeDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ICurrencyTypeDtoPagedResultDto {
  items: CurrencyTypeDto[] | undefined;
  totalCount: number;
}
//#endregion
//#region Supplier
@Injectable()
export class SupplierServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateSupplierDto | undefined): Observable<SupplierDto> {
    let url_ = this.baseUrl + "/api/services/app/Supplier/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SupplierDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<SupplierDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<SupplierDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SupplierDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: SupplierDto | undefined): Observable<SupplierDto> {
    let url_ = this.baseUrl + "/api/services/app/Supplier/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SupplierDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<SupplierDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<SupplierDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SupplierDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Supplier/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<SupplierDto> {
    let url_ = this.baseUrl + "/api/services/app/Supplier/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SupplierDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<SupplierDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<SupplierDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SupplierDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<SupplierDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Supplier/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<SupplierDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<SupplierDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<SupplierDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SupplierDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateSupplierDto implements ICreateSupplierDto {
  name: string;
  code: number;

  constructor(data?: ICreateSupplierDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): CreateSupplierDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateSupplierDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["code"] = this.code;
    return data;
  }

  clone(): CreateSupplierDto {
    const json = this.toJSON();
    let result = new CreateSupplierDto();
    result.init(json);
    return result;
  }
}

export interface ICreateSupplierDto {
  name: string;
  code: number;
}

export class SupplierDto implements ISupplierDto {
  id: number;
  name: string;
  code: number;
  constructor(data?: ISupplierDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.code = _data["code"];
    }
  }

  static fromJS(data: any): SupplierDto {
    data = typeof data === "object" ? data : {};
    let result = new SupplierDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["code"] = this.code;

    return data;
  }

  clone(): SupplierDto {
    const json = this.toJSON();
    let result = new SupplierDto();
    result.init(json);
    return result;
  }
}

export interface ISupplierDto {
  id: number;
  name: string;
  code: number;
}
export class SupplierDtoPagedResultDto implements ISupplierDtoPagedResultDto {
  items: SupplierDto[] | undefined;
  totalCount: number;

  constructor(data?: ISupplierDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(SupplierDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): SupplierDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new SupplierDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): SupplierDtoPagedResultDto {
    const json = this.toJSON();
    let result = new SupplierDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ISupplierDtoPagedResultDto {
  items: SupplierDto[] | undefined;
  totalCount: number;
}
//#endregion
//#region Accounting
@Injectable()
export class AccountingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateAccountingDto | undefined): Observable<AccountingDto> {
    let url_ = this.baseUrl + "/api/services/app/Accounting/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AccountingDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AccountingDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<AccountingDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AccountingDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: AccountingDto | undefined): Observable<AccountingDto> {
    let url_ = this.baseUrl + "/api/services/app/Accounting/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AccountingDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AccountingDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<AccountingDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AccountingDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Accounting/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<AccountingDto> {
    let url_ = this.baseUrl + "/api/services/app/Accounting/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AccountingDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AccountingDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<AccountingDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AccountingDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<AccountingDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Accounting/GetAll?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AccountingDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AccountingDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<AccountingDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AccountingDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getAllbyUserAndCase(
    UserId: number | undefined,
    CaseId: number | undefined,
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<AccountingDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Accounting/GetAllbyUserAndCase?";
    if (UserId === null)
      throw new Error("The parameter 'UserId' cannot be null.");
    else if (UserId !== undefined)
      url_ += "UserId=" + encodeURIComponent("" + UserId) + "&";
    if (CaseId === null)
      throw new Error("The parameter 'CaseId' cannot be null.");
    else if (CaseId !== undefined)
      url_ += "CaseId=" + encodeURIComponent("" + CaseId) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllbyUserAndCase(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllbyUserAndCase(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<AccountingDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<AccountingDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAllbyUserAndCase(
    response: HttpResponseBase,
  ): Observable<AccountingDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AccountingDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateAccountingDto implements ICreateAccountingDto {
  userId: number;
  caseId: number;
  payForId: number;
  currencyTypeId: number;
  statusId: number;
  isCurrencyOrRiyal: boolean = false;
  paymentDeadline: Date;
  currencyRate: number;
  remittancePrice: number;
  date: Date;
  totalCurrencyAmount: number;
  totalRialsAmount: number;
  responsibleForPaymentId: number;
  supplierId: number;
  payingExchange: string;
  accountOwner: string;
  bankAndBranch: string;
  attachements: FileModel[] = [];

  constructor(data?: ICreateAccountingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.caseId = _data["caseId"];
      this.payForId = _data["payForId"];
      this.currencyTypeId = _data["currencyTypeId"];
      this.statusId = _data["statusId"];
      this.isCurrencyOrRiyal = _data["isCurrencyOrRiyal"];
      this.paymentDeadline = _data["paymentDeadline"];
      this.currencyRate = _data["currencyRate"];
      this.remittancePrice = _data["remittancePrice"];
      this.date = _data["date"];
      this.totalCurrencyAmount = _data["totalCurrencyAmount"];
      this.totalRialsAmount = _data["totalRialsAmount"];
      this.responsibleForPaymentId = _data["responsibleForPaymentId"];
      this.supplierId = _data["supplierId"];
      this.payingExchange = _data["payingExchange"];
      this.accountOwner = _data["accountOwner"];
      this.bankAndBranch = _data["bankAndBranch"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): CreateAccountingDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateAccountingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userId"] = this.userId;
    data["caseId"] = this.caseId;
    data["payForId"] = this.payForId;
    data["currencyTypeId"] = this.currencyTypeId;
    data["statusId"] = this.statusId;
    data["isCurrencyOrRiyal"] = this.isCurrencyOrRiyal;
    data["paymentDeadline"] = this.paymentDeadline;
    data["currencyRate"] = this.currencyRate;
    data["remittancePrice"] = this.remittancePrice;
    data["date"] = this.date;
    data["totalCurrencyAmount"] = this.totalCurrencyAmount;
    data["totalRialsAmount"] = this.totalRialsAmount;
    data["responsibleForPaymentId"] = this.responsibleForPaymentId;
    data["supplierId"] = this.supplierId;
    data["payingExchange"] = this.payingExchange;
    data["accountOwner"] = this.accountOwner;
    data["bankAndBranch"] = this.bankAndBranch;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    return data;
  }

  clone(): CreateAccountingDto {
    const json = this.toJSON();
    let result = new CreateAccountingDto();
    result.init(json);
    return result;
  }
}

export interface ICreateAccountingDto {
  userId: number;
  caseId: number;
  payForId: number;
  currencyTypeId: number;
  statusId: number;
  isCurrencyOrRiyal: boolean;
  paymentDeadline: Date;
  currencyRate: number;
  remittancePrice: number;
  date: Date;
  totalCurrencyAmount: number;
  totalRialsAmount: number;
  responsibleForPaymentId: number;
  supplierId: number;
  payingExchange: string;
  accountOwner: string;
  bankAndBranch: string;
  attachements: FileModel[] | undefined;
}

export class AccountingDto implements IAccountingDto {
  id: number;
  userId: number;
  caseId: number;
  payForId: number;
  payForName: string;
  currencyTypeId: number;
  currencyTypeName: string;
  statusId: number;
  statusName: string;
  isCurrencyOrRiyal: boolean = false;
  paymentDeadline: string;
  currencyRate: number;
  remittancePrice: number;
  date: string;
  totalCurrencyAmount: number;
  responsibleForPaymentId: number;
  totalRialsAmount: number;
  responsibleForPaymentName: string;
  supplierId: number;
  supplierName: string;
  payingExchange: string;
  accountOwner: string;
  bankAndBranch: string;
  debtValue: number;
  attachements: FileModel[] = [];

  constructor(data?: IAccountingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.userId = _data["userId"];
      this.caseId = _data["caseId"];
      this.payForId = _data["payForId"];
      this.payForName = _data["payForName"];
      this.currencyTypeId = _data["currencyTypeId"];
      this.currencyTypeName = _data["currencyTypeName"];
      this.statusId = _data["statusId"];
      this.statusName = _data["statusName"];
      this.isCurrencyOrRiyal = _data["isCurrencyOrRiyal"];
      this.paymentDeadline = _data["paymentDeadline"];
      this.currencyRate = _data["currencyRate"];
      this.remittancePrice = _data["remittancePrice"];
      this.date = _data["date"];
      this.totalCurrencyAmount = _data["totalCurrencyAmount"];
      this.totalRialsAmount = _data["totalRialsAmount"];
      this.responsibleForPaymentId = _data["responsibleForPaymentId"];
      this.responsibleForPaymentName = _data["responsibleForPaymentName"];
      this.supplierId = _data["supplierId"];
      this.supplierName = _data["supplierName"];
      this.payingExchange = _data["payingExchange"];
      this.accountOwner = _data["accountOwner"];
      this.bankAndBranch = _data["bankAndBranch"];
      this.debtValue = _data["debtValue"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): AccountingDto {
    data = typeof data === "object" ? data : {};
    let result = new AccountingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["userId"] = this.userId;
    data["caseId"] = this.caseId;
    data["payForId"] = this.payForId;
    data["payForName"] = this.payForName;
    data["currencyTypeId"] = this.currencyTypeId;
    data["statusId"] = this.statusId;
    data["isCurrencyOrRiyal"] = this.isCurrencyOrRiyal;
    data["paymentDeadline"] = this.paymentDeadline;
    data["currencyRate"] = this.currencyRate;
    data["remittancePrice"] = this.remittancePrice;
    data["date"] = this.date;
    data["totalCurrencyAmount"] = this.totalCurrencyAmount;
    data["totalRialsAmount"] = this.totalRialsAmount;
    data["responsibleForPaymentId"] = this.responsibleForPaymentId;
    data["supplierId"] = this.supplierId;
    data["payingExchange"] = this.payingExchange;
    data["accountOwner"] = this.accountOwner;
    data["bankAndBranch"] = this.bankAndBranch;
    data["debtValue"] = this.debtValue;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    return data;
  }

  clone(): AccountingDto {
    const json = this.toJSON();
    let result = new AccountingDto();
    result.init(json);
    return result;
  }
}

export interface IAccountingDto {
  id: number;
  userId: number;
  caseId: number;
  payForId: number;
  payForName: string;
  currencyTypeId: number;
  currencyTypeName: string;
  statusId: number;
  statusName: string;
  isCurrencyOrRiyal: boolean;
  paymentDeadline: string;
  currencyRate: number;
  remittancePrice: number;
  date: string;
  totalCurrencyAmount: number;
  totalRialsAmount: number;
  responsibleForPaymentId: number;
  responsibleForPaymentName: string;
  supplierId: number;
  supplierName: string;
  payingExchange: string;
  accountOwner: string;
  bankAndBranch: string;
  debtValue: number;
  attachements: FileModel[] | undefined;
}
export class AccountingDtoPagedResultDto implements IAccountingDtoPagedResultDto {
  items: AccountingDto[] | undefined;
  totalCount: number;

  constructor(data?: IAccountingDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(AccountingDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): AccountingDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new AccountingDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): AccountingDtoPagedResultDto {
    const json = this.toJSON();
    let result = new AccountingDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IAccountingDtoPagedResultDto {
  items: AccountingDto[] | undefined;
  totalCount: number;
}
//#endregion
//#region City
@Injectable()
export class CityServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateCityDto | undefined): Observable<CityDto> {
    let url_ = this.baseUrl + "/api/services/app/City/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CityDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<CityDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CityDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: CityDto | undefined): Observable<CityDto> {
    let url_ = this.baseUrl + "/api/services/app/City/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CityDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<CityDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CityDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/City/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<CityDto> {
    let url_ = this.baseUrl + "/api/services/app/City/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CityDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<CityDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CityDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    ParentId: number | undefined,
    CountryId: number | undefined,
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<CityDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/City/GetAll?";
    if (ParentId === null)
      throw new Error("The parameter 'ParentId' cannot be null.");
    else if (ParentId !== undefined)
      url_ += "ParentId=" + encodeURIComponent("" + ParentId) + "&";
    if (CountryId === null)
      throw new Error("The parameter 'CountryId' cannot be null.");
    else if (CountryId !== undefined)
      url_ += "CountryId=" + encodeURIComponent("" + CountryId) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<CityDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<CityDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<CityDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CityDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateCityDto implements ICreateCityDto {
  countryId: number;
  name: string;
  type: number;
  parentId: number;

  constructor(data?: ICreateCityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.countryId = _data["countryId"];
      this.name = _data["name"];
      this.type = _data["type"];
      this.parentId = _data["parentId"];
    }
  }

  static fromJS(data: any): CreateCityDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["countryId"] = this.countryId;
    data["name"] = this.name;
    data["type"] = this.type;
    data["parentId"] = this.parentId;
    return data;
  }

  clone(): CreateCityDto {
    const json = this.toJSON();
    let result = new CreateCityDto();
    result.init(json);
    return result;
  }
}

export interface ICreateCityDto {
  countryId: number;
  name: string;
  type: number;
  parentId: number;
}

export class CityDto implements ICityDto {
  id: number;
  countryId: number;
  countryName: string;
  name: string;
  type: number;
  typeName: string;
  parentId: number;
  parentName: string;

  constructor(data?: ICityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.countryId = _data["countryId"];
      this.countryName = _data["countryName"];
      this.name = _data["name"];
      this.type = _data["type"];
      this.typeName = _data["typeName"];
      this.parentId = _data["parentId"];
      this.parentName = _data["parentName"];
    }
  }

  static fromJS(data: any): CityDto {
    data = typeof data === "object" ? data : {};
    let result = new CityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["countryId"] = this.countryId;
    data["countryName"] = this.countryName;
    data["name"] = this.name;
    data["type"] = this.type;
    data["typeName"] = this.typeName;
    data["parentId"] = this.parentId;
    data["parentName"] = this.parentName;

    return data;
  }

  clone(): CityDto {
    const json = this.toJSON();
    let result = new CityDto();
    result.init(json);
    return result;
  }
}

export interface ICityDto {
  id: number;
  countryId: number;
  countryName: string;
  name: string;
  type: number;
  typeName: string;
  parentId: number;
  parentName: string;
}
export class CityDtoPagedResultDto implements ICityDtoPagedResultDto {
  items: CityDto[] | undefined;
  totalCount: number;

  constructor(data?: ICityDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(CityDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): CityDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CityDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): CityDtoPagedResultDto {
    const json = this.toJSON();
    let result = new CityDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ICityDtoPagedResultDto {
  items: CityDto[] | undefined;
  totalCount: number;
}
//#endregion
//#region Contract
@Injectable()
export class ContractServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateContractDto | undefined): Observable<ContractDto> {
    let url_ = this.baseUrl + "/api/services/app/Contract/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContractDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ContractDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<ContractDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContractDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: ContractDto | undefined): Observable<ContractDto> {
    let url_ = this.baseUrl + "/api/services/app/Contract/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContractDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ContractDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<ContractDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContractDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Contract/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<ContractDto> {
    let url_ = this.baseUrl + "/api/services/app/Contract/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContractDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ContractDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ContractDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContractDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    caseId: number | undefined,
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ContractDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Contract/GetAll?";
    if (caseId === null)
      throw new Error("The parameter 'caseId' cannot be null.");
    else if (caseId !== undefined)
      url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ContractDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ContractDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<ContractDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContractDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateContractDto implements ICreateContractDto {
  caseId: number;
  date: string;
  amount: number;
  discount: number;
  creditorAmount: number;
  creditorCurrencyTypeId: number;
  creditorPayForId: number;
  debitorAmount: number;
  debitorCurrencyTypeId: number;
  debitorPayForId: number;
  createContractInsttallments: CreateContractInsttallmentsDto[] = [];

  constructor(data?: ICreateContractDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"];
      this.caseId = _data["caseId"];
      this.amount = _data["amount"];
      this.discount = _data["discount"];
      this.creditorAmount = _data["creditorAmount"];
      this.creditorCurrencyTypeId = _data["creditorCurrencyTypeId"];
      this.creditorPayForId = _data["creditorPayForId"];
      this.debitorAmount = _data["debitorAmount"];
      this.debitorCurrencyTypeId = _data["debitorCurrencyTypeId"];
      this.debitorPayForId = _data["debitorPayForId"];
      if (Array.isArray(_data["createContractInsttallments"])) {
        this.createContractInsttallments = [] as any;
        for (let item of _data["createContractInsttallments"])
          this.createContractInsttallments.push(item);
      }
    }
  }

  static fromJS(data: any): CreateContractDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateContractDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date;
    data["caseId"] = this.caseId;
    data["amount"] = this.amount;
    data["discount"] = this.discount;
    data["creditorAmount"] = this.creditorAmount;
    data["creditorCurrencyTypeId"] = this.creditorCurrencyTypeId;
    data["creditorPayForId"] = this.creditorPayForId;
    data["debitorAmount"] = this.debitorAmount;
    data["debitorCurrencyTypeId"] = this.debitorCurrencyTypeId;
    data["debitorPayForId"] = this.debitorPayForId;
    if (Array.isArray(this.createContractInsttallments)) {
      data["createContractInsttallments"] = [];
      for (let item of this.createContractInsttallments)
        data["createContractInsttallments"].push(item);
    }
    return data;
  }

  clone(): CreateContractDto {
    const json = this.toJSON();
    let result = new CreateContractDto();
    result.init(json);
    return result;
  }
}

export interface ICreateContractDto {
  caseId: number;
  date: string;
  amount: number;
  discount: number;
  creditorAmount: number;
  creditorCurrencyTypeId: number;
  creditorPayForId: number;
  debitorAmount: number;
  debitorCurrencyTypeId: number;
  debitorPayForId: number;
  createContractInsttallments: CreateContractInsttallmentsDto[] | undefined;
}

export class ContractDto implements IContractDto {
  id: number;
  caseId: number;
  date: string;
  amount: number;
  discount: number;
  creditorAmount: number;
  creditorCurrencyTypeId: number;
  creditorPayForId: number;
  debitorAmount: number;
  debitorCurrencyTypeId: number;
  debitorPayForId: number;
  creditorCurrencyTypeName: string;
  creditorPayForName: string;
  debitorCurrencyTypeName: string;
  debitorPayForName: string;

  constructor(data?: IContractDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.date = _data["date"];
      this.caseId = _data["caseId"];
      this.amount = _data["amount"];
      this.discount = _data["discount"];
      this.creditorAmount = _data["creditorAmount"];
      this.creditorCurrencyTypeId = _data["creditorCurrencyTypeId"];
      this.creditorPayForId = _data["creditorPayForId"];
      this.debitorAmount = _data["debitorAmount"];
      this.debitorCurrencyTypeId = _data["debitorCurrencyTypeId"];
      this.debitorPayForId = _data["debitorPayForId"];
      this.creditorCurrencyTypeName = _data["creditorCurrencyTypeName"];
      this.creditorPayForName = _data["creditorPayForName"];
      this.debitorCurrencyTypeName = _data["debitorCurrencyTypeName"];
      this.debitorPayForName = _data["debitorPayForName"];
    }
  }

  static fromJS(data: any): ContractDto {
    data = typeof data === "object" ? data : {};
    let result = new ContractDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["caseId"] = this.caseId;
    data["date"] = this.date;
    data["amount"] = this.amount;
    data["discount"] = this.discount;
    data["creditorAmount"] = this.creditorAmount;
    data["creditorCurrencyTypeId"] = this.creditorCurrencyTypeId;
    data["creditorPayForId"] = this.creditorPayForId;
    data["debitorAmount"] = this.debitorAmount;
    data["debitorCurrencyTypeId"] = this.debitorCurrencyTypeId;
    data["debitorPayForId"] = this.debitorPayForId;
    data["creditorCurrencyTypeName"] = this.creditorCurrencyTypeName;
    data["creditorPayForName"] = this.creditorPayForName;
    data["debitorCurrencyTypeName"] = this.debitorCurrencyTypeName;
    data["debitorPayForName"] = this.debitorPayForName;

    return data;
  }

  clone(): ContractDto {
    const json = this.toJSON();
    let result = new ContractDto();
    result.init(json);
    return result;
  }
}

export interface IContractDto {
  id: number;
  caseId: number;
  date: string;
  amount: number;
  discount: number;
  creditorAmount: number;
  creditorCurrencyTypeId: number;
  creditorPayForId: number;
  debitorAmount: number;
  debitorCurrencyTypeId: number;
  debitorPayForId: number;
  creditorCurrencyTypeName: string;
  creditorPayForName: string;
  debitorCurrencyTypeName: string;
  debitorPayForName: string;
}
export class ContractDtoPagedResultDto implements IContractDtoPagedResultDto {
  items: ContractDto[] | undefined;
  totalCount: number;

  constructor(data?: IContractDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ContractDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ContractDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ContractDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): ContractDtoPagedResultDto {
    const json = this.toJSON();
    let result = new ContractDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IContractDtoPagedResultDto {
  items: ContractDto[] | undefined;
  totalCount: number;
}
//#endregion
//#region ContractInsttallments
@Injectable()
export class ContractInsttallmentsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(
    body: CreateContractInsttallmentsDto | undefined,
  ): Observable<ContractInsttallmentsDto> {
    let url_ = this.baseUrl + "/api/services/app/ContractInsttallments/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ContractInsttallmentsDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ContractInsttallmentsDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<ContractInsttallmentsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContractInsttallmentsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(
    body: ContractInsttallmentsDto | undefined,
  ): Observable<ContractInsttallmentsDto> {
    let url_ = this.baseUrl + "/api/services/app/ContractInsttallments/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ContractInsttallmentsDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ContractInsttallmentsDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<ContractInsttallmentsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContractInsttallmentsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/ContractInsttallments/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<ContractInsttallmentsDto> {
    let url_ = this.baseUrl + "/api/services/app/ContractInsttallments/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ContractInsttallmentsDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ContractInsttallmentsDto>;
        }),
      );
  }

  protected processGet(
    response: HttpResponseBase,
  ): Observable<ContractInsttallmentsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContractInsttallmentsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    ContractId: number | undefined,
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ContractInsttallmentsDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/ContractInsttallments/GetAll?";
    if (ContractId === null)
      throw new Error("The parameter 'ContractId' cannot be null.");
    else if (ContractId !== undefined)
      url_ += "ContractId=" + encodeURIComponent("" + ContractId) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ContractInsttallmentsDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ContractInsttallmentsDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<ContractInsttallmentsDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            ContractInsttallmentsDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateContractInsttallmentsDto implements ICreateContractInsttallmentsDto {
  contractId: number;
  statusId: number;
  amount: number;
  description: string;
  payMode: number;
  currencyTypeId: number;
  attachements: FileModel[] = [];

  constructor(data?: ICreateContractInsttallmentsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contractId = _data["contractId"];
      this.statusId = _data["statusId"];
      this.amount = _data["amount"];
      this.description = _data["description"];
      this.payMode = _data["payMode"];
      this.currencyTypeId = _data["currencyTypeId"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): CreateContractInsttallmentsDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateContractInsttallmentsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contractId"] = this.contractId;
    data["statusId"] = this.statusId;
    data["amount"] = this.amount;
    data["description"] = this.description;
    data["payMode"] = this.payMode;
    data["currencyTypeId"] = this.currencyTypeId;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    return data;
  }

  clone(): CreateContractInsttallmentsDto {
    const json = this.toJSON();
    let result = new CreateContractInsttallmentsDto();
    result.init(json);
    return result;
  }
}

export interface ICreateContractInsttallmentsDto {
  contractId: number;
  statusId: number;
  amount: number;
  description: string;
  payMode: number;
  attachements: FileModel[] | undefined;
}

export class ContractInsttallmentsDto implements IContractInsttallmentsDto {
  id: number;
  contractId: number;
  statusId: number;
  statusName: string;
  amount: number;
  description: string;
  payMode: number;
  payModeName: string;
  currencyTypeId: number;
  currencyTypeName: string;
  attachements: FileModel[] = [];

  constructor(data?: IContractInsttallmentsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.contractId = _data["contractId"];
      this.statusId = _data["statusId"];
      this.statusName = _data["statusName"];
      this.amount = _data["amount"];
      this.description = _data["description"];
      this.payMode = _data["payMode"];
      this.payModeName = _data["payModeName"];
      this.currencyTypeId = _data["currencyTypeId"];
      this.currencyTypeName = _data["currencyTypeName"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): ContractInsttallmentsDto {
    data = typeof data === "object" ? data : {};
    let result = new ContractInsttallmentsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["contractId"] = this.contractId;
    data["statusId"] = this.statusId;
    data["statusName"] = this.statusName;
    data["amount"] = this.amount;
    data["description"] = this.description;
    data["payMode"] = this.payMode;
    data["payModeName"] = this.payModeName;
    data["currencyTypeId"] = this.currencyTypeId;
    data["currencyTypeName"] = this.currencyTypeName;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }

    return data;
  }

  clone(): ContractInsttallmentsDto {
    const json = this.toJSON();
    let result = new ContractInsttallmentsDto();
    result.init(json);
    return result;
  }
}

export interface IContractInsttallmentsDto {
  id: number;
  contractId: number;
  statusId: number;
  statusName: string;
  amount: number;
  description: string;
  payMode: number;
  payModeName: string;
  attachements: FileModel[] | undefined;
}
export class ContractInsttallmentsDtoPagedResultDto implements IContractInsttallmentsDtoPagedResultDto {
  items: ContractInsttallmentsDto[] | undefined;
  totalCount: number;

  constructor(data?: IContractInsttallmentsDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ContractInsttallmentsDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ContractInsttallmentsDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ContractInsttallmentsDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): ContractInsttallmentsDtoPagedResultDto {
    const json = this.toJSON();
    let result = new ContractInsttallmentsDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IContractInsttallmentsDtoPagedResultDto {
  items: ContractInsttallmentsDto[] | undefined;
  totalCount: number;
}
//#endregion
//#region Scholarship
@Injectable()
export class ScholarshipServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateScholarshipDto | undefined): Observable<ScholarshipDto> {
    let url_ = this.baseUrl + "/api/services/app/Scholarship/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ScholarshipDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ScholarshipDto>;
        }),
      );
  }

  protected processCreate(
    response: HttpResponseBase,
  ): Observable<ScholarshipDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ScholarshipDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: ScholarshipDto | undefined): Observable<ScholarshipDto> {
    let url_ = this.baseUrl + "/api/services/app/Scholarship/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ScholarshipDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ScholarshipDto>;
        }),
      );
  }

  protected processUpdate(
    response: HttpResponseBase,
  ): Observable<ScholarshipDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ScholarshipDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Scholarship/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<ScholarshipDto> {
    let url_ = this.baseUrl + "/api/services/app/Scholarship/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ScholarshipDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ScholarshipDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ScholarshipDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ScholarshipDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  getByCaseRequestId(
    CaseRequestId: number | undefined,
  ): Observable<ScholarshipDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Scholarship/GetByCaseRequestId?";
    if (CaseRequestId === null)
      throw new Error("The parameter 'CaseRequestId' cannot be null.");
    else if (CaseRequestId !== undefined)
      url_ += "CaseRequestId=" + encodeURIComponent("" + CaseRequestId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ScholarshipDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ScholarshipDto>;
        }),
      );
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    ParentId: number | undefined,
    CountryId: number | undefined,
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<ScholarshipDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Scholarship/GetAll?";
    if (ParentId === null)
      throw new Error("The parameter 'ParentId' cannot be null.");
    else if (ParentId !== undefined)
      url_ += "ParentId=" + encodeURIComponent("" + ParentId) + "&";
    if (CountryId === null)
      throw new Error("The parameter 'CountryId' cannot be null.");
    else if (CountryId !== undefined)
      url_ += "CountryId=" + encodeURIComponent("" + CountryId) + "&";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ScholarshipDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ScholarshipDtoPagedResultDto>;
        }),
      );
  }

  protected processGetAll(
    response: HttpResponseBase,
  ): Observable<ScholarshipDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ScholarshipDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  GetLatestDataByEducationalInstitution(
    EducationalInstitutionId: number | undefined,
  ): Observable<ScholarshipDto> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Scholarship/GetLatestDataByEducationalInstitution?";
    if (EducationalInstitutionId === null)
      throw new Error(
        "The parameter 'EducationalInstitutionId' cannot be null.",
      );
    else if (EducationalInstitutionId !== undefined)
      url_ +=
        "EducationalInstitutionId=" +
        encodeURIComponent("" + EducationalInstitutionId) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLatestDataByEducationalInstitution(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLatestDataByEducationalInstitution(
                response_ as any,
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<ScholarshipDto>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ScholarshipDto>;
        }),
      );
  }

  protected processGetLatestDataByEducationalInstitution(
    response: HttpResponseBase,
  ): Observable<ScholarshipDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ScholarshipDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
export class CreateScholarshipDto implements ICreateScholarshipDto {
  statusId: number;
  caseRequestId: number;
  stateId: number;
  cityId: number;
  educationalInstitutionId: number;
  /// <summary>
  /// تایید استان
  /// </summary>
  isApprovalCity: boolean = false;
  /// <summary>
  /// تایید پرفتورا
  /// </summary>
  isApprovalPerfectura: boolean = false;
  /// <summary>
  /// مراجعه حضوری به کف جهت دریافت ایزه
  /// </summary>
  visitTheKafToReceiveIze: boolean = false;
  /// <summary>
  /// آپلود مدارک در سایت کف جهت دریافت ایزه
  /// </summary>
  uploadDocumentTheKafToReceiveIze: boolean = false;
  /// <summary>
  /// ددلاین سابمیت اپلیکیشن
  /// </summary>
  applicationSubmissionDeadline: string;
  /// <summary>
  /// ددلاین درخواست خوابگاه
  /// </summary>
  dormitoryApplicationDeadline: string;
  /// <summary>
  /// ددلاین آپلود مدارک
  /// </summary>
  uploadingDocumentsDeadline: string;
  /// <summary>
  /// ددلاین آپلود اجاره نامه
  /// </summary>
  leaseUploadDeadline: string;
  /// <summary>
  /// ددلاین تحویل مدارک
  /// </summary>
  documentsDeliveryDeadline: string;
  /// <summary>
  /// ددلاین ثبت نام دانشگاه
  /// </summary>
  universityRegistrationDeadline: string;
  /// <summary>
  /// شرایط اجاره نامه
  /// </summary>
  leaseConditions: string;
  /// <summary>
  /// مدت
  /// </summary>
  period: number;
  /// <summary>
  /// تاریخ شروع
  /// </summary>
  startDate: string;
  /// <summary>
  /// تاریخ پایان
  /// </summary>
  endDate: string;
  /// <summary>
  /// تاریخ انتشار بندو
  /// </summary>
  bandoReleaseDate: string;
  /// <summary>
  /// لینک وب سایت استان
  /// </summary>
  cityWebsiteLink: string;
  /// <summary>
  /// تاریخ انتشار رنکینگ اولیه
  /// </summary>
  initialRankinPublicationDate: string;
  /// <summary>
  /// تاریخ انتشار رنکینگ خوابگاه
  /// </summary>
  dormitoryRankingPublicationDate: string;
  /// <summary>
  /// تاریخ انتشار رنکینگ نهایی
  /// </summary>
  finalRankingPublicationDate: string;
  /// <summary>
  /// شخص تایید کننده
  /// </summary>
  approvingPerson: string;
  /// <summary>
  /// تاریخ ارسال
  /// </summary>
  sendDate: string;
  /// <summary>
  /// شخص تایید کننده در شهر مقصد (پرفتورا و کف)
  /// </summary>
  approvingPersonInDestinationCity: string;
  /// <summary>
  /// تاریخ ارسال به شهر مقصد
  /// </summary>
  deliveryDateToDestinationCity: string;
  /// <summary>
  /// هزینه
  /// </summary>
  cost: number;
  /// <summary>
  /// شیوه پرداخت
  /// </summary>
  paymentMethod: number;
  /// <summary>
  /// تاریخ پرداخت
  /// </summary>
  paymentDate: string;
  /// <summary>
  /// تاریخ تحویل به شخص
  /// </summary>
  deliveryDateToPerson: string;
  /// <summary>
  /// تاریخ تحویل به اداره بورس
  /// </summary>
  deliveryDateToStockExchangeOffice: string;
  /// <summary>
  /// درخواست خوابگاه
  /// </summary>
  accommodationRequest: boolean = false;
  /// <summary>
  /// وضعیت مالی و تاییدات
  /// </summary>
  financeAndApprovalsStatus: boolean = false;
  /// <summary>
  /// وضعیت آپلود مدارک
  /// </summary>
  uploadingDocuments: boolean = false;

  applicationUserAccounts: UserAccountsDto = new UserAccountsDto();
  kafUserAccounts: UserAccountsDto = new UserAccountsDto();
  eSUUserAccounts: UserAccountsDto = new UserAccountsDto();

  constructor(data?: ICreateScholarshipDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.statusId = _data["statusId"];
      this.caseRequestId = _data["caseRequestId"];
      this.stateId = _data["stateId"];
      this.cityId = _data["cityId"];
      this.educationalInstitutionId = _data["educationalInstitutionId"];
      this.isApprovalCity = _data["isApprovalCity"];
      this.isApprovalPerfectura = _data["isApprovalPerfectura"];
      this.visitTheKafToReceiveIze = _data["visitTheKafToReceiveIze"];
      this.uploadDocumentTheKafToReceiveIze =
        _data["uploadDocumentTheKafToReceiveIze"];
      this.applicationSubmissionDeadline =
        _data["applicationSubmissionDeadline"];
      this.dormitoryApplicationDeadline = _data["dormitoryApplicationDeadline"];
      this.uploadingDocumentsDeadline = _data["uploadingDocumentsDeadline"];
      this.leaseUploadDeadline = _data["leaseUploadDeadline"];
      this.documentsDeliveryDeadline = _data["documentsDeliveryDeadline"];
      this.universityRegistrationDeadline =
        _data["universityRegistrationDeadline"];
      this.leaseConditions = _data["leaseConditions"];
      this.period = _data["period"];
      this.startDate = _data["startDate"];
      this.endDate = _data["endDate"];
      this.bandoReleaseDate = _data["bandoReleaseDate"];
      this.cityWebsiteLink = _data["cityWebsiteLink"];
      this.initialRankinPublicationDate = _data["initialRankinPublicationDate"];
      this.dormitoryRankingPublicationDate =
        _data["dormitoryRankingPublicationDate"];
      this.finalRankingPublicationDate = _data["finalRankingPublicationDate"];
      this.approvingPerson = _data["approvingPerson"];
      this.sendDate = _data["sendDate"];
      this.approvingPersonInDestinationCity =
        _data["approvingPersonInDestinationCity"];
      this.deliveryDateToDestinationCity =
        _data["deliveryDateToDestinationCity"];
      this.cost = _data["cost"];
      this.paymentMethod = _data["paymentMethod"];
      this.paymentDate = _data["paymentDate"];
      this.deliveryDateToPerson = _data["deliveryDateToPerson"];
      this.deliveryDateToStockExchangeOffice =
        _data["deliveryDateToStockExchangeOffice"];
      this.accommodationRequest = _data["accommodationRequest"];
      this.financeAndApprovalsStatus = _data["financeAndApprovalsStatus"];
      this.uploadingDocuments = _data["uploadingDocuments"];
      this.applicationUserAccounts = _data["applicationUserAccounts"];
      this.kafUserAccounts = _data["kafUserAccounts"];
      this.eSUUserAccounts = _data["eSUUserAccounts"];
    }
  }

  static fromJS(data: any): CreateScholarshipDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateScholarshipDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["statusId"] = this.statusId;
    data["caseRequestId"] = this.caseRequestId;
    data["stateId"] = this.stateId;
    data["cityId"] = this.cityId;
    data["educationalInstitutionId"] = this.educationalInstitutionId;
    data["isApprovalCity"] = this.isApprovalCity;
    data["isApprovalPerfectura"] = this.isApprovalPerfectura;
    data["visitTheKafToReceiveIze"] = this.visitTheKafToReceiveIze;
    data["uploadDocumentTheKafToReceiveIze"] =
      this.uploadDocumentTheKafToReceiveIze;
    data["applicationSubmissionDeadline"] = this.applicationSubmissionDeadline;
    data["dormitoryApplicationDeadline"] = this.dormitoryApplicationDeadline;
    data["uploadingDocumentsDeadline"] = this.uploadingDocumentsDeadline;
    data["leaseUploadDeadline"] = this.leaseUploadDeadline;
    data["documentsDeliveryDeadline"] = this.documentsDeliveryDeadline;
    data["universityRegistrationDeadline"] =
      this.universityRegistrationDeadline;
    data["leaseConditions"] = this.leaseConditions;
    data["period"] = this.period;
    data["startDate"] = this.startDate;
    data["endDate"] = this.endDate;
    data["bandoReleaseDate"] = this.bandoReleaseDate;
    data["cityWebsiteLink"] = this.cityWebsiteLink;
    data["initialRankinPublicationDate"] = this.initialRankinPublicationDate;
    data["dormitoryRankingPublicationDate"] =
      this.dormitoryRankingPublicationDate;
    data["finalRankingPublicationDate"] = this.finalRankingPublicationDate;
    data["approvingPerson"] = this.approvingPerson;
    data["sendDate"] = this.sendDate;
    data["approvingPersonInDestinationCity"] =
      this.approvingPersonInDestinationCity;
    data["deliveryDateToDestinationCity"] = this.deliveryDateToDestinationCity;
    data["cost"] = this.cost;
    data["paymentMethod"] = this.paymentMethod;
    data["paymentDate"] = this.paymentDate;
    data["deliveryDateToPerson"] = this.deliveryDateToPerson;
    data["deliveryDateToStockExchangeOffice"] =
      this.deliveryDateToStockExchangeOffice;
    data["accommodationRequest"] = this.accommodationRequest;
    data["financeAndApprovalsStatus"] = this.financeAndApprovalsStatus;
    data["uploadingDocuments"] = this.uploadingDocuments;
    data["applicationUserAccounts"] = this.applicationUserAccounts;
    data["kafUserAccounts"] = this.kafUserAccounts;
    data["eSUUserAccounts"] = this.eSUUserAccounts;

    return data;
  }

  clone(): CreateScholarshipDto {
    const json = this.toJSON();
    let result = new CreateScholarshipDto();
    result.init(json);
    return result;
  }
}

export interface ICreateScholarshipDto {
  statusId: number;
  caseRequestId: number;
  stateId: number;
  cityId: number;
  educationalInstitutionId: number;
  isApprovalCity: boolean;
  isApprovalPerfectura: boolean;
  visitTheKafToReceiveIze: boolean;
  uploadDocumentTheKafToReceiveIze: boolean;
  applicationSubmissionDeadline: string;
  dormitoryApplicationDeadline: string;
  uploadingDocumentsDeadline: string;
  leaseUploadDeadline: string;
  documentsDeliveryDeadline: string;
  universityRegistrationDeadline: string;
  leaseConditions: string;
  period: number;
  startDate: string;
  endDate: string;
  bandoReleaseDate: string;
  cityWebsiteLink: string;
  initialRankinPublicationDate: string;
  dormitoryRankingPublicationDate: string;
  finalRankingPublicationDate: string;
  approvingPerson: string;
  sendDate: string;
  approvingPersonInDestinationCity: string;
  deliveryDateToDestinationCity: string;
  cost: number;
  paymentMethod: number;
  paymentDate: string;
  deliveryDateToPerson: string;
  deliveryDateToStockExchangeOffice: string;
  accommodationRequest: boolean;
  financeAndApprovalsStatus: boolean;
  uploadingDocuments: boolean;
  applicationUserAccounts: UserAccountsDto | undefined;
  kafUserAccounts: UserAccountsDto | undefined;
  eSUUserAccounts: UserAccountsDto | undefined;
}

export class ScholarshipDto implements IScholarshipDto {
  fromLatesData: boolean = false;
  id: number;
  statusId: number;
  caseRequestId: number;
  stateId: number;
  cityId: number;
  educationalInstitutionId: number;
  /// <summary>
  /// تایید استان
  /// </summary>
  isApprovalCity: boolean = false;
  /// <summary>
  /// تایید پرفتورا
  /// </summary>
  isApprovalPerfectura: boolean = false;
  /// <summary>
  /// مراجعه حضوری به کف جهت دریافت ایزه
  /// </summary>
  visitTheKafToReceiveIze: boolean = false;
  /// <summary>
  /// آپلود مدارک در سایت کف جهت دریافت ایزه
  /// </summary>
  uploadDocumentTheKafToReceiveIze: boolean = false;
  /// <summary>
  /// ددلاین سابمیت اپلیکیشن
  /// </summary>
  applicationSubmissionDeadline: string;
  /// <summary>
  /// ددلاین درخواست خوابگاه
  /// </summary>
  dormitoryApplicationDeadline: string;
  /// <summary>
  /// ددلاین آپلود مدارک
  /// </summary>
  uploadingDocumentsDeadline: string;
  /// <summary>
  /// ددلاین آپلود اجاره نامه
  /// </summary>
  leaseUploadDeadline: string;
  /// <summary>
  /// ددلاین تحویل مدارک
  /// </summary>
  documentsDeliveryDeadline: string;
  /// <summary>
  /// ددلاین ثبت نام دانشگاه
  /// </summary>
  universityRegistrationDeadline: string;
  /// <summary>
  /// شرایط اجاره نامه
  /// </summary>
  leaseConditions: string;
  /// <summary>
  /// مدت
  /// </summary>
  period: number;
  /// <summary>
  /// تاریخ شروع
  /// </summary>
  startDate: string;
  /// <summary>
  /// تاریخ پایان
  /// </summary>
  endDate: string;
  /// <summary>
  /// تاریخ انتشار بندو
  /// </summary>
  bandoReleaseDate: string;
  /// <summary>
  /// لینک وب سایت استان
  /// </summary>
  cityWebsiteLink: string;
  /// <summary>
  /// تاریخ انتشار رنکینگ اولیه
  /// </summary>
  initialRankinPublicationDate: string;
  /// <summary>
  /// تاریخ انتشار رنکینگ خوابگاه
  /// </summary>
  dormitoryRankingPublicationDate: string;
  /// <summary>
  /// تاریخ انتشار رنکینگ نهایی
  /// </summary>
  finalRankingPublicationDate: string;
  /// <summary>
  /// شخص تایید کننده
  /// </summary>
  approvingPerson: string;
  /// <summary>
  /// تاریخ ارسال
  /// </summary>
  sendDate: string;
  /// <summary>
  /// شخص تایید کننده در شهر مقصد (پرفتورا و کف)
  /// </summary>
  approvingPersonInDestinationCity: string;
  /// <summary>
  /// تاریخ ارسال به شهر مقصد
  /// </summary>
  deliveryDateToDestinationCity: string;
  /// <summary>
  /// هزینه
  /// </summary>
  cost: number;
  /// <summary>
  /// شیوه پرداخت
  /// </summary>
  paymentMethod: number;
  /// <summary>
  /// تاریخ پرداخت
  /// </summary>
  paymentDate: string;
  /// <summary>
  /// تاریخ تحویل به شخص
  /// </summary>
  deliveryDateToPerson: string;
  /// <summary>
  /// تاریخ تحویل به اداره بورس
  /// </summary>
  deliveryDateToStockExchangeOffice: string;
  /// <summary>
  /// درخواست خوابگاه
  /// </summary>
  accommodationRequest: boolean = false;
  /// <summary>
  /// وضعیت مالی و تاییدات
  /// </summary>
  financeAndApprovalsStatus: boolean = false;
  /// <summary>
  /// وضعیت آپلود مدارک
  /// </summary>
  uploadingDocuments: boolean = false;
  applicationUserAccounts: UserAccountsDto = new UserAccountsDto();
  kafUserAccounts: UserAccountsDto = new UserAccountsDto();
  eSUUserAccounts: UserAccountsDto = new UserAccountsDto();

  constructor(data?: IScholarshipDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fromLatesData = _data["fromLatesData"];
      this.id = _data["id"];
      this.statusId = _data["statusId"];
      this.caseRequestId = _data["caseRequestId"];
      this.stateId = _data["stateId"];
      this.cityId = _data["cityId"];
      this.educationalInstitutionId = _data["educationalInstitutionId"];
      this.isApprovalCity = _data["isApprovalCity"];
      this.isApprovalPerfectura = _data["isApprovalPerfectura"];
      this.visitTheKafToReceiveIze = _data["visitTheKafToReceiveIze"];
      this.uploadDocumentTheKafToReceiveIze =
        _data["uploadDocumentTheKafToReceiveIze"];
      this.applicationSubmissionDeadline =
        _data["applicationSubmissionDeadline"];
      this.dormitoryApplicationDeadline = _data["dormitoryApplicationDeadline"];
      this.uploadingDocumentsDeadline = _data["uploadingDocumentsDeadline"];
      this.leaseUploadDeadline = _data["leaseUploadDeadline"];
      this.documentsDeliveryDeadline = _data["documentsDeliveryDeadline"];
      this.universityRegistrationDeadline =
        _data["universityRegistrationDeadline"];
      this.leaseConditions = _data["leaseConditions"];
      this.period = _data["period"];
      this.startDate = _data["startDate"];
      this.endDate = _data["endDate"];
      this.bandoReleaseDate = _data["bandoReleaseDate"];
      this.cityWebsiteLink = _data["cityWebsiteLink"];
      this.initialRankinPublicationDate = _data["initialRankinPublicationDate"];
      this.dormitoryRankingPublicationDate =
        _data["dormitoryRankingPublicationDate"];
      this.finalRankingPublicationDate = _data["finalRankingPublicationDate"];
      this.approvingPerson = _data["approvingPerson"];
      this.sendDate = _data["sendDate"];
      this.approvingPersonInDestinationCity =
        _data["approvingPersonInDestinationCity"];
      this.deliveryDateToDestinationCity =
        _data["deliveryDateToDestinationCity"];
      this.cost = _data["cost"];
      this.paymentMethod = _data["paymentMethod"];
      this.paymentDate = _data["paymentDate"];
      this.deliveryDateToPerson = _data["deliveryDateToPerson"];
      this.deliveryDateToStockExchangeOffice =
        _data["deliveryDateToStockExchangeOffice"];
      this.accommodationRequest = _data["accommodationRequest"];
      this.financeAndApprovalsStatus = _data["financeAndApprovalsStatus"];
      this.uploadingDocuments = _data["uploadingDocuments"];
      this.applicationUserAccounts = _data["applicationUserAccounts"];
      this.kafUserAccounts = _data["kafUserAccounts"];
      this.eSUUserAccounts = _data["eSUUserAccounts"];
    }
  }

  static fromJS(data: any): ScholarshipDto {
    data = typeof data === "object" ? data : {};
    let result = new ScholarshipDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fromLatesData"] = this.fromLatesData;
    data["id"] = this.id;
    data["statusId"] = this.statusId;
    data["caseRequestId"] = this.caseRequestId;
    data["stateId"] = this.stateId;
    data["cityId"] = this.cityId;
    data["educationalInstitutionId"] = this.educationalInstitutionId;
    data["isApprovalCity"] = this.isApprovalCity;
    data["isApprovalPerfectura"] = this.isApprovalPerfectura;
    data["visitTheKafToReceiveIze"] = this.visitTheKafToReceiveIze;
    data["uploadDocumentTheKafToReceiveIze"] =
      this.uploadDocumentTheKafToReceiveIze;
    data["applicationSubmissionDeadline"] = this.applicationSubmissionDeadline;
    data["dormitoryApplicationDeadline"] = this.dormitoryApplicationDeadline;
    data["uploadingDocumentsDeadline"] = this.uploadingDocumentsDeadline;
    data["leaseUploadDeadline"] = this.leaseUploadDeadline;
    data["documentsDeliveryDeadline"] = this.documentsDeliveryDeadline;
    data["universityRegistrationDeadline"] =
      this.universityRegistrationDeadline;
    data["leaseConditions"] = this.leaseConditions;
    data["period"] = this.period;
    data["startDate"] = this.startDate;
    data["endDate"] = this.endDate;
    data["bandoReleaseDate"] = this.bandoReleaseDate;
    data["cityWebsiteLink"] = this.cityWebsiteLink;
    data["initialRankinPublicationDate"] = this.initialRankinPublicationDate;
    data["dormitoryRankingPublicationDate"] =
      this.dormitoryRankingPublicationDate;
    data["finalRankingPublicationDate"] = this.finalRankingPublicationDate;
    data["approvingPerson"] = this.approvingPerson;
    data["sendDate"] = this.sendDate;
    data["approvingPersonInDestinationCity"] =
      this.approvingPersonInDestinationCity;
    data["deliveryDateToDestinationCity"] = this.deliveryDateToDestinationCity;
    data["cost"] = this.cost;
    data["paymentMethod"] = this.paymentMethod;
    data["paymentDate"] = this.paymentDate;
    data["deliveryDateToPerson"] = this.deliveryDateToPerson;
    data["deliveryDateToStockExchangeOffice"] =
      this.deliveryDateToStockExchangeOffice;
    data["accommodationRequest"] = this.accommodationRequest;
    data["financeAndApprovalsStatus"] = this.financeAndApprovalsStatus;
    data["uploadingDocuments"] = this.uploadingDocuments;
    data["applicationUserAccounts"] = this.applicationUserAccounts;
    data["kafUserAccounts"] = this.kafUserAccounts;
    data["eSUUserAccounts"] = this.eSUUserAccounts;

    return data;
  }

  clone(): ScholarshipDto {
    const json = this.toJSON();
    let result = new ScholarshipDto();
    result.init(json);
    return result;
  }
}

export interface IScholarshipDto {
  fromLatesData: boolean;
  id: number;
  statusId: number;
  caseRequestId: number;
  stateId: number;
  cityId: number;
  educationalInstitutionId: number;
  isApprovalCity: boolean;
  isApprovalPerfectura: boolean;
  visitTheKafToReceiveIze: boolean;
  uploadDocumentTheKafToReceiveIze: boolean;
  applicationSubmissionDeadline: string;
  dormitoryApplicationDeadline: string;
  uploadingDocumentsDeadline: string;
  leaseUploadDeadline: string;
  documentsDeliveryDeadline: string;
  universityRegistrationDeadline: string;
  leaseConditions: string;
  period: number;
  startDate: string;
  endDate: string;
  bandoReleaseDate: string;
  cityWebsiteLink: string;
  initialRankinPublicationDate: string;
  dormitoryRankingPublicationDate: string;
  finalRankingPublicationDate: string;
  approvingPerson: string;
  sendDate: string;
  approvingPersonInDestinationCity: string;
  deliveryDateToDestinationCity: string;
  cost: number;
  paymentMethod: number;
  paymentDate: string;
  deliveryDateToPerson: string;
  deliveryDateToStockExchangeOffice: string;
  accommodationRequest: boolean;
  financeAndApprovalsStatus: boolean;
  uploadingDocuments: boolean;
  applicationUserAccounts: UserAccountsDto | undefined;
  kafUserAccounts: UserAccountsDto | undefined;
  eSUUserAccounts: UserAccountsDto | undefined;
}
export class ScholarshipDtoPagedResultDto implements IScholarshipDtoPagedResultDto {
  items: ScholarshipDto[] | undefined;
  totalCount: number;

  constructor(data?: IScholarshipDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ScholarshipDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): ScholarshipDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ScholarshipDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): ScholarshipDtoPagedResultDto {
    const json = this.toJSON();
    let result = new ScholarshipDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IScholarshipDtoPagedResultDto {
  items: ScholarshipDto[] | undefined;
  totalCount: number;
}
//#endregion

export class UserAccountsDto implements IUserAccountsDto {
  link: string;
  userName: string;
  password: string;

  constructor(data?: IUserAccountsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.link = _data["link"];
      this.userName = _data["userName"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): UserAccountsDto {
    data = typeof data === "object" ? data : {};
    let result = new UserAccountsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["link"] = this.link;
    data["userName"] = this.userName;
    data["password"] = this.password;

    return data;
  }

  clone(): UserAccountsDto {
    const json = this.toJSON();
    let result = new UserAccountsDto();
    result.init(json);
    return result;
  }
}
export interface IUserAccountsDto {
  link: string;
  userName: string;
  password: string;
}
export class SelectionorganizationItems implements ISelectionorganizationItems {
  parentCode: number | string;
  parentName: string | number;
  Code: number | string;
  Name: string;
  CountryId: number;
  EducationalInstitutionId: number;
  CountryIds: number[] | undefined;
  EducationalInstitutions: EducationalInstitutionDto[];

  constructor(data?: ISelectionorganizationItems) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentCode = _data["parentCode"];
      this.Code = _data["Code"];
      this.CountryId = _data["CountryId"];
      this.EducationalInstitutionId = _data["EducationalInstitutionId"];

      if (Array.isArray(_data["EducationalInstitutions"])) {
        this.EducationalInstitutions = [] as any;
        for (let item of _data["EducationalInstitutions"])
          this.EducationalInstitutions.push(
            EducationalInstitutionDto.fromJS(item),
          );
      }
      if (Array.isArray(_data["CountryIds"])) {
        this.CountryIds = [] as any;
        for (let item of _data["CountryIds"]) this.CountryIds.push(item);
      }
    }
  }

  static fromJS(data: any): SelectionorganizationItems {
    data = typeof data === "object" ? data : {};
    let result = new SelectionorganizationItems();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.Code;
    data["parentCode"] = this.parentCode;
    data["CountryId"] = this.CountryId;
    data["EducationalInstitutionId"] = this.EducationalInstitutionId;
    data["parentCode"] = this.parentCode;
    if (Array.isArray(this.CountryIds)) {
      data["countryIds"] = [];
      for (let item of this.CountryIds) data["countryIds"].push(item);
    }
    if (Array.isArray(this.EducationalInstitutions)) {
      data["educationalInstitutions"] = [];
      for (let item of this.EducationalInstitutions)
        data["educationalInstitutions"].push(item.toJSON());
    }

    return data;
  }

  clone(): SelectionorganizationItems {
    const json = this.toJSON();
    let result = new SelectionorganizationItems();
    result.init(json);
    return result;
  }
}

export interface ISelectionorganizationItems {
  parentCode: number | string;
  parentName: string | number;
  Code: number | string;
  Name: string;
  CountryId: number;
  EducationalInstitutionId: number;
  EducationalInstitutions: EducationalInstitutionDto[] | undefined;
  CountryIds: number[] | undefined;
}
